

  



var _ajaxloadpresspage=2;
var _canayaxload=true;

var _returnscount=0;
var _returnsamount=0;
var iframe_vimeo = $('#vimeo-player')[0];
var player_vimeo = $f(iframe_vimeo);

var iframe_vimeo2 = $('#vimeo-player2')[0];
var player_vimeo2 = $f(iframe_vimeo2);

var animatetime = 500;
var __shop_social=[];
var _ajaxloadingpageid=2;
var _productslistshow=1;
var _loadingcollectionproducts=true;
var show_more_height;
var _wished_products_handles=[];
var block_height_resp;
var _shop_social_corusel;
var _curr_lat=0;
var _curr_lng=0;
var _origin_url='';
var _first_load=true;

$(document).ready(function() {

  $('body').on('click', function(event) {

    const header = document.querySelector('.header');
    const headerTop = document.querySelector('.header_top');
    const top_banner = document.querySelector('.top_banner');

    // if (window.innerWidth >= 768) {
    
       if (!$(event.target).closest('.custom_filter_menu, .custom_filter_toggle').length) {
          console.log("Clicked outside of dropdown and toggle");

          $('.custom_filter_menu').slideUp(200).attr("aria-hidden", "true");
          $('.custom_filter_toggle').attr("aria-expanded", "false");
       }
      
       if (!$(event.target).closest('filters_neww, .active ').length) {
     
         const filtersElement = document.querySelector('.filters_neww');
  
        if (filtersElement && filtersElement.classList.contains('active')) { 
          // Remove the 'active' class
          filtersElement.classList.remove('active');
          
          // Hide the filters_neww element itself
          filtersElement.style.display = 'none';
          
          // Also hide the filters_neww_bg element
          const bgElement = document.querySelector('.filters_neww_bg');
          if (bgElement) {
            bgElement.style.display = 'none';

            if (window.innerWidth <= 1100) {
              header.style.zIndex = '21';
              headerTop.style.zIndex = '21';
              top_banner.style.zIndex = '21';
              document.body.classList.remove('no-scroll');
            }
          }
        }
       }
      
    // }
    
  });
  
    $("#news_letter_submit").on('click', function (event) {
    //alert('sfsdfdsa');
    event.preventDefault(); // Prevents the default action (e.g., form submission)
    // Your code here
});
  
 	//check_cart_page();
  
  
  	if($('.one_piece_container').length){
      $('html').css('overflow-x', 'hidden');
    }
  
  
  
  
  
   $('#ttl_email').keypress(function( e ) {
        if(e.which === 32) 
            return false;
    });
  
  
  	$(".turtle_form input").keyup(function(){
      	$(this).removeClass('ttl_active');
    });
  
  	$('body').on('click', '.turtle_form.opened .turtle_close', function(e){
      	e.preventDefault();
          $('.turtle_form').removeClass('opened');
          $('.retailer_drop').removeClass('opened').html('');
      	  $('#ttl_retailer').val('').css('pointer-events', 'all').removeClass('ttl_active');
        return false;
  	});
  
  	$('body').on('click', '.turtle_rtl_li', function(e) {
      	$('.retailer_drop').removeClass('opened').html('');
      	$('#ttl_retailer').val(_retailers_list[parseInt($(this).data('id'))]).css('pointer-events', 'none').addClass('ttl_active');
      	$('.turtle_form').addClass('opened');
	});
  
    $(".turtle_drop").on('click', function(){
      var _data = 'jew';
      if(_data.length>2){
            var retailer_drop = SearchRetailer(_data);
            $('.retailer_drop').html('');
            if(retailer_drop.length){ 
              $('.retailer_drop').addClass('opened').append("<li class='turtle_rtl_top'>TOP SUGGESTIONS:</li>");         
              for(var _a=0; _a<retailer_drop.length; _a++){
                  $('.turtle_form').addClass('opened');
                  $('.retailer_drop').addClass('opened').append("<li class='turtle_rtl_li' data-id='"+retailer_drop[_a]['id']+"'>"+retailer_drop[_a]['title']+"</li>");
              }
            } else{
              	$('.turtle_form').addClass('opened');
            	$('.retailer_drop').addClass('opened').append("<li>No retailer found.</li>"); 
            }
      }
    });
  
  
  	$("#ttl_retailer").keyup(function() {
      var _data = $(this).val();
      if(_data.length>2){
            var retailer_drop = SearchRetailer(_data);
            $('.retailer_drop').html('');
            if(retailer_drop.length){
              for(var _a=0; _a<retailer_drop.length; _a++){ 
                  $('.retailer_drop').addClass('opened').append("<li class='turtle_rtl_li' data-id='"+retailer_drop[_a]['id']+"'>"+retailer_drop[_a]['title']+"</li>");
              }
            }  else{
              	$('.retailer_drop').addClass('opened').append("<li>No retailer found.</li>"); 
            }
      }
    });
  
  
  	$('body').on('click', '.turtlesubscribe', function(e){
       if($('.turtle_form').length>0){

            $.validate({
              form: '.turtle_form',
              scrollToTopOnError: false,
              onSuccess: function(){
                  if($('#ttl_retailer').val().trim()!="" 
                     && $('#ttl_retailer').hasClass('ttl_active') 
                     && $('#ttl_name').val().trim().length>0  
                     && $('#ttl_lname').val().trim().length>0 
                     && $('#ttl_terms').prop('checked')  
                     && $('#ttl_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i)){
                   
                   $('.turtlesubscribe').hide();
                   $('.schedulrequestform_loading').show();
                    
                   var formData = new FormData();

                   formData.append('form',"turtlecontest");
                   formData.append('ttl_retailer',$('#ttl_retailer').val().trim());
                   formData.append('ttl_name',$('#ttl_name').val().trim());
                   formData.append('ttl_lname',$('#ttl_lname').val().trim());
                   formData.append('ttl_email',$('#ttl_email').val().trim());
                   formData.append('ttl_phone',$('#ttl_phone').val().trim());
                   formData.append('ttl_marketing',($("#ttl_marketing").prop('checked') ? 'Y' : 'N'));
                    	
                   var xhr = new XMLHttpRequest();
                   xhr.open('post', 'https://seiko-apps.com/api/postrequest', true);

                   xhr.onerror = function(e) {
                   };
                   xhr.onload = function(date) {		
                     $('.turtle_form_block').addClass('hideform');
                  	 $('.turtle_success').addClass('showed');
                     $('.turtle_bg').css('min-height', (window.innerHeight-$('.header').height()));
                   	 $('.schedulrequestform_loading').hide();
                   };
                   xhr.send(formData);
                 }
                 return false;
              }
          });
       }
    });
  
 
  
  setTimeout(function(){
    if($('#locksmith-content')[0]){
      $('.loader_start').css({'visibility':'hidden','opacity':'0'}); 
    }
  }, 1000);
  
  
  
  
  	if($('.page-product').length){
      Move_OutofStoke_to_bottom();
    }
  
  
    if($('.load_image_src').length){
      loadImageSrc($('.load_image_src'));
    }
  
    $('.sign_up_open').on('click', function(e){
      e.preventDefault(); 
      $('.rowing_signup_form').show();
      $(this).hide();
      $('.rowing_features_text').addClass('open');
      $('.rowing_bottom_image').addClass('open');
     

      if(window.innerWidth<768){
        setTimeout(function(){
          $('.rowing_bottom_image .flickity-viewport').stop().animate({"height": 910}, 500);
        }, 10);
      }
    });
  
    $('body').on('click', '.rowing_signup', function(e){
	 if($('.rowing_signup_form').length>0){
        
        $.validate({
          form: '.rowing_signup_form',
          scrollToTopOnError: false,
          onSuccess: function(){
            
              var formData = new FormData();

              formData.append('form',"rowingblazers");
              formData.append('fname',$('#row_fname').val().trim());
              formData.append('lname',$('#row_lname').val().trim());
              formData.append('email',$('#row_email').val().trim());
              formData.append('phone',$('#row_phone').val().trim());
              formData.append('subscribe',($("#row_subscribe").prop('checked') ? 'Y' : 'N'));

              //console.log($("#row_subscribe").prop('checked'));
            
              var xhr = new XMLHttpRequest();
              xhr.open('post', 'https://seiko-apps.com/api/postrequest', true);

              xhr.onerror = function(e) {
              };
              xhr.onload = function(date) {		
                $('.rowing_features_text').removeClass('show').removeClass('open');

                setTimeout(function(){
                  $('.rowing_signup_form_thanks').addClass('open');
                }, 10);


                if(window.innerWidth<768){
                  $('.rowing_bottom_image').addClass('openthanks');
                }  
              };
              xhr.send(formData);
             
              return false;
        	}
        });
      }
    });
  
  	$('.rowing_grid .press_img').on('click keypress', function(e){
    	e.preventDefault();
      
      	
    	
    	$('.rowing_popup .info_popup_inner').html('<img src="'+$(this).data('image')+'" alt="" title="" />');
		
		$(document).find('.rowing_popup .info_popup_inner').find('img').css("max-height", window.innerHeight-150);
        setTimeout(function(){
        	$(document).find('.rowing_popup .popup_container').css("max-width", $('.rowing_popup .info_popup_inner').find('img').width()+60);
        }, 100);

		$('.rowing_popup .info_popup').addClass('opened').attr('aria-hidden', false);				
		$('body').addClass('y_hidden');			
		$('.loader_inner').css({'visibility':'hidden','opacity':'0'});
		$('.rowing_popup .popup_container').addClass('opened');
      	$(this).attr('aria-expanded', true);
    });

    if($('.rowing_blocks_slider').length){
      setTimeout(function(){
        $('.rowing_blocks_slider').each(function(){
          
          var __this = $(this);

          var hasMultipleCells = __this.find('.rowing_blocks_slider_cell').length > 1;
          
          if(__this.hasClass('featured_slider')){var timesl = false;}
          else if(__this.parents('.rowing_blocks_container').hasClass('rowing_bottom_image')){var timesl = false;}
          else{var timesl = false;}

          
          __this.flickity({
            pageDots: (hasMultipleCells ? true : false),
            wrapAround: (hasMultipleCells ? true : false),
            draggable: (hasMultipleCells ? true : false),
            pauseAutoPlayOnHover: false,
            autoPlay: false
          });


          if(window.innerWidth>640){
            console.log('111');
            if($('.rowing_blocks_slider_text.single_text').length){
              $('.rowing_blocks_slider_text.single_text').height($('.rowing_fake_container').height());
            }
            
            if($('.rowing_blocks_slider .flickity-page-dots').length){
			
              if(!__this.parents('.rowing_blocks_slider_container').hasClass('rowing_fake_container')){
                if(window.innerWidth>1440){
                  var offset_story = 90;
                } else{
                  var offset_story = 60;
                }

                var story_off = __this.find('.rowing_blocks_slider_text').position().top+__this.find('.rowing_blocks_slider_text').height();

                __this.find('.flickity-page-dots').css({
                  'left': __this.find('.rowing_blocks_slider_text_block').offset().left-__this.offset().left-12, 
                  'top': (story_off+($('.rowing_blocks_slider_cell').height()-story_off-offset_story)/2)
                });
              }
              else{
                
                if(window.innerWidth>1440){
                  var offset_story = 90;
                } else{
                  var offset_story = 60;
                }

                var story_off = $('.rowing_blocks_slider_text.single_text .rowing_blocks_slider_text_block').position().top+$('.rowing_blocks_slider_text.single_text .rowing_blocks_slider_text_block').height();

              	__this.find('.flickity-page-dots').css({
                  'left': $('.rowing_blocks_slider_text.single_text .rowing_blocks_slider_text_block').offset().left-__this.offset().left-12, 
                  'top': (story_off+($('.rowing_blocks_slider_cell').height()-story_off-offset_story)/2)
                });
              }
            }
          }
          else{
            /*setTimeout(function(){
              $('.featured_slider.rowing_blocks_slider').find('.flickity-page-dots').css({ 
                'top': 280//($('.featured_slider.rowing_blocks_slider').find('.rowing_blocks_slider_image_cont').height()+10)
              });
            }, 4500)*/
          }

        });
      }, 200);
      $('.rowing_blocks_slider .flickity-page-dots .dot').attr('tabindex', 0);

      $('body').on('keypress', '.rowing_blocks_slider .flickity-page-dots .dot', function (e) {
        var key = e.which;
        if(key == 13) {
          var index = $(this).index();
          $gallery.flickity('select', index-1);
        }
      });
    }


    if($('.press_grid').length){
        setTimeout(function(){
          $('.press_grid').masonry({
              itemSelector: '.grid-item',
              columnWidth: '.grid-sizer',
              percentPosition: true
          });
         }, 400);
      }
  
  
  	if($('#homebestsellers')[0]){
       LoadHomeBestSellers();
    }
  
  
  
  
 	
  
  
  
  
  	if($('.corpgifts21_slider').length){
		var $corpgifts21_slider = $('.corpgifts21_slider.carousel').flickity({
			bgLazyLoad: true,
			wrapAround: true,
          	autoPlay: 5000
		});
      
      	$corpgifts21_slider.on( 'dragStart.flickity', function( event, pointer ) {
            document.ontouchmove = function (e) {
                e.preventDefault();
            }
        });
        $corpgifts21_slider.on( 'dragEnd.flickity', function( event, pointer ) {
            document.ontouchmove = function (e) {
                return true;
            }
        });
	}
  
  
  
  	_origin_url=window.location.href.split('#')[0];
  
   if($('.promo-header').length){
        var promoticker = $(".promo-header");
        var t = $(".promo-header").find("li");
        promoticker.find("li:first-child").addClass("is-promo-visible"),
          t.length >= 2 && $(".promo-header").find("li:last-child").addClass("no-promo-visible"),
          (promoTickerTimer = setInterval(i, 5000)),
          $(window).on("orientationchange", function () {});
      
      function i() {
        var t = promoticker.find("li").length;
        // if (!(t < 2)) {
        //   var e = promoticker.find(".is-promo-visible").index();
        //   (e = e === t - 1 ? 0 : e + 1),
        //     $(".promo-header").find("li").removeClass("is-promo-visible").addClass("no-promo-visible"),
        //     $(".promo-header").find("li").eq(e).removeClass("no-promo-visible").addClass("is-promo-visible");
        // }
      }
      	
    }
  
   if($('#video_6').length){
          var myPlayer6 = videojs("video_6", {"controls": true, "autoplay": false, "muted": false}, function(){
              var player6 = this;
              player6.on('ended', function() {	
                this.play();
              }).on('seeking', function (e) {												
              }).on('play', function (e) {						
              }).on('pause', function(e) {												
              });
          });
      
  
          $('.scd_video').on('click keypress', function(){
            if(!$('.scd_video .video-js.vjs-default-skin .vjs-big-play-button').is(':visible')){
              $('.scd_video .video-js.vjs-default-skin .vjs-big-play-button').show();
              myPlayer6.pause();
            }
            else{
              $('.scd_video .video-js.vjs-default-skin .vjs-big-play-button').hide();
              myPlayer6.play();
            }
          });

          if(device.mobile()){
            var touchmoved6;
            $('#video_6_html5_api').on('touchend', function(e){
              if(touchmoved6 != true){
                if (myPlayer6.paused()) {
                  $('.scd_video .video-js.vjs-default-skin .vjs-big-play-button').hide();
              	  myPlayer6.play();
                }
                else {
                  $('.scd_video .video-js.vjs-default-skin .vjs-big-play-button').show();
              	  myPlayer6.pause();
                }
              }
            }).on('touchmove', function(e){
              touchmoved6 = true;
            }).on('touchstart', function(){	
              touchmoved6 = false;
            });
          }
      }
    
   $('.find_a_store').on('click', function(e){
        if(window.innerWidth > 640){
          e.preventDefault();
          $(".l_map_res_list").empty();
          $('.store_popup_block h2 span').show();
          $('.find_a_store_opened').stop().animate({"height": 200}, 400);
          $(this).addClass('active');
        }
        else{
          window.location.href = '/pages/store-locator';
        }
    });
     $('.findstore.popup_close').on('click', function(){
        $('.find_a_store_opened').stop().animate({"height": 0}, 400);
        $(this).removeClass('active');
    });

     $('.loc_fixed').on('click', function(){
    	 $(".l_map_res_list").empty();
    	L_GeoIP_popup();
  });
  
     $('#praddress_incollection').keypress(function (e) {
	  if (e.which == 13) {
		///searchLocations(); 
	  }
	});		

  	 let debounceTimeout;
const RateLimiter = (function () {
    let lastExecutionTime = 0;
    const delay = 500; // 2 requests per second = 500ms delay between requests

    return async function (callback) {
        const now = Date.now();
        const timeSinceLastExecution = now - lastExecutionTime;

        if (timeSinceLastExecution < delay) {
            await new Promise(resolve => setTimeout(resolve, delay - timeSinceLastExecution));
        }

        lastExecutionTime = Date.now();
        return callback();
    };
})();

$("#praddress_incollection").keyup(function () {
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(async () => {
        let _data = $(this).val();

        if (_data.length > 1) {
            if (_data.length > 4) {
                // If it's a ZIP (only digits)
                if (/^\d+$/.test(_data)) {
                    try {
                        const response = await fetch(`http://api.zippopotam.us/us/${_data}`);
                        if (!response.ok) throw new Error('ZIP not found');

                        const json = await response.json();
                        const place = json.places[0];
                        const cityState = `${place['place name']}, ${place['state']}`;
                        console.log("City and State:", cityState);
                        _data = cityState; //  override _data
                    } catch (error) {
                        console.error("Error fetching ZIP info:", error.message);
                        // Still proceed with original _data (numeric ZIP)
                    }
                }
            }

            // Now _data is either updated (e.g. "Austin, Texas") or unchanged (fallback ZIP)
            RateLimiter(() => PostRec(
                'https://geocode.maps.co/search?q=' + encodeURIComponent(_data) + '&format=json&api_key=676595b7f0bd0872036171tno88a01f',
                _data,
                function (_err, ___data) {
                    if (!_err) {
                        $('.store_form').addClass('opened');
                        var addresses_drop = (___data ? get_all_addresses_popup(___data) : []);
                        $('.addresses_drop').html('');

                        console.log("Address drop: " + addresses_drop.length);

                        if (addresses_drop.length > 0) {
                            for (var _a = 0; _a < addresses_drop.length; _a++) {
                                $('.addresses_drop').addClass('opened').append(
                                    "<li class='l_drop_li_cs' data-id='" + addresses_drop[_a]['id'] + "'  " +
                                    "data-name='" + addresses_drop[_a]['title'].trim() + "' " +
                                    "data-address='" + addresses_drop[_a]['title'].trim() + "' " +
                                    "data-lat='" + addresses_drop[_a]['lat'] + "' data-lng='" + addresses_drop[_a]['lon'] + "'>" +
                                    addresses_drop[_a]['title'] + "</li>"
                                );
                            }
                        } else {
                            // Address not found
                        }
                    } else {
                        console.error("Error fetching geocode data", _err);
                    }
                }
            ));
        }
    }, 300); // Debounce wait time
});

  
  
     $('body').on('click', '.store_form.opened .form_block button.close_search', function(e){
          e.preventDefault();
          $('.store_form').removeClass('opened');
          $('.addresses_drop').removeClass('opened').html('');
        return false;
      });


  $("#praddress_incollection").on('keyup', function () {
    const selectedValue = $('input[name="search_type"]:checked').val();
    var _data = $("#praddress_incollection").val();
    
    if (_data.length > 2) {
      if (selectedValue === 'name') {                    
        $('.store_form').addClass('opened');                    
        searchLocationsNear("", "", _data);                
      }
    }
  });

  function clearLocations() {
	$(".l_map_res_list").empty();
  }

  var _collection_icons=["https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Seiko5_Black.png?v=1661411997","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/pressage_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/prospex_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215"];

  function searchLocationsNear(lat, lng, name, callbackFnk, onlyMap = false) {  
    
  	LoaderShow();
    $(".list_loader_popup").show();
	clearLocations();
	markers = []; 
    // var searchUrl = 'https://apps-jsa.com/seiko-staging-app/public/api/postrequest';  
    var searchUrl = 'https://seiko-apps.com/public/api/postrequest';  
	var _data={};
  
    _data["storeid"]  = lng;
    lat = 0;
	lng = 0;
    _data["name"]  = name;

   $('.collections_filter_s li').removeClass('active');
  
   _curr_lat=lat;
   _curr_lng=lng;
	
	PostRec(searchUrl, _data, function(_err, __data){

   	  if (__data.stores.length > 0) {
   	    var ___data = __data['stores'];
		_allstores_list = ___data;
          
   	    if(___data.length>0){
		
          $('.l_map_wrap_right').css('opacity', '1');              
               	  
          var _all_strs=[];
                
          for (var i = 0; i < ___data.length; i++) {                    
            var id 			= ___data[i]._id;                     
            var store_name 	= ___data[i].data.name;                    
            var phone 		= ___data[i].data.phone;                   
            var site 		= ___data[i].data.web;                   
            var address 	= ___data[i].data.address;                   
            var city_state 	= _allstores_list[i].data.city_state;                   
            var latl 		= ___data[i].position[1];                   
            var lngl 		= ___data[i].position[0];                    
            var distance 	= getDistance(lat, lng, latl, lngl).toFixed(1);                    
            var _collection =GetCollectionIcons(___data[i].collections);
                  
            _all_strs.push({id:id, store_name:store_name,  phone:phone, address:address, city_state:city_state, latl:latl, lngl:lngl, distance:distance, i:i, collection:_collection, site:site});
            _all_strs.sort(SortStores);
                
          } 

          clearLocations();
          for (var i = 0; i < Math.min(3, _all_strs.length); i++) {
            console.log('_all_strs', _all_strs);
             const storee = _all_strs[i] || {};
              createOption_popup_name(
                storee.id ?? "",
                storee.store_name ?? "",
                storee.address ?? "",
                storee.latl ?? "",
                storee.lngl ?? "",
                storee.distance ?? "",
                i
              );
          }

          $(".l_map_res_list").append(
            '<a class="view_more_s" href="/pages/store-locator#' +
              _all_strs[0].id +
              "|" +
               _all_strs[0].latl +
              "|" +
              _all_strs[0].lngl +
              '">View all results</a>'
          );

          var ul_height = $(".find_a_store_opened .l_map_res_list").height();
          $(".find_a_store_opened")
            .stop()
            .animate({ height: ul_height + 245 }, 400);
          $(".find_a_store_opened .l_map_wrap_left_scrl")
            .stop()
            .animate({ height: ul_height + 50 }, 400);
        }            
        else{                
          $('.l_map_wrap_right').css('opacity', '.4');      
          $(".list_loader_popup").hide();
          // LoaderHide();             
        }			
      }	      
      else {
        $(".list_loader_popup").hide();
        clearLocations();
        PopuperShow("Please search another input address to search for locations.");
      }     
    });
  }

function createOption_popup_name(id, store_name, address, lat, lng, distance, i) {
  PopuperClose();
  $(".list_loader_popup").hide();
  $(".store_popup_block h2 span").hide();
  $(".l_map_res_list").append(
    "<li class='l_map_res_list_i' tabindex='0' data-id='" +
      id +
      "'  " +
      "data-name='" +
      store_name.trim() +
      "' " +
      "data-address='" +
      address.trim() +
      "' " +
      "data-lat='" +
      lat +
      "' data-lng='" +
      lng +
      "'> " +
      "<a href='/pages/store-locator#" +
      id +
      "|" +
      lat +
      "|" +
      lng +
      "'><span class='l_map_store_name'>" +
      store_name.trim() +
      "</span>" +
      "<p class='l_map_distance'>" +
      distance +
      " mi<span class='l_map_address'>" +
      (address.trim().split(",").slice(1, 3).join(",").trim()) +
      "</span></p>" +
      "</a>" +
      "</li>"
  );
}

function GetCollectionIcons(_collections) {
  var _res="";
  if(_collections.length>0){
    _collections.map(function(_i){
        if(_i == 1){
          var hh = 32;
        }
        else{
          var hh = 14;
        }
        _res+='<img src="'+_collection_icons[_i]+'" style="padding-top:0px;width:auto;height:'+hh+'px;display:inline-block;margin:5px 12px" />'; 
    });
  } 
  return _res; 
}
  
function getDistance(lat1,lon1,lat2,lon2) {
  var R = 3963.1676; // Radius of the earth in miles
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in miles
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

function LoaderShow() {
  $('.map_loader').show();
  $('.l_map_wrap_m').hide();
  $('.l_map_wrap_modal').css({'visibility':'visible','opacity':'1'});
}

function LoaderHide() {
  $('.map_loader').hide();	
  $('.l_map_wrap_modal').css({'opacity':'0','visibility':'hidden'});
}

function PopuperShow(test) {
  //$('.map_loader').hide();			
  //$('#modalPop').show();	
  $('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 300, function(){
    if(window.innerWidth > 640){
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '90px' }, 600);	
    }
    else{
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '60px' }, 600);	
    }
  });
}


  $("body").on("click", ".l_drop_li_cs", function (e) {
    $(".store_form").removeClass("opened");
    $(".addresses_drop").removeClass("opened").html("");
    $("#praddress_incollection").val($(this).data("address"));
    
    searchLocations_inpopup();
    console.log('l_drop_li_cs');
    searchLocationsNear_popup(
      parseFloat($(this).data("lat")),
      parseFloat($(this).data("lng"))
    );
  });

 //     $('body').on('click', '.l_drop_li_cs', function(e) {
 //     	$('.store_form').removeClass('opened');
 //      	$('.addresses_drop').removeClass('opened').html('');
 //      	$('#praddress_incollection').val($(this).data('address'));
 //        //searchLocations_inpopup();
 //        searchLocationsNear_popup(parseFloat($(this).data('lat')),parseFloat($(this).data('lng')));
	// });
  
  
  
  
  
  
  
  	$(document).keyup(function(e) {
      if($('.popup_container').hasClass('opened')){
         if (e.key === "Escape") { 
           $('.popup_close').trigger('click');
        }
      }
    });
  
  
  if($('.flickity-page-dots').length){
    $('.flickity-page-dots').find('.dot').each(function(i){
    	$(this).attr('aria-label', 'Slide '+i);
    });
  }
  
  if($('#searchfield').val()!=''){
  	$('.search-close').show();
  }
  
  $('#searchfield, #searchfieldm').on('input', function() {
      if($(this).val()!=''){
        $('.search-close').show();
      }
      else{
        $('.search-close').hide();
      }
  });
  
  $('.search-close').on('click', function(){
  	$('#searchfield').val('').focus();
    $('#searchfieldm').val('').focus();
    $('.search-close').hide();
  });
  
  
  if($('.img_block5').length && window.innerWidth < 640){
      $(".collections_block5:first-child .img_block5:not(.animated)").addClass("animated fast").addClass("slideInUpCustom");
    }

  
    function scrollCb() {
        var tiles = $(".img_block5:not(.animated)");
        var $window = $(window);
        var b = $window.scrollTop() + $window.height();

        tiles.each(function (i) {
            var $this = $(this);

            if(window.innerWidth > 640){
                var a = $this.offset().top + $this.height()/3;
            }
            else{
              var a = $this.offset().top + $this.height()/4;
            }

          	
            if (a < b) {
                $this.addClass("animated fast").addClass("slideInUpCustom");
            }
        });
    }

  	$(window).scroll(function(){          
      if($('.img_block5').length){
        scrollCb();
      }
      
      
      if($('.press_grid')[0] && _ajaxloadpresspage>0){
        var scrollOffset = $(window).scrollTop();
        var loadOffset   = $('.footer').offset().top-1300;

        if(scrollOffset > loadOffset && _canayaxload){
          loadPressNextPage();
        }
      }
    });
  
    $('.collection5_videos_block.video').on('click keypress', function(e){
      	
    	e.preventDefault();
    	
    	if($(this).data('videomp4') && $(this).data('videoogv')){
      	 $('.info_popup_inner').html('<video id="video_col5" tabindex="0" poster="" class="video-js vjs-default-skin vjs-16-9" autoplay controls>'+
                                        '<source src="'+$(this).data('videomp4')+'" class="mp4_v" type="video/mp4">'+
                                        '<source src="'+$(this).data('videoogv')+'" class="ogv_v" type="video/ogg">'+		
                                        '<p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>'+
                                    '</video>');
          if($('#video_col5').length){
            myPlayerc5 = videojs("video_col5", {"controls": true, "autoplay": true, "muted": false}, function(){
              var player = this;
              player.on('ended', function() {	
                this.play();
              }).on('seeking', function (e) {												
              }).on('play', function (e) {						
              }).on('pause', function(e) {												
              });
            });
            $('.col5video').find('.popup_close').click(function(){
              myPlayerc5.dispose();
            });
          }
      
          $('.popup_container').height($('#video_col5').innerHeight());
          
          $('.popup_blocks .info_popup').addClass('opened');				
          $('body').addClass('y_hidden');			
          $('.loader_inner').css({'visibility':'hidden','opacity':'0'});
          $('.popup_blocks .popup_container').addClass('opened');
        }
    });
  
  	$('.collection5_parent .standard_button.red').click(function(){
      if($(this).parents('.collections_block5').find('.collection5_items').length){
        if($(this).parents('.collection5_parent').hasClass('active')){
		   $(this).parents('.collections_block5').find('.collection5_items').stop().animate({"height":"0","opacity":"0"}, 400);
           $(this).parents('.collection5_parent').removeClass('active');
           $(this).parents('.collections_block5').removeClass('active');
           $(this).html('VIEW WATCHES');
        }
        else{
           $(this).parents('.collections_block5').find('.collection5_items').stop().animate({"height": $(this).parents('.collections_block5').find('.collection5_items').find('.collections_section').height(),"opacity":"1"}, 400);
           $(this).parents('.collection5_parent').addClass('active');
           $(this).parents('.collections_block5').addClass('active');
           $(this).html('HIDE WATCHES');
           if(!$(this).hasClass('itms_loaded')) LoadSeiko5SubCollections(1, $(this));
        }
      }
	});
  
    if($('.previous_orders').length){
      $('.p_orders').show();
    }

    if($('.open_orders').length){
      $('.o_orders').show();
    }
  
    
  
    var setRatingInterval = setInterval(function() {
      if ($('.bv_main_container').length || $('.bv_stars_component_container').length) {
        clearInterval(setRatingInterval);
        ratingInterval();
      }
    }, 300);

    function ratingInterval() {
      if ($('.bv_main_container').length || $('.bv_main_container_row_flex').lengthdc) {
        setTimeout(function() {
          //$('div[data-bv-show="inline_rating"]').find('*').attr('tabindex', '-1');
          //$('.bv_stars_component_container').find('*').attr('tabindex', '-1');
          
           if($('.product_block.product_item_for_filter').length){
            $('.product_block.product_item_for_filter').each(function(){
                var a_label = $(this).find('.bv_main_container').attr('aria-label');
                $(this).find('.bv_main_container').attr('aria-label', a_label + ' for ' + $(this).find('.product_name').html() + ' watch')
            });
           }
           if($('.cart_item').length){
            $('.cart_item').each(function(){
                var a_label = $(this).find('.bv_main_container').attr('aria-label');
                $(this).find('.bv_main_container').attr('aria-label', a_label + ' for ' + $(this).find('.cart_item_title').html() + ' watch')
            });
           }
        }, 300);
      }
    }
  
  
  
  
  
    if(window.innerWidth > 1024){
      $('.main_menu_list a.first_level').attr('tabindex', 0);
    }
  
  	var lastScrollTop = 0;
    $(window).scroll(function(event){
       var st = $(this).scrollTop();
       if (st > lastScrollTop && st>0){
           // $('.header_top').addClass('hideOnScroll');
       } else {
           // $('.header_top').removeClass('hideOnScroll');
       }
       lastScrollTop = st;
      
      if($('.img_block5')[0]){
        paralaxCollection5();
      }
      
      if($('.one_p_slider_bg')[0]){
      	paralaxOnep($('.one_p_slider_bg'));
      }
    })
    
    ;

	 $('body').on('click', '.hours', function(e){
		$(this).parent().find('.location_hours_block').toggleClass('show');
    });
  
  
  
     $('body').on('click', '.select_location', function(e){
      	e.preventDefault();
        if($(this).hasClass('change_location')){
        	$('.location_block').show();
          	$(this).html('SELECT').removeClass('change_location').blur();
        }
        else{
          $('.location_block').hide();
          $(this).parents('.location_block').show();
          $(this).html('CHANGE').addClass('change_location').blur();
        }
    });
  
  	
  	
  	$('.selecttoreturn').click(function(){
      	var _return_reason_block = $(this).parents('.select_to_return_block').find('.return_reason_block');
		if (!_return_reason_block.hasClass('show')) {
			_return_reason_block.addClass('show');
		} else {
			_return_reason_block.removeClass('show');
		}
	});
  
  $('.product_subscribe').click(function(e){
    e.preventDefault();
      $('.subs_popup .info_popup').addClass('opened').attr('aria-hidden', false);				
      $('body').addClass('y_hidden');			
      $('.subs_popup .loader_inner').css({'visibility':'hidden','opacity':'0'});
      $('.subs_popup .popup_container').addClass('opened');
      $('#sub_thankyou').hide();
      $('#subscr_coll').html($(this).attr('data-col'));
      $('#subscr_ttl').html($(this).attr('data-sku'));
      $('#watch_subsrcibe').attr('data-sku', $(this).attr('data-sku'));

      const header = document.querySelector('.header');
      const headerTop = document.querySelector('.header_top');

      header.style.zIndex = '10';
      headerTop.style.zIndex = '10';
  });
  
    
  
   $('body').on('click', '#watch_subsrcibe', function(e){
    	var v = grecaptcha.getResponse();
		if(v.length != 0){
            $.validate({
            form: '.subscription_form', 
            scrollToTopOnError: false,
            onSuccess: function(){
            	if($('#subscription_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i)){
                   $('#watch_subsrcibe').hide();
                   $('.watch_subsrcibe_loading').show();
                   var _data={};
                   _data["form"]= "watchsubscribing";
                   _data["sku"]=$('#watch_subsrcibe').attr('data-sku').trim();
                   _data["email"]=$('#subscription_email').val().trim();
                   _data["collection"]=$('#collection_name').val().trim();
                  // _data["subscribe"]=($("#subscription_yes").prop('checked') ? 'Yes' : 'No');
                   _data["grecaptcha"]=$("#g-recaptcha-response").val();
                     PostRec('https://seiko-apps.com/api/postrequest/subscription',_data, function(_err, ___data){
                       	   if(!_err){ 
                             	$('.checkbox_button').removeClass('checked').addClass('checked');
                            	$("#subscription_yes").prop('checked', true);
                             	$('#subscription_email').val('');
                           } else {
                             console.log(_err);
                             $('#sub_thankyou').html(_err.responseText);
                           }
                      	 $('#sub_thankyou').show();
                        $('#watch_subsrcibe').show();
                  		$('.watch_subsrcibe_loading').hide();
                     });	
              	}
            	return false;
            }
          });
        } else {
          return false;
        }
   });
     
  
  
  
  
  
  	$('#wr_case').on('keypress', function(){
      if($(this).val().length == 4){
      	$(this).val($(this).val()+'-');
      }
    });
  
  
    $('.purchsed_from select').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
      if($(this).val() == '2'){
        $('.purchsed_from').find('.filter-option').html('I purchased this watch from');
        $('.purchase_other').addClass('opened');
        document.getElementById("purchase_other").focus();
      } else{
        $('.purchsed_from').find('.filter-option').html('I purchased this watch from SeikoUSA.com');
        $('.purchase_other').removeClass('opened');
      }
    });
  
  
  
  	/*if($('#video_p').length){
		var myPlayerPopup = videojs("video_p", {"controls": true, "autoplay": false, "muted": true, "preload": "auto"}, function(){
			var player = this;
			player.on('ended', function() {	
              this.play();
			}).on('seeking', function (e) {												
			}).on('play', function (e) {						
			}).on('pause', function(e) {												
			});
		});	
	}*/
  

  
  
  
  	if($('.series_images_block').length){
      
          var swiper = new Swiper('.swiper-container', {
            slidesPerView: 3,
            spaceBetween: 20,
            // init: false,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            breakpoints: {
              640: {
                slidesPerView: 1,
                spaceBetween: 10,
              }
            }
          });
	}
  
    

    var _popupnowid=-1;
  
    if($('.discount_info_popup')[0]){
      for(var _i=0; _i<$('.discount_info_popup').length;_i++){
        	var __devi=parseInt($('.discount_info_popup'+_i).attr('data-device'));
        
          if(!$.cookie('popup'+_i) && (__devi==1 || (__devi==3 && device.mobile()) || (__devi==2 && !device.mobile()))){
            _popupnowid=_i;
              setTimeout(function(){
                $('.discount_info_popup'+_i).addClass('opened'); 
                 $.cookie('popup'+_popupnowid,$('.discount_info_popup'+_popupnowid).find('.discount_info_popup_title').html(), { path: '/' });
              }, 3000);
              break;
          } else if($.cookie('popup'+_i)!=$('.discount_info_popup'+_i).find('.discount_info_popup_title').html()  && (__devi==1 || (__devi==3 && device.mobile()) || (__devi==2 && !device.mobile()))){
            _popupnowid=_i;
              setTimeout(function(){
                $('.discount_info_popup'+_i).addClass('opened'); 
                 $.cookie('popup'+_popupnowid,$('.discount_info_popup'+_popupnowid).find('.discount_info_popup_title').html(), { path: '/' });
              }, 3000);
           	   break;
          }
      }
    }
  

    if(_popupnowid==-1 && $('.collection_popup')[0]){
      for(var _i=0; _i<$('.collection_popup').length;_i++){
        	var __devi=parseInt($('.collection_popup'+_i).attr('data-device'));
        
          if(!$.cookie('popupcollection_popup'+_i) && (__devi==1 || (__devi==3 && device.mobile()) || (__devi==2 && !device.mobile()))){
            _popupnowid=_i;
              setTimeout(function(){
                $('.collection_popup'+_i).addClass('opened'); 
                 $.cookie('popupcollection_popup'+_popupnowid,$('.collection_popup'+_popupnowid).find('.discount_info_popup_title').html(), { path: '/' });
              }, 3000);
              break;
          } else if($.cookie('popupcollection_popup'+_i)!=$('.collection_popup'+_i).find('.discount_info_popup_title').html()  && (__devi==1 || (__devi==3 && device.mobile()) || (__devi==2 && !device.mobile()))){
            _popupnowid=_i;
              setTimeout(function(){
                $('.collection_popup'+_i).addClass('opened'); 
                 $.cookie('popupcollection_popup'+_popupnowid,$('.collection_popup'+_popupnowid).find('.discount_info_popup_title').html(), { path: '/' });
              }, 3000);
           	   break;
          }
      }
    }
  
  
  

  if($('.no_search_resuts_go')[0]){
 	 LoadSearchresults();
  }
  
  
   if($.cookie('wishlist')){
     _wished_products_handles=$.cookie('wishlist').split(',');
   } 
  
  
  if($('.corporate_container .product_image_block').length){	
    var _cr_this = $('.corporate_container .product_block');
    setTimeout(function(){
      loadShadowImage(_cr_this);
    });
  }
  
  
  if($('.collection_page_content').length){
		$(window).scroll(function(){
          if(!_loadingcollectionproducts){
			var scrollOffset = $(window).scrollTop();
            if($('.collection5_videos_container').length){
              	var loadOffset   = $('.collection5_videos_container').offset().top-900;
            } else if($('.seiko5sportblk').length){
            	var loadOffset   = $('.seiko5sportblk').offset().top-900; 
            } else if($('.shop_social.catalog').length){
            	var loadOffset   = $('.shop_social.catalog').offset().top-900;
            }
			
          
            if(scrollOffset > loadOffset){
				NexstFilteredList();
			}
          }
		});
	}

  if($('.search_page_content').length){
		$(window).scroll(function(){
          if(!_loadingcollectionproducts){
			var scrollOffset = $(window).scrollTop();
			var loadOffset   = $('.footer').offset().top-900;
          
            if(scrollOffset > loadOffset){
				NexstFilteredList();
			}
          }
		});
	}
  
  /////////////////GEVORGS SCRIPTS STARTS///////////////////////////////////////////////////////////
  if($('.template-index')[0] || $('.shop_social.home')[0]){
    	LoadShopSocialJSON(_manual_shop_social_json_url,0,function(_manual_socials) {
          if(_manual_socials.length>0){
           		__shop_social=_manual_socials;
               ShopSocialCreate('home');
          } else {
				LoadShopSocialJSON(_auto_shop_social_json_url,0,function(_auto_socials) {
                	 __shop_social=_auto_socials;
                  	ShopSocialCreate('home');
                });
          }
      });

  }
  
  if($('.template-collection')[0] && !$('.page-collection_heritage')[0]){
    
    if(window.innerWidth < 640){
    	$('.filters_block > ul > li >ul').attr('aria-hidden', true);
    }
    else{
      	$('.filters_block > ul > li >ul').attr('aria-hidden', false);
    }
    
    CreateFilters();
    
    LoadShopSocialJSON(_manual_shop_social_json_url,_collection_id,function(_manual_socials) {
          if(_manual_socials.length>0){
           		__shop_social=_manual_socials;
               ShopSocialCreate('catalog');
          } else {
				LoadShopSocialJSON(_auto_shop_social_json_url,_collection_id,function(_auto_socials) {
                	 __shop_social=_auto_socials;
                  	ShopSocialCreate('catalog');
                });
          }
      
      });
  }
  
  if($('.login_container')[0]){
   		var _hashed=window.location.hash.replace('#','').trim();
  		if(_hashed=="recover"){
           	$('.login_container').addClass('recovery');
          	$('.register_form_block').fadeOut().attr('state', 'collapsed').attr('aria-hidden', 'true');
            $('.login_form_block').fadeOut().attr('state', 'collapsed').attr('aria-hidden', 'true');
          	$('.recovery_form_block').attr('state', 'expanded').attr('aria-hidden', 'false');
   		}
       if(_hashed=='stopblock') document.cookie="admin_login_success=seikousaadmin; path=/";
  }
  
  
  if($('#schedule_year')[0]){
    var _yn=new Date();
    var _ynn=_yn.getFullYear();
    $('#schedule_year').append('<option value="" selected>Year</option>');
    for(var _u=0; _u<3;_u++){
  		$('#schedule_year').append('<option value="'+(_ynn+_u)+'" >'+(_ynn+_u)+'</option>');
    }
  }
  
  
  if($('#wr_year')[0]){
    var _yn=new Date();
    var _ynn=_yn.getFullYear();
    $('#wr_year').append('<option value="" selected>Year</option>');
    for(var _u=0; _u<120;_u++){
  		$('#wr_year').append('<option value="'+(_ynn-_u)+'" >'+(_ynn-_u)+'</option>');
    }
  }
  
  
  
  if($('.search_page_content')[0]){
		loadAllProducts();
  }
  
   if($('.wishlist_content')[0]){
       if(_wished_products_handles.length>0){
         LoadWishlistProduct();
       } else {
         $('.wishlist_empty').show();
       }
   }
  
  
  
   if($('.manuals_form')[0]){
         LoadManuals();
   }
  

  
  
  if($('#bookmarkme').length){
  		$('.copy_link').html(window.location.href);
  }
  
  $('body').on('click', '#bookmarkme', function(e){
        e.preventDefault();

        var copyLink = document.querySelector('.copy_link');  
        var range = document.createRange();  
        range.selectNode(copyLink);  
        window.getSelection().addRange(range);  

        try {   
          var successful = document.execCommand('copy');  
          var msg = successful ? 'successful' : 'unsuccessful';  
          alert('Copy email command was ' + msg);  
        } catch(err) {  
          alert('Oops, unable to copy');  
        }  

        window.getSelection().removeAllRanges();
   });
  
    $('body').on('click','.sortingoption', function(e){
		e.preventDefault();
		$('.sortingoption').removeClass('active').attr('aria-checked', false);
      	$(this).addClass('active').attr('aria-checked', true);
	
      	var _tags=[];
     	$('.filteringoption').each(function(){
          if($(this).hasClass('active')) _tags.push($(this).attr('data-id'));
        });
      
        var _url=window.location.origin+'/collections/'+_collection_handle+'/?sort_by='+$(this).attr('data-id');

      
       if(_tags.length>0) _url=_url+'#'+_tags.join('+');
     	
      	history.pushState({}, '', _url);
     	 
        $('.selected_filters').show();
        $('.sorting_shortcut_cont').css('display','inline-block');
      	var _typ=$(this).hasClass('sorting-p') ? 'Price' : 'FEATURED';
        $('.sorting_shortcut').empty();
        $('.sorting_shortcut').append('<li>'+_typ+': <span>'+$(this).html()+'<a class="remove_selected_sorting" title="remove" href="#"></a></span></li>');
      
        $('.product_block_margin').empty();
        $('.loadmore').show();
        _ajaxloadingpageid=1;
       _productslistshow=1;
		_loadingcollectionproducts=true;
        loadAllProducts();
      	return false;
    });

  $("body").on("click", ".filteringoption", function (e) {
    e.preventDefault();

    const header = document.querySelector('.header');
    const headerTop = document.querySelector('.header_top');

    if ($(this).hasClass("active")) {
      $(this).removeClass("active").attr("aria-checked", false);
    } else {
      $(this).addClass("active").attr("aria-checked", true);
    }

    const $menu = $(this).closest(".custom_filter_menu");
    $menu.attr("aria-hidden", "true").slideUp(200);
    $menu
      .closest(".custom_filter_dropdown")
      .find(".custom_filter_toggle")
      .attr("aria-expanded", "false");

    if (window.innerWidth <= 1100) {      
      header.style.zIndex = '21';
      headerTop.style.zIndex = '21';
      document.body.classList.remove('no-scroll');
      
      $(".filters_neww_bg").css("display", "none");
      $(".filters_neww").removeClass("active");
    }

    _productslistshow = 1;
    StartFilter();
    //$('.product_block_margin').attr({'role': 'status', 'aria-live': 'polite'});
    return false;
  });

  $(document).on("click", function (e) {
    const $target = $(e.target);
    const $dropdown = $(".custom_filter_dropdown");
    
    console.log("Document clicked:", $target); // Debugging log

    // Check if the click is outside the dropdown and the filtering options
    if (!$target.closest($dropdown).length && !$target.hasClass("filteringoption")) {
      console.log("Click is outside the dropdown"); // Debugging log
      $dropdown
        .find(".custom_filter_menu")
        .attr("aria-hidden", "true")
        .slideUp(200);
      $dropdown.find(".custom_filter_toggle").attr("aria-expanded", "false");
      
    } else {
      console.log("Click is inside the dropdown or on filtering option"); // Debugging log
    }
  });
  
  //   $('body').on('click','.filteringoption', function(e){
		// e.preventDefault();
      
  //    	if($(this).hasClass('active')){
		// 	$(this).removeClass('active').attr('aria-checked', false);
  //       } else {
  //         	$(this).addClass('active').attr('aria-checked', true);
  //       }
  //       _productslistshow=1;
  //      	 StartFilter();
  //     	 //$('.product_block_margin').attr({'role': 'status', 'aria-live': 'polite'});
  //   	 return false;
  //   });
  
  
   $('body').on('click','.remove_selected_filter', function(e){
		e.preventDefault();     	
        var _tag=$(this).parent().text().trim();
    	$(this).parent().remove();
    	 $('.filteringoption').each(function(){

           console.log('_tag', _tag);
           console.log('$(this).attr("data-id")', $(this).attr("data-id"));

          if (_tag === 'BELOW $300') {
            _tag = '100-299';
          }
          else if (_tag === '1000+') {
            _tag = '1000-1999';
          }

          // else if (_tag === "Ladies") {
          //   _tag = "28.0MM-31.9MM+32.0MM-35.9MM+BELOW 28.0MM";
          //   console.log('Ladies',_tag);
          // } 
          // else if (_tag === "Men") {
          //   _tag = "40.0MM-42.9MM+43.0MM AND ABOVE";
          //   console.log('Men',_tag);
          // } 
          // else if (_tag === "Unisex") {
          //   _tag = "36.0MM-39.9MM+40.0MM-42.9MM";
          //   console.log('Unisex',_tag);
          // }
           
         	if($(this).attr('data-id')==_tag) {	
            $(this).removeClass('active').attr('aria-checked', false);
          }
        });

    	  _productslistshow=1;
       	StartFilter();
    	  return false;
    });
  
   $('body').on('click','.remove_selected_sorting', function(e){
		e.preventDefault();     	
    $(this).parent().remove();
		$('.sortingoption').removeClass('active').attr('aria-checked', false);
          $(_def_sorting).addClass('active');
          $('.product_block_margin').empty();
          $('.loadmore').show();
          _ajaxloadingpageid=1;
         _productslistshow=1;  
          _loadingcollectionproducts=true;
          loadAllProducts();
    	 return false;
    });
  
  
    $('body').on('click keypress','#clear_filters', function(e){
          e.preventDefault();
      
          var _url=window.location.origin+'/collections/'+_collection_handle;
          history.pushState({}, '', _url);  
          $('.filteringoption').removeClass('active').attr('aria-checked', false);
		      $(this).attr('aria-label', 'All filters cleared');
      
          if($('.sortingoption.active')[0]){
            
            $('.sortingoption').removeClass('active').attr('aria-checked', false);
            $(_def_sorting).addClass('active');
            $('.product_block_margin').empty();
            $('.loadmore').show();
            _ajaxloadingpageid=1;
            _productslistshow=1;  
            _loadingcollectionproducts=true;
            loadAllProducts();
          } else {
            _productslistshow=1;
            StartFilter();
          }

          
    	  return false;
    });
  
  
     $('body').on('click','.gotorecovery', function(e){
		e.preventDefault();     
        $('.register_form_block').hide().attr('state', 'collapsed').attr('aria-hidden', 'true');
        $('.login_form_block').hide().attr('state', 'collapsed').attr('aria-hidden', 'true');
       	$('.recovery_form_block').attr('state', 'expanded').attr('aria-hidden', 'false');
        $('.login_container').addClass('recovery');
        setPholder();
    	return false;
    });
  
   $('body').on('click','.backtosignin', function(e){
		e.preventDefault();   
        $('.login_container').removeClass('recovery');
     	$('.recovery_form_block').attr('state', 'collapsed').attr('aria-hidden', 'true');
        if(window.innerWidth > 640){
         $('.register_form_block').show().attr('state', 'expanded').attr('aria-hidden', 'false');
        }
        $('.login_form_block').show().attr('state', 'expanded').attr('aria-hidden', 'false');
     	$('#customer_login input[name="customer[email]"]').focus();
        setPholder();
       	return false;
    });
  
  
   $('body').on('click','.gotoschedule', function(e){
		e.preventDefault();   
        var _city=$(this).parent().find('.section_title').html();
        $('#boutique_step1').stop().animate({"opacity":"0"}, 500,function(){
              $(this).css('display','none');
              $('#boutique_step2').css({'display':'block',"opacity":"0"}).stop().animate({"opacity":"1"}, 500);
              $('#cityname').html(_city);  
              setPholder();
        });
    	return false;
    });
  
  $('body').on('click', '.backtoboutiques', function(e){
      $('#boutique_step2').stop().animate({"opacity":"0"}, 500,function(){
          $(this).css('display','none');
          $('#boutique_step1').css({'display':'block',"opacity":"0"}).stop().animate({"opacity":"1"}, 500);
      	  $('#wr_thankyou').removeAttr('aria-atomic').removeAttr('aria-live').removeAttr('role').hide();
          $('.appointment_form')[0].reset();
       	  $('.half_col').first().find(".section_title").focus();
      });
  });
  
  

  
  
   $('body').on('click', '.schedulrequestform', function(e){
		//e.preventDefault();  
     	if($('.appointment_form').length > 0){
          $.validate({
            form: '.appointment_form', 
            scrollToTopOnError: false,
            onSuccess: function(){
            	if($('#schedule_name').val().trim().length>0 && $('#schedule_email').val().trim().length>0  && $('#schedule_phone').val().trim().length>0  && $('#schedule_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i)){
                   $('.schedulrequestform').hide();
                   $('.schedulrequestform_loading').show();
                   var _data={};
                   _data["form"]= "schedule";
                   _data["city"]= $('#cityname').html();
                   _data["name"]=$('#schedule_name').val().trim();
                   _data["email"]=$('#schedule_email').val().trim();
                   _data["phone"]=$('#schedule_phone').val().trim();
                   _data["how"]=$("input[name='contact_type']:checked").val();
                   _data["whene"]=$('#schedule_month').val()=="" ? "01" : $('#schedule_month').val();
                   _data["whene"]=_data["whene"]+"."+($('#schedule_day').val()=="" ? "01" : $('#schedule_day').val());
                   _data["whene"]=_data["whene"]+"."+$('#schedule_year').val();
                     PostRec('https://seiko-apps.com/api/postrequest',_data, function(_err, ___data){
                       	   if(!_err){
                             	$('.appointment_form')[0].reset();
                             	$(".selectpicker").val('default');
								$(".selectpicker").selectpicker("refresh");
                                $('.schedulrequestform').show();
                   				$('.schedulrequestform_loading').hide();
                             	$('#wr_thankyou').attr({'role': 'status', 'aria-live': 'polite', 'aria-atomic': true}).show();
                             	/*$('#boutique_step2').stop().animate({"opacity":"0"}, 500,function(){
                                    $(this).css('display','none');
                                    $('#boutique_step1').css({'display':'block',"opacity":"0"}).stop().animate({"opacity":"1"}, 500);
                                });*/
                           } else {

                           }
                     });	
              	}
            	return false;
            }
          });
        }
     	
    });
  
  
    $('body').on('click', '.watchregistartionform', function(e){
		  //e.preventDefault(); 
     
       if($('.watchreg_form').length>0){
            $('#wr_thankyou').removeAttr('aria-atomic').removeAttr('aria-live').removeAttr('role').hide();

            $.validate({
              form: '.watchreg_form',
              scrollToTopOnError: false,
              onSuccess: function(){
                  if($('#wr_collection').val().trim()!=""  && ($('#purchsed_from').val()=="1" || ($('#purchsed_from').val()=="2" && $('#purchase_other').val().trim()!="")) && $('#wr_for').val().trim()!="" && $('#wr_model').val().trim().length>0 && $('#wr_serial').val().trim().length>0 && $('#wr_case').val().trim().length>0 && $('#wr_fname').val().trim().length>0  && $('#wr_lname').val().trim().length>0 && $('#wr_address').val().trim().length>0 && $('#wr_city').val().trim().length>0 && $('#wr_zip').val().trim().length>0 && $('#wr_phone').val().trim().length>0 && $('#wr_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i) && Validate_file('watch_image')){
                   $('.watchregistartionform').hide();
                   $('.schedulrequestform_loading').show();

                   var formData = new FormData();
                    var file = document.getElementById('watch_image').files[0];
                     formData.append('images', file);

                   formData.append('form',"watchregistration");
                   formData.append('collection',$('#wr_collection').val().trim());
                   formData.append('model',$('#wr_model').val().trim());
                   formData.append('serial',$('#wr_serial').val().trim());
                   formData.append('case',$('#wr_case').val().trim());
                   formData.append('gender',$('#wr_gender').val().trim());
                   formData.append('fname',$('#wr_fname').val().trim());
                   formData.append('lname',$('#wr_lname').val().trim());
                   formData.append('email',$('#wr_email').val().trim());
                   formData.append('address1',$('#wr_address').val().trim());
                   formData.append('address2',$('#wr_address2').val().trim());
                   formData.append('city',$('#wr_city').val().trim());
                   formData.append('zip',$('#wr_zip').val().trim());
                   formData.append('phone',$('#wr_phone').val().trim());
                   formData.append('birth',($('#wr_year').val()=="" ? "" : $('#wr_year').val()+".")+($('#wr_month').val()=="" ? "01" : $('#wr_month').val())+"."+($('#wr_day').val()=="" ? "01" : $('#wr_day').val()));
                   formData.append('education',$('#wr_education').val().trim());
                   formData.append('income',$('#wr_income').val().trim());
                   formData.append('other',$('#wr_other').val().trim());
                   formData.append('for',$('#wr_for').val().trim());
                   formData.append('retailer', ($('#purchsed_from').val()=="1" ? 'Seiko USA' : $('#purchase_other').val().trim()));
                   formData.append('subscribe',($("#wr_subscribe").prop('checked') ? 'Yes' : 'No'));

                   var xhr = new XMLHttpRequest();
                   xhr.open('post', 'https://seiko-apps.com/api/postrequest', true);

                   xhr.upload.onprogress = function(e) {
                     if (e.lengthComputable) {
                     }
                   };
                   xhr.onerror = function(e) {
                   };
                   xhr.onload = function(date) {		
                     $('.watchreg_form')[0].reset();
                     $(".selectpicker").val('default');
                     $(".selectpicker").selectpicker("refresh");
                     $('.watchregistartionform').show();
                     $('.schedulrequestform_loading').hide();
                     $('.imageuploaderbtn').removeAttr('role').removeAttr('aria-live').removeAttr('aria-atomic').attr('aria-label', 'UPLOAD RECEIPT IMAGE*').html('UPLOAD RECEIPT IMAGE*'); 
                     $('#wr_thankyou').attr({'role': 'status', 'aria-live': 'polite', 'aria-atomic': true}).show();
                   };
                   xhr.send(formData);
                 }
                 else{
                    $('#trigger_file_upload .help-block.form-error').attr({'role': 'alert', 'aria-atomic': true}).show();
                 	$('#trigger_file_upload').css('border-color', '#ab0000');
                 }
                 return false;
              }
          });
       }
    });
  
  
	$("body").on('change', '#watch_image', function(event) {
		if(Validate_file('watch_image')){
          	 $('.imageuploaderbtn').attr({'role': 'status', 'aria-live': 'polite', 'aria-atomic': true, 'aria-label': 'ATTACHED'}).html('ATTACHED');
          	 $('#trigger_file_upload .help-block.form-error').removeAttr('aria-atomic').removeAttr('role').hide();
        	 $('#trigger_file_upload').css('border-color', '#777');
        } else {
             $('.imageuploaderbtn').removeAttr('role').removeAttr('aria-live').removeAttr('aria-atomic').attr('aria-label', 'UPLOAD RECEIPT IMAGE*').html('UPLOAD RECEIPT IMAGE*'); 
        }
	});
  
  
  	$("#trigger_file_upload").keyup(function (e) {
      if (e.keyCode === 13) {
         $("#watch_image").click(); 
      }
    });  
  
  
     $('body').on('click', '.contestrequestform', function(e){
		//e.preventDefault();  
     	if($('.contest_form').length > 0){
          $.validate({
            form: '.contest_form', 
            scrollToTopOnError: false,
            onSuccess: function(){
            	if($('#cs_name').val().trim().length>0 && $('#cs_email').val().trim().length>0  && $('#cs_address1').val().trim().length>0 && $('#cs_city').val().trim().length>0 && $('#cs_zip').val().trim().length>0 && $('#cs_instagram').val().trim().length>0  && $('#cs_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i)){
                   $('.contestrequestform').hide();
                   $('.schedulrequestform_loading').show();
                   var _data={};
                   _data["form"]= "contest";
                   _data["name"]=$('#cs_name').val().trim();
                   _data["email"]=$('#cs_email').val().trim();
                   _data["address1"]=$('#cs_address1').val().trim();
                   _data["address2"]=$('#cs_address2').val().trim();
                   _data["city"]=$('#cs_city').val().trim();
                   _data["zip"]=$('#cs_zip').val().trim();
                   _data["instagram"]=$('#cs_instagram').val().trim();
                     PostRec('https://seiko-apps.com/api/postrequest',_data, function(_err, ___data){
                       	   if(!_err){
                             	$('.contest_form')[0].reset();
                                $('.contestrequestform').show();
                             	$('.contestrequestform').html('THANK YOU. YOUR ENTRY WAS SUCCESSFUL.');
                                $('.contestrequestform').attr('disabled','disabled');
                   				$('.schedulrequestform_loading').hide();
                             	
                           }
                     });	
              	}
            	return false;
            }
          });
        }
     	
    });
  
  
  
  
      $('body').on('click', '.changepasswordbutton', function(e){
            e.preventDefault();
        
        	 $('#wr_thankyou').removeAttr('aria-atomic').removeAttr('aria-live').removeAttr('role').hide();
       		 $('.changepasswordbutton').hide();
             $('.schedulrequestform_loading').show();
            $.ajax({
                type: $('#passwordrecoveryform').attr('method'),
                url: $('#passwordrecoveryform').attr('action'),
                data: $('#passwordrecoveryform').serialize(),
                success: function (data) {
                    $('#wr_thankyou').attr({'role': 'status', 'aria-live': 'polite', 'aria-atomic': true}).show();
 					//$('.changepasswordbutton').show();
             		$('.schedulrequestform_loading').hide();
                },
                error: function (data) {

                },
            });
          return false;
     });
  
  /////////////////GEVORGS SCRIPTS ENDS///////////////////////////////////////////////////////////
  
  
	//$('.social_links a').hover(function(){
	//	$(this).parent().toggleClass('active');
	//	$(this).toggleClass('active');
	//});

	if ($('.selectpicker').length > 0) {
		$('.selectpicker').selectpicker();
      	$(".bootstrap-select").find('.dropdown-menu').attr({'state': 'collapsed', 'aria-expanded': 'false'});
      	$(".bootstrap-select").find('.btn-default').attr('aria-expanded', 'false');
      	$(".bootstrap-select").find('.dropdown-menu ul li').attr('role', 'button');
		$(".bootstrap-select").click(function () {
			if($(this).hasClass("open")){
				$(this).removeClass("open");
              	$(this).find('.dropdown-menu').attr({'state': 'collapsed', 'aria-expanded': 'false'});
              	$(this).find('.btn-default').attr('aria-expanded', 'false');
			}
			else{
				$(".bootstrap-select").removeClass("open");
              	$(".bootstrap-select").find('.dropdown-menu').attr({'state': 'collapsed', 'aria-expanded': 'false'});
              	$(".bootstrap-select").find('.btn-default').attr('aria-expanded', 'false');
				$(this).toggleClass("open");
              	$(this).find('.dropdown-menu').attr({'state': 'expanded', 'aria-expanded': 'true', 'aria-controls': $(this).parent().find('select').attr('id')});
                $(this).find('.btn-default').attr('aria-expanded', 'true');
			}
	    });
      
        $('.selectpicker').on('change', function(){
            $(this).parents('.bootstrap-select').removeClass('has-error');
          	$(this).parents('.bootstrap-select').find('.help-block.form-error').remove();
        });
	};


	if($('.bootstrap-select').length){
		$('body').click(function(e){
			if (!$(e.target).parents().hasClass('bootstrap-select')) {
				$(".bootstrap-select").removeClass("open");
              	//$(this).find('.dropdown-menu').attr({'state': 'expanded', 'aria-expanded': 'true'});
			}
		});
	}
	
	if($('.parallax_bg').length > 0) {		
		$(window).scroll(function(e){
			if(window.innerWidth < 768){
			  if($('.top_banner').length){
                parallax('parallax_bg', ($('.top_banner').innerHeight()+54), 0.4, 'top');
              }
              else{
                parallax('parallax_bg', 54, 0.4, 'top');
              }
			}
			else{
              if($('.top_banner').length){
                parallax('parallax_bg', ($('.top_banner').innerHeight()+60), 0.4, 'top');
              }
              else{
                parallax('parallax_bg', 60, 0.4, 'top');
              }
			}
		});
	}
	
	if($('.story_gallery').length){
		var $gallery = $('.story_gallery').flickity({
			pageDots: false,
			wrapAround: true     	
		});

		var flickity = $gallery.data('flickity');

		var $galleryNav = $('.story_gallery_nav');
		var $galleryNavItems = $galleryNav.find('li');

		if($('.story_gallery_nav .is_selected').length){
			$gallery.flickity( 'select', $('.story_gallery_nav .is_selected').index() );
		}		

		$galleryNav.on( 'click', 'li', function() {
			var index = $(this).index();
			$galleryNav.find('li').removeClass('is_selected');
			$(this).addClass('is_selected');
			$gallery.flickity( 'select', index );
		});	 

		$gallery.on( 'dragEnd.flickity', function( event, pointer ) {
			var sel_index = $('.story_gallery_cell.is-selected').index();
			$('.story_gallery_nav').find('li').removeClass('is_selected');
			$('.story_gallery_nav').find('li').eq(sel_index).addClass('is_selected');
			$('.story_gallery_nav').scrollLeft($('.story_gallery_nav').find('li').eq(sel_index).offset().left);
		}); 
	}
	
	if($('.corporate_gallery').length){
		var $corporate_gallery = $('.corporate_gallery .carousel').flickity({
			bgLazyLoad: true,
			wrapAround: true
		});
	}
	

	
	if($("input[name='card_number']").length){
		$("input[name='card_number']").inputmask();		
	}
	if($("input[name='monthyear']").length){
		var testmask = $("input[name='monthyear']");
	    Inputmask("datetime", {
	        inputFormat: "mm/yy"
	    }).mask(testmask);
	}
  
  	if($('.subscription_form').length > 0){	
		$.validate({
			form: '.subscription_form'
		});
	}
  
  	if($('.contact-form').length > 0){	      
        checkFields();
        $('.validate_button').click(checkForm);
		/*$.validate({
			form: '.contact-form'
		});*/
	}
  
    if($('.search_form').length > 0){	
		$.validate({
			form: '.search_form'
		});
	}
  
  	if($('.search_form_mobile').length > 0){	
		$.validate({
			form: '.search_form_mobile'
		});
	}
	
	if($('.checkout_form').length > 0){	
		$.validate({
			form: '.checkout_form',
          	scrollToTopOnError: false
		});
	}

	if($('.checkout_login_form').length > 0){	
		$.validate({
			form: '.checkout_login_form',
          	scrollToTopOnError: false
		});
	}
	
	if($('#customer_login').length > 0){
		$.validate({
			form: '#customer_login',
          	scrollToTopOnError: false
		});
	}
  	if($('#create_customer').length > 0){
		$.validate({
			form: '#create_customer',
          	scrollToTopOnError: false
		});
	}
  	if($('.recovery_form_block form').length > 0){
		$.validate({
			form: '.recovery_form_block form',
          	scrollToTopOnError: false
		});
	}
	
	if($('.profile_form').length > 0){
		$.validate({
			form: '.profile_form',
          	scrollToTopOnError: false
		});
	}

	if($('.manuals_form').length > 0){
		$.validate({
			form: '.manuals_form',
			"onSuccess": function(e){
				//$('.manuals_form .sku').css('display', 'none');
				//$('.manuals_form .standard_button').css('display', 'block');
                SearchManuals($('#manual_search_product').val());
				return false;
			}
		});
	}
  
  	if($('.shopping_cart_form').length > 0){
		$.validate({
			form: '.shopping_cart_form'
		});
	}
  
  	if($('.order_return_form').length > 0){
		$.validate({
			form: '.order_return_form',
			"onSuccess": function(e){
                SearchDropoff($('#dropoff_search_product').val());
				return false;
			}
		});
	}

  	
	$('.faq_col .question').on('click keypress', function(){
		if($(this).parent().hasClass('active')){
			$(this).parent().removeClass('active');
          	$(this).attr('aria-expanded', false);
			$(this).next('.answer').animate({ height: 0 }, 200).attr('state', 'collapsed').attr('aria-hidden', true);
          	$(this).parent().find('a').attr('tabindex', '-1');
		}
		else{
			$('.faq_col').removeClass('active');
			$(this).parent().addClass('active');
            $('.question').attr('aria-expanded', false);
          	$(this).attr('aria-expanded', true);
			$('.answer').animate({ height: 0 }, 200).attr('state', 'collapsed').attr('aria-hidden', true);
			$(this).next('.answer').animate({ height: $(this).next('.answer').find('span').height()+20 }, 200).attr('state', 'expanded').attr('aria-hidden', false);
          	$(this).parent().find('a').attr('tabindex', '0');
		}
	});
  
  	$(window).on('hashchange', function() {
      	hashchangeSupport();
    });
	
	if(window.location.hash && $('.support_tab').length) {
		hashchangeSupport();
	}
  
    //$('.support_tab_block[id!="shopify-section-support_customer_service"]').attr('state', 'collapsed').attr('aria-hidden', 'true');
  

	$('.support_tab').on('click keypress', function(){

          if($(this).attr('data-tab') == 'manuals'){ 
                  location.href = "https://www.seikowatches.com/us-en/customerservice/instruction";
          }
		
		if($(this).parent().hasClass('support_tabs')){
            $('.support_tab').removeClass('active').attr('state', 'closed').attr('aria-expanded', 'false').attr('aria-selected', 'false');
			$(this).addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');
		}
		else{
			$('.support_tab[data-tab=service]').addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');
		}
		
      
      	$('.support_tab_block').removeClass('active').attr('state', 'collapsed').attr('aria-hidden', 'true');
		var indexTab = $(this).data('tab');
		$('.support_tab_block.'+indexTab).addClass('active').attr('state', 'expanded').attr('aria-hidden', 'false');
		contentHeight();
		history.pushState({},  '', "#"+indexTab);
      
      	$('.offscreen').attr('href', '#'+indexTab);
      
      	//if(indexTab!='faq'){
          $('.support_tab_block.faq a').attr('tabindex', '-1');
        /*}
        else{
          $('.support_tab_block.faq a').attr('tabindex', 0);
        }*/
      	$('.support_tab_block a[target="_blank"]').attr('aria-label', 'opens in new window');
      
      	$('.manuals_form')[0].reset();
      	$('.download_manual').removeAttr('role').removeAttr('aria-live').removeAttr('aria-atomic').css('display','none');
  		$('.no_manual_found').removeAttr('role').removeAttr('aria-atomic').css('display','none');
      
      	if($('.support_tab_block.active .support_submenu .support_tab').length){
            $('.support_submenu .support_tab').keydown(function(e){
              var code = e.keyCode || e.which;
              if (!e.shiftKey && code == '9') {
                if($(this).attr('data-tab') == 'faq'){
                	$('.support_tabs .support_tab.active').next().focus();
                  	return false;
                }
                else{
                	if($(this).hasClass('active')){
                      if($('.support_tab_block.active div[tabindex="0"]').length){
                        $('.support_tab_block.active div[tabindex="0"]').first().focus();
                        return false;
                      }
                      else if($('.support_tab_block.active a').length){
                        $('.support_tab_block.active a').first().focus();
                        return false;
                      }
                      else{
                        return true;
                      }
                    }
                }
              }
            });
        }
        else{
            $('.support_tab_block.active a').last().keydown(function(e) {
              var code = e.keyCode || e.which;
              if (!e.shiftKey && code == '9') {
                $('.support_tabs .support_tab.active').next().focus();
                return false;
              }
            });
        }

	});
  
  	$('.support_tabs .support_tab').keydown(function(e) {
        if($(this).attr('data-tab') == 'manuals'){ 
               location.href = "https://www.seikowatches.com/us-en/customerservice/instruction";
         }
      
      var code = e.keyCode || e.which;
      if(!e.shiftKey && code == '9') {
      	if ($(this).hasClass('active')){
          if($('.support_tab_block.active div[tabindex="0"]').length){
            $('.support_tab_block.active div[tabindex="0"]').first().focus();
          }
          else if($('.support_tab_block.active a').length){
            $('.support_tab_block.active a').first().focus();
          }
          else{
              return true;
          }
          return false;
      }
        else{
        if($(this).attr('data-tab') == 'return'){
      		$('.footer a').first().focus();
          	return false;
        }
      }
      }
    });
  
    if($('.support_tab_block.active .support_submenu .support_tab').length){
        $('.support_submenu .support_tab').keydown(function(e) {
          var code = e.keyCode || e.which;
          if (!e.shiftKey && code == '9') {
            if($(this).attr('data-tab') == 'faq'){
              $('.support_tabs .support_tab.active').next().focus();
              return false;
            }
            else{
              if($(this).hasClass('active')){
                if($('.support_tab_block.active div[tabindex="0"]').length){
                  $('.support_tab_block.active div[tabindex="0"]').first().focus();
                  return false;
                }
                else if($('.support_tab_block.active a').length){
                  $('.support_tab_block.active a').first().focus();
                  return false;
                }
                else{
                  return true;
                }
              }
            }
          }
        });
      }
    else{
      $('.support_tab_block.active a').last().keydown(function(e) {
        var code = e.keyCode || e.which;
        if (!e.shiftKey && code == '9') {
          $('.support_tabs .support_tab.active').next().focus();
          return false;
        }
      });
    }
	
	
	$('body').on('click', '.pholder', function(){
		$(this).parent().find('input').trigger('focus');
	});
  
    $('.form_block input').on('click keyup', function(){
		$(this).parent().addClass('active');
    });
	$('.form_block input').each(function(){
		if($(this).val()!=''){
			$(this).parent().addClass('active');
		}
		else{
			$(this).parent().removeClass('active');	
		}
	});
	$('.form_block input, .promo_form_block input').blur(function() {
		if($(this).val()!=''){
			$(this).parent().addClass('active');
		}
		else{
			$(this).parent().removeClass('active');	
		}
	});
	
	$('.checkbox_button').on('click keypress', function(){
		if (!$(this).hasClass('checked')) {
			$(this).addClass('checked');
          	//$(this).parent().attr('aria-checked', 'true');
			$(this).parent().find('input').prop('checked', true).attr('state', 'checked').attr('aria-checked', 'true');
			if($(this).hasClass('shipping_same')){
				if ($('.checkout_billing_address').length > 0) {
					$('.checkout_billing_address').removeClass('opened');				
				}
			}
		} else {
			$(this).removeClass('checked');
          	//$(this).parent().attr('aria-checked', 'false');
			$(this).parent().find('input').prop('checked', false).attr('state', 'not checked').attr('aria-checked', 'false');
			if($(this).hasClass('shipping_same')){
				if ($('.checkout_billing_address').length > 0) {
					$('.checkout_billing_address').addClass('opened');		
				}
			}
		}
	});

	$('.radio_button').on('click keypress', function(){
		$('.radio_button').removeClass('checked');
      	$('.radio_button').parent().find('input').attr('aria-checked', false);
		if (!$(this).hasClass('checked')) {
			$(this).addClass('checked');
          	$(this).parent().find('input').attr('aria-checked', true);
		} else {
			$(this).removeClass('checked');
          	$(this).parent().find('input').attr('aria-checked', false);
		}
	});
	
	$('.checkout_tab.login').click(function(){
		$('.checkout_tab').removeClass('active').attr('aria-selected', false);
		$(this).addClass('active').attr('aria-selected', true);
		$('.checkout_login_form').addClass('opened');
	});
	
	$('.checkout_tab.guest').click(function(){
		$('.checkout_tab').removeClass('active').attr('aria-selected', false);
		$(this).addClass('active').attr('aria-selected', true);
		$('.checkout_login_form').removeClass('opened');
	});
	
	$('.checkout_tab.loginuser').click(function(){
		$('.checkout_tab').removeClass('active').attr('aria-selected', false);
		$(this).addClass('active').attr('aria-selected', true);
		$('.login_form_block').fadeIn().attr('state', 'expanded').attr('aria-hidden', 'false');
		$('.register_form_block').fadeOut().attr('state', 'collapsed').attr('aria-hidden', 'true');
        setPholder();
	});
	
	$('.checkout_tab.registeruser').click(function(){
		$('.checkout_tab').removeClass('active').attr('aria-selected', false);
		$(this).addClass('active').attr('aria-selected', true);
		$('.login_form_block').fadeOut().attr('state', 'collapsed').attr('aria-hidden', 'true');
		$('.register_form_block').fadeIn().attr('state', 'expanded').attr('aria-hidden', 'false');
        setPholder();
	});

	$('.show_more a').click(function(){
		if(!$(this).parent().hasClass('opened')){
          	$(this).parent().addClass("opened").attr('aria-expanded', true);
			$('.product_description').find('.more_text').addClass('opened').attr('state', 'expanded').css('max-height', ($('.product_description').find('.more_text .inner_text').innerHeight() + 50));
        }
		else{
          	$(this).parent().removeClass("opened").attr('aria-expanded', false);
			$('.product_description').find('.more_text').removeClass('opened').attr('state', 'collapsed').css('max-height', show_more_height);
		}
        $('.show_more a').attr('aria-hidden', false).show();
        $(this).attr('aria-hidden', true).hide();
        
	});

	if ($('.product_zoom_block').length > 0) {
		if(!device.mobile()){

		  	$('.tile')
		    .on('mouseover', function(){
				$(this).children('.zoom_block').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
		    })
		    .on('mouseout', function(){
				$(this).children('.zoom_block').css({'transform': 'scale(1)'});
		    })
		    .on('mousemove', function(e){
				$(this).children('.zoom_block').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
		    })
            .on('keyup', function(e){
            	var key = e.which;
              
                if(key == 13) {
                  $(this).children('.zoom_block').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
                }
              	if(e.key === "Escape" || e.keyCode == 27) {
                  $(this).children('.zoom_block').css({'transform': 'scale(1)'});
                }
                if(e.key === "ArrowUp"){
                  $(this).children('.zoom_block').css({'transform-origin': '50% 0'});
                }
              	if(e.key === "ArrowDown"){
                  $(this).children('.zoom_block').css({'transform-origin': '50% 100%'});
                }
              	if(e.key === "ArrowLeft"){
                  $(this).children('.zoom_block').css({'transform-origin': '0 50%'});
                }
              	if(e.key === "ArrowRight"){
                  $(this).children('.zoom_block').css({'transform-origin': '100% 50%'});
                }
            });
		}
	}
  
    

	if($('.homepage_content').length){
		loadAllBGImages($('.home_preloadimage'), function(){
			setTimeout(function(){
				$('.loader_start').css({'visibility':'hidden','opacity':'0'});
				$('.home_fold_block').addClass('show');
			}, 100);			
		});
	} else {
		if($('.catalog_preloadimage').length){
			loadAllBGImages($('.catalog_preloadimage'), function(){
				setTimeout(function(){
					$('.loader_start').css({'visibility':'hidden','opacity':'0'});
				}, 100);
			});
		}
		else{
			setTimeout(function(){
				$('.loader_start').css({'visibility':'hidden','opacity':'0'});
				//$('.header_top').css({"top": "0"});
			}, 100);
		}
	}

	function closeAllMenues(evt) {
		if(!$(evt.target).hasClass('login_button')){
            $('.login_block').removeClass('opened');
            $('.login_button').removeClass('opened');
        }
      	if(!$(evt.target).hasClass('submenu_button')){
            $('.has_submenu').removeClass('opened_menu');
          	if(window.innerWidth < 1024){
            	$('.has_submenu').find('.submenu_list').css('max-height', 0);
            }
            $('.has_submenu').find('.submenu_list').attr('state', 'collapsed').attr('aria-hidden', 'true');
            $('.has_submenu').find('.submenu_list a').attr('state', 'collapsed').attr('tabindex', '-1');
            $('.has_submenu').attr('aria-expanded', 'false');
            $('.has_submenu').parent().attr('aria-expanded', 'false');
        }
		if ($(".search_open_button").hasClass("opened")) {
			$(".search_open_button").removeClass("opened");
          	$('.search_form').attr('state', 'collapsed').attr('aria-hidden', 'true').attr('aria-expanded', 'false');
			$(".search_form").removeClass("opened");
          	$('.search_form input').attr('tabindex', '-1');
      		$('.search_form button').attr('tabindex', '-1');
			$(".search_form input").val("");
		}
	};

	$('body').click(closeAllMenues);

	
    $(document).keydown(function(e) {
        if (e.which == 32 && e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA') {
            return false;
        }
    });
	
	
	$(".search_open_button").on("click" , function(evt){
		closeAllMenues(evt);
		evt.stopPropagation();
      	$('.search_form input').attr('tabindex', 0);
      	$('.search_form button').attr('tabindex', 0);
      	$('.search_form').attr('state', 'expanded').attr('aria-hidden', 'false').attr('aria-expanded', 'true');
		$(this).addClass("opened").attr('aria-expanded', 'true');
		$(".search_form").addClass("opened");
	});

  
  
  	$(".search_open_button").on('keyup', function(evt){      
       if(evt.keyCode == 32){
           	closeAllMenues(evt);
            evt.stopPropagation();
            $('.search_form input').attr('tabindex', 0);
            $('.search_form button').attr('tabindex', 0);
            $('.search_form').attr('state', 'expanded').attr('aria-hidden', 'false').attr('aria-expanded', 'true');
            $(this).addClass("opened").attr('aria-expanded', 'true');
            $(".search_form").addClass("opened");
       }

       if (evt.key == "Escape") {
           if ($(".search_open_button").hasClass("opened")) {
              $(".search_open_button").removeClass("opened");
              $('.search_form').attr('state', 'collapsed').attr('aria-hidden', 'true').attr('aria-expanded', 'false');
              $(".search_form").removeClass("opened");
              $('.search_form input').attr('tabindex', '-1');
              $('.search_form button').attr('tabindex', '-1');
              $(".search_form input").val("");
              $(this).attr('aria-expanded', 'false');
          }
       }
  	});
  
  
    $(".icon-search").on('keyup', function(evt){ 
         if (evt.key == "Escape") {
             if ($(".search_open_button").hasClass("opened")) {
                $(".search_open_button").removeClass("opened");
                $('.search_form').attr('state', 'collapsed').attr('aria-hidden', 'false').attr('aria-expanded', 'true');
                $(".search_form").removeClass("opened");
                $('.search_form input').attr('tabindex', '-1');
                $('.search_form button').attr('tabindex', '-1');
                $(".search_form input").val("");
                $(this).attr('aria-expanded', 'false');
            }
         }
    });
  
  
	$(".search_form").on("click" , function(evt){
		evt.stopPropagation();
	});

	$('.login_button').hover(
      function(){
          $('.actions_list a').attr('tabindex', 0);
          $('.actions_list').attr('aria-hidden', 'false');
          $('.login_block').addClass('opened');
          $(this).addClass('opened').attr('aria-expanded', 'true');
      },
      function () {
          $('.actions_list a').attr('tabindex', '-1');
          $('.actions_list').attr('aria-hidden', 'true');
          $('.login_block').removeClass('opened');
          $(this).removeClass('opened').attr('aria-expanded', 'false');
      }
    );
  
  	$(".login_block.loggedin .login_button").on('keyup', function(evt){
      if(evt.keyCode == 32){
      	if(!$(this).hasClass('opened')){
          $('.actions_list a').attr('tabindex', 0);
          $('.actions_list').attr('aria-hidden', 'false');
          $('.login_block').addClass('opened');
          $(this).addClass('opened').attr('aria-expanded', 'true');
        }
      }
      if (evt.key == "Escape") {
      	$('.actions_list a').attr('tabindex', '-1');
        $('.actions_list').attr('aria-hidden', 'true');
        $('.login_block').removeClass('opened');
        $(this).removeClass('opened').attr('aria-expanded', 'false');
      }
    });
  
  	$('.login_block.loggedin .login_button').on('click keypress', function (e) {      
      if(!$(this).hasClass('opened')){
        $('.actions_list a').attr('tabindex', 0);
        $('.actions_list').attr('aria-hidden', 'false');
        $('.login_block').addClass('opened');
        $(this).addClass('opened').attr('aria-expanded', 'true');
      }
      else{
        $('.actions_list a').attr('tabindex', '-1');
        $('.actions_list').attr('aria-hidden', 'true');
        $('.login_block').removeClass('opened');
        $(this).removeClass('opened').attr('aria-expanded', 'false');
      }
    }); 

	$('.actions_list').click(function(evt){
		evt.stopPropagation();
	});

	


  	$('body').on('keypress', '.social_link', function (e) {
       var key = e.which;
       if(key == 13) {
            openSocialPopup($(this));
       }
    }); 



	$('body').on('click','.social_link', function(e){
		e.preventDefault();
      	openSocialPopup($(this));		
	});
  
  
  
  
  
     $( ".cart_item_quantity_input" ).change(function() {



      
       if(parseInt($(this).val())>0){
          $.post('/cart/change.js', {quantity: parseInt($(this).val()), id: $(this).attr('data-id')});
          var _sp= $(this).parent().parent().find('.line_price').html().substr(1);
          $(this).parent().parent().find('.line_total').attr({'role': 'status', 'aria-label': $(this).parent().parent().find('.cart_item_total').attr('aria-label')+' changed to $'+(parseInt($(this).val())*parseFloat(_sp)), 'aria-live': 'polite', 'aria-atomic': true}).html('$'+(parseInt($(this).val())*parseFloat(_sp)));
          var _subtt=0;
         $('.line_total').each(function(){
           _subtt+=parseFloat($(this).html().substr(1));
         })
         $('.subtotal_price').html('$'+_subtt);
       } else if(parseInt($(this).val())==0){
          var _url=$(this).parents('.cart_item').find('.cart_item_remove_url').attr('href');
          window.location.href=_url;
       }  
       
                
    });
  
    $('.cart_item_remove_url').click(function(){
		$(this).attr('aria-label', 'Product successfully removed from cart');
    });
  
  
  
   $('body').on('click','.social_add_to_cart', function(e){
    	e.preventDefault();
		if(!$(this).hasClass('strapadded')){
              var _this=$(this);
              var _vid=$(this).attr('data-id');
              var _items=[{quantity: 1, id:_vid }];

             var _gift_itm=CheckGiftItem($(this).attr('data-sku'));
              if(_gift_itm) _items.push({quantity: 1, id:_gift_itm});

                $.post('/cart/add.js', {items:_items})
               .done(function(msg){  })
                .fail(function(xhr, status, error) {
                 if(typeof xhr.responseText!="undefined"){
                   var _ss=JSON.parse(xhr.responseText);
                   if(typeof _ss.status!="undefined"){
                     if(_ss.status.toString()=="422" || _ss.status.toString()=="404"){
                       $.post('/cart/add.js', {quantity: 1, id:_vid});
                     }
                   }
                 }
                });

             // $(this).hide();
              $(this).html('ADDED').prop("disabled", true).css('pointer-events', 'none').attr({'aria-label': 'product '+$(this).data('title')+' added to cart', 'role': 'status'});
              var _count=$('#items_in_cart_count').html()!='' ? parseInt($('#items_in_cart_count').html())+1 : 1;
              if(_count>0){
                  $('.icon-bag').addClass('active');
              }
              $('#items_in_cart_count').html(_count);
              //$('.basket_button').attr('title','Products in cart - '+_count);
              $('.cart_bubble').addClass('active');
              setTimeout(function(){
                 $('.cart_bubble').removeClass('active');
                 if(_this.hasClass('incartupsell')) location.reload();
              }, 600); 
          }
        return false;
          
    });
  
  
  
   $('body').on('click','.coutura_car_buy_now', function(e){
    	e.preventDefault();
       $.post('/cart/add.js', {quantity: 1, id: 13344178044980}, function( data ) {
			window.location.href='/cart';
       }, "json");
        return false;
    });
  
  
   $('body').on('click','.prospex_buy_now', function(e){
    	e.preventDefault();
      var _vid=$(this).attr('data-id');
       var _items=[{quantity: 1, id: _vid}];

       var _gift_itm=CheckGiftItem( $(this).attr('data-sku'));
        if(_gift_itm) _items.push({quantity: 1, id:_gift_itm});
     

         $.post('/cart/add.js', {items:_items})
         .done(function(msg){  })
         .fail(function(xhr, status, error) {
           if(typeof xhr.responseText!="undefined"){
             var _ss=JSON.parse(xhr.responseText);
             if(typeof _ss.status!="undefined"){
               if(_ss.status.toString()=="422" || _ss.status.toString()=="404"){
                 $.post('/cart/add.js', {quantity: 1, id:_vid}, function( data ) {
                      window.location.href='/cart';
                 }, "json");
               } else {
                 window.location.href='/cart';
               }
             } else {
               window.location.href='/cart';
             }
           }
          });
     
        return false;
    });
  
  
  
   $('body').on('click','.productinfo_add_to_cart', function(e){
    	e.preventDefault();
     	var _vid=$(this).attr('data-id');
		 var _items=[{quantity: 1, id:_vid }];
        
     	var _gift_itm=CheckGiftItem( $(this).attr('data-sku'));
         if(_gift_itm) _items.push({quantity: 1, id:_gift_itm});
     
        if($('.add_to_cart_strap')[0]){
            $('.add_to_cart_strap').each(function(){
             if($(this).prop('checked')){  
                _items.push({quantity: 1, id:$(this).val()});
             }
          })
         }
     

         $.post('/cart/add.js', {items:_items})
         .done(function(msg){  })
          .fail(function(xhr, status, error) {
           if(typeof xhr.responseText!="undefined"){
             var _ss=JSON.parse(xhr.responseText);
             if(typeof _ss.status!="undefined"){
               if(_ss.status.toString()=="422" || _ss.status.toString()=="404"){
                 $.post('/cart/add.js', {quantity: 1, id:_vid});
               }
             }   
           }
          });
     
     
       if($(this).hasClass('co_add_to_cart')) {
         $(this).html('<span>ADDED</span>');
       } else {
         $(this).html('ADDED');
       }
     	$(this).prop("disabled", true).css('pointer-events', 'none').attr({'aria-label': 'product '+($(this).data('title')?$(this).data('title'):'')+' added to cart', 'role': 'status'}); 
        var _count=$('#items_in_cart_count').html()!='' ? parseInt($('#items_in_cart_count').html())+1 : 1;
     	if(_count>0){
			$('.icon-bag').addClass('active');
        }
        $('#items_in_cart_count, .cart_bubble').html(_count);
        //$('.basket_button').attr('title','Products in cart - '+_count);
        $('.cart_bubble').addClass('active');
        setTimeout(function(){
           $('.cart_bubble').removeClass('active');
        }, 600);
         
        return false;
    });
  
  
     $('body').on('click','.wishlist_remove_item', function(e){
		e.preventDefault();   
        var _handle=$(this).attr('data-handle');
        var _id=$(this).attr('data-id');
     	var _ind=_wished_products_handles.indexOf(_handle);
     	if(_ind>-1){
       		 _wished_products_handles.splice(_ind,1);
       		 $.cookie('wishlist',_wished_products_handles.join(','), { path: '/' });
  		 }
     	$('#'+_id).remove();
       if(!$('.cart_item')[0]){
       	   $('.wishlist_content').hide();
   	 		$('.wishlist_empty').show();
       }
    	return false;
    });
  
  
 	 $('body').on('click','.wishlist_add_to_cart', function(e){
    	e.preventDefault();
		var _vid=$(this).attr('data-id');
		 var _items=[{quantity: 1, id:_vid }];
        
     	var _gift_itm=CheckGiftItem( $(this).attr('data-sku'));
         if(_gift_itm) _items.push({quantity: 1, id:_gift_itm});

         $.post('/cart/add.js', {items:_items})
         .done(function(msg){  })
          .fail(function(xhr, status, error) {
           if(typeof xhr.responseText!="undefined"){
             var _ss=JSON.parse(xhr.responseText);
             if(typeof _ss.status!="undefined"){
               if(_ss.status.toString()=="422" || _ss.status.toString()=="404"){
                 $.post('/cart/add.js', {quantity: 1, id:_vid});
               }
             }
           }
          });
     
       
        var _count=$('#items_in_cart_count').html()!='' ? parseInt($('#items_in_cart_count').html())+1 : 1;
       	if(_count>0){
			$('.icon-bag').addClass('active');
        }
        $('#items_in_cart_count, .cart_bubble').html(_count); 
       //$('.basket_button').attr('title','Products in cart - '+_count);
        $('.cart_bubble').addClass('active');
        setTimeout(function(){
           $('.cart_bubble').removeClass('active');
        }, 600);
      
        var _handle=$(this).attr('data-handle');
     	var _ind=_wished_products_handles.indexOf(_handle);
       if(_ind>-1){
       		 _wished_products_handles.splice(_ind,1);
       		 $.cookie('wishlist',_wished_products_handles.join(','), { path: '/' });
       }
        $('#'+$(this).attr('data-id')).remove();    
       if(!$('.cart_item')[0]){
       	   $('.wishlist_content').hide();
   	 		$('.wishlist_empty').show();
       }
        return false;
    });
  
  
  
  
  
  $('body').on('click','.wishlist_add_all', function(e){
    	e.preventDefault();
      	$('.cart_item').each(function(){
             var _vid=$(this).attr('id');
          		var _items=[{quantity: 1, id:_vid}];

              var _gift_itm=CheckGiftItem($(this).attr('data-sku'));
               if(_gift_itm) _items.push({quantity: 1, id:_gift_itm});

               $.post('/cart/add.js', {items:_items})
               .done(function(msg){  })
                .fail(function(xhr, status, error) {
                 if(typeof xhr.responseText!="undefined"){
                   var _ss=JSON.parse(xhr.responseText);
                   if(typeof _ss.status!="undefined"){
                     if(_ss.status.toString()=="422" || _ss.status.toString()=="404"){
                       $.post('/cart/add.js', {quantity: 1, id:_vid});
                     }
                   }
                 }
                });
          
          
              var _count=$('#items_in_cart_count').html()!='' ? parseInt($('#items_in_cart_count').html())+1 : 1;
              $('#items_in_cart_count, .cart_bubble').html(_count);
          	  //$('.basket_button').attr('title','Products in cart - '+_count);
              $('.cart_bubble').addClass('active');
              setTimeout(function(){
                 $('.cart_bubble').removeClass('active');
              }, 600);
         	 // $(this).remove();
        });

        _wished_products_handles=[];
        $.cookie('wishlist','', { path: '/' });
    
   	 	 $('.wishlist_content').hide();
   	 	 $('.wishlist_empty').show();
    
        return false;
    });
  
   $('.product_block').mouseleave(function(e) {
     if(!$(e.target).hasClass('wishlist')){
     	$(this).removeClass('hover');
     }
   });
  
   $('body').on('click keypress', '.wishlist', function(e){
    	 e.preventDefault();	
     	 $(this).parent().addClass('hover');
     	 if(!$(this).hasClass('active')){
             var _handle=$(this).attr('data-handle');
              if(_wished_products_handles.indexOf(_handle)==-1){	
             		 _wished_products_handles.push(_handle);
             		$.cookie('wishlist',_wished_products_handles.join(','), { path: '/' });
              }
              $(this).addClass('active').attr('aria-pressed', true).attr('aria-label', 'Watch '+$(this).attr('data-handle')+' added to wishlist');
           
           	  var bubblethis = $(this);
           	  bubblethis.addClass('bubble');
              setTimeout(function(){
                	bubblethis.removeClass('bubble');
              }, 600);
             
         } else {
             var _handle=$(this).attr('data-handle');
             var _ind=_wished_products_handles.indexOf(_handle);
             if(_ind>-1){
                   _wished_products_handles.splice(_ind,1);
                   $.cookie('wishlist',_wished_products_handles.join(','), { path: '/' });
             }
             $(this).removeClass('active').attr('aria-pressed', false).attr('aria-label', 'Watch '+$(this).attr('data-handle')+' removed to wishlist');
           
           	 var bubblethis = $(this);
             bubblethis.addClass('bubble');
             setTimeout(function(){
              		bubblethis.removeClass('bubble');
             }, 600);
         }
             
         return false;
    });
  
	
    $('body').on('mouseenter mouseleave', '.shop_social .social_link', function(e) {
        $('.shop_social .social_link').not(this).stop(true).fadeTo('fast', e.type === 'mouseenter' ? 0.5 : 1);
    });
  
  $('.shopsocial_popupcont .popup_close').click(function(e){
    $('.social_link[aria-expanded=true]').focus();
  	//$('.social_link[data-index='+(parseInt($(this).parents('.popup_container').find('.focus_simulation').val())+1)+']').focus();
  	$('.social_link').attr('aria-expanded', false);
    $('.header, .top_banner, .footer, .home_fold_block, .categories_section, .shop_social, #maincontent > div[class!="popup_blocks"]').attr({'aria-hidden': false, 'tabindex': "0"});
  
  });
  
  $('.popup_blocks.video_tut .popup_close').click(function(e){
  	$('.download_manual_link').trigger('focus');
  });
  
  $('.popup_blocks.prod_video .popup_close').click(function(e){
  	$('.product_thumb.video').attr('aria-expanded', false);
  });


  
   $('.popup_close, .popup_close_span, .discount_info_popup_over').click(function(e){
		e.preventDefault();
        if(!$(this).hasClass('discount_close') && !$(this).hasClass('discount_info_popup_over') ){
          const header = document.querySelector('.header');
          const headerTop = document.querySelector('.header_top');

          header.style.zIndex = '21';
          headerTop.style.zIndex = '21';

            $(this).parents('.popup_container').removeClass('opened');	
            $(this).parents('.info_popup').removeClass('opened').attr('aria-hidden', 'true');
            $(this).parents('.popup_container').find('.product_image_block').css('background-size', '0 0');
                    	
          	
          	if($('.popup_container_video').length){
              $(this).parents('.popup_container_video').removeClass('opened');	
              $(this).parents('.info_popup_video').removeClass('opened');
              $('.info_popup_inner').html('');
              
             // myPlayerPopup.pause();
            }
          
            $('body').removeClass('y_hidden');
            if($('.info_popup_inner iframe').length){
              	player_vimeo.api('pause');
              	player_vimeo2.api('pause');
              	$('.video_tutorial').attr('state', 'collapsed').attr('aria-expanded', 'false');
                $('.info_popup_inner iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            }
        } else {
            $.cookie('popup'+$(this).data('id'),$(this).parents('.discount_info_popup').find('.discount_info_popup_title').html(), { path: '/' });
            $('.discount_info_popup').removeClass('opened');
        }
	});

	$('.info_popup, .info_popup_video').click(function(e) {
		if($(e.target).is('.cell_middle')){
			$('.popup_close').trigger('click');
		}
    });

    $('.product_thumb').on('click keypress', function(){
    	if($(this).data('image')){
          	gtag('event', 'product_thumbnail_click', {'event_category' : 'click','event_label' : $('.product_description .code').html()});
    		$('.product_thumb').removeClass('active');
    		$(this).addClass('active');
    		if($('.product_thumb.active').is(':first-child')){
    			$('.zoom_shadow').show();
    		}
    		else{
    			$('.zoom_shadow').hide();
    		}
          
          	$('.photo_zoom').html('<img src="'+$('.photo_zoom').attr('data-spin')+'" alt="Loading" title="" class="spinner" />');
          	$(document).find('.photo_zoom').css('background-image', 'none');	
          
          	var img = new Image();
            img.src = $(this).data('image');

            img.onload = function() {
              $('.photo_zoom').html('');
              $(document).find('.photo_zoom').css('background-image', 'url('+img.src+')');			
            }
    	}
    });
  
    if($('.photo_zoom').length){
      $('.photo_zoom').html('<img src="'+$('.photo_zoom').attr('data-spin')+'" alt="Loading" title="" class="spinner" />');
      
      
      var img = new Image();
      img.src = $('.photo_zoom').attr("data-src");

      img.onload = function() {
        $('.photo_zoom').addClass('loaded');
        $('.photo_zoom').css('background-image', 'url('+img.src+')');
        $('.photo_zoom').html('');
        $('.photo_zoom').next('.zoom_shadow').css('background-size', 'contain');				
      }
    }

    $('.product_thumb.video').on('click keypress', function(e){
    	e.preventDefault();

      const header = document.querySelector('.header');
          const headerTop = document.querySelector('.header_top');

          header.style.zIndex = '10';
          headerTop.style.zIndex = '10';
    	
    	if($(this).data('video')){
          if($('.luxeprds')[0]){
            $('.prod_video .info_popup_inner').html('<iframe id="vimeo-player2" tabindex="0" src="https://player.vimeo.com/video/'+$(this).data('video')+'?autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>');
          	iframe_vimeo2 = $('#vimeo-player2')[0];
			player_vimeo2 = $f(iframe_vimeo2);
          } else {
            $('.prod_video .info_popup_inner').html('<iframe tabindex="0" src="https://www.youtube.com/embed/'+$(this).data('video')+'?enablejsapi=1&rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
          }
        } else{
			$('.prod_video .info_popup_inner').html('<img src="'+$(this).data('image')+'" alt="'+$('.product_desc_cont').find('.code').html()+'" title="" />');
		}

		$('.product_media .prod_video.popup_blocks .info_popup_inner iframe').height($('.product_media .prod_video.popup_blocks .info_popup_inner').innerHeight());
		
		$(document).find('.product_media .prod_video .info_popup_inner').find('img').css("max-height", window.innerHeight-150);

		$('.prod_video .info_popup').addClass('opened').attr('aria-hidden', false);				
		$('body').addClass('y_hidden');			
		$('.loader_inner').css({'visibility':'hidden','opacity':'0'});
		$('.prod_video .popup_container').addClass('opened');
      	$(this).attr('aria-expanded', true);
    });
  
 	
    $('.video_tutorial').on('click keypress', function(e){
    	e.preventDefault();
      const header = document.querySelector('.header');
          const headerTop = document.querySelector('.header_top');

          header.style.zIndex = '10';
          headerTop.style.zIndex = '10';
          
      	$(this).attr('state', 'expanded').attr('aria-expanded', 'true');
     	$('.video_tut .info_popup_inner').html('<iframe id="vimeo-player" tabindex="0" src="https://www.youtube.com/embed/'+$(this).data('video')+'?enablejsapi=1&rel=0&amp;controls=1&amp;showinfo=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
         
        $('.video_tut.popup_blocks .info_popup_inner iframe').height($('.video_tut.popup_blocks .info_popup_inner').innerHeight());
		
		$(document).find('.video_tut .info_popup_inner').find('img').css("max-height", window.innerHeight-150);
        
        $('.video_tut .info_popup').addClass('opened').attr('aria-hidden', false);				
		$('body').addClass('y_hidden');			
		$('.loader_inner').css({'visibility':'hidden','opacity':'0'});
		$('.video_tut .popup_container').addClass('opened');
      
      	iframe_vimeo = $('#vimeo-player')[0];
		player_vimeo = $f(iframe_vimeo);
        
       // myPlayerPopup.play();
      
    });
  
  
  
  	
  
  
	$('.filter_sort_block span').on('click keypress', function(){
		if($(this).hasClass('opened')){
			$('.collections_filter').removeClass('opened');
			$('.filter_sort_block span').removeClass('opened');
			$(this).removeClass('opened');
			$('.filter_dropdown').removeClass('opened').attr('state', 'collapsed').attr('aria-hidden', true).attr('hidden', true);
			$('.filter_dropdown .tab_content').removeClass('active').attr('aria-hidden', true);
			$('.filter_dropdown').height(0);
          	$('.filter_dropdown a').attr('tabindex', '-1');
          	$('.filter_dropdown .filter_close').html('');
          	$(this).attr({'aria-expanded': false,  'aria-selected': false});
		}
		else{
			$('.collections_filter').addClass('opened');
			$('.filter_sort_block span').removeClass('opened');
			$('.filter_dropdown .tab_content').removeClass('active').attr('aria-hidden', true);
			$(this).addClass('opened');
			$('.filter_dropdown').addClass('opened').attr('state', 'expanded').attr('aria-hidden', false).removeAttr('hidden');
			$('.filter_dropdown .tab_content.'+$(this).data('type')).addClass('active').attr('aria-hidden', false);
			var block_height = $('.filter_dropdown .tab_content.'+$(this).data('type')+' ul').height();
			$('.filter_dropdown').height(block_height+65);
          	$('.filter_dropdown a').attr('tabindex', 0);
          	$('.filter_dropdown .filter_close').attr({'aria-hidden': false, 'aria-label': 'Close '+$(this).attr('aria-label'), 'data-title': $(this).attr('aria-label')}).html('close '+$(this).html()+' closed');
          	$('.filter_sort_block span').attr({'aria-expanded': false,  'aria-selected': false});
          	$(this).attr({'aria-expanded': true,  'aria-selected': true});

		}
      	if(window.innerWidth < 640){
          $('.filter_dropdown .tab_content > ul > li').find('span').attr('aria-expanded', false);
          $('.filter_dropdown .tab_content > ul > li').find('ul').attr('aria-hidden', true);
          $('.filter_dropdown .tab_content > ul > li').removeClass('opened');
        }
      	block_height_resp = $('.tab_content.active ul').height();
	});

  	$('.filter_sort_block span').keydown(function(e) {
      var code = e.keyCode || e.which;
      if ($(this).hasClass('opened') && !e.shiftKey && code == '9') {
        if(window.innerWidth > 640){
        	$('.filter_close').focus();
        }
        else{
        	$('.tab_content.active li.vis_filter').first().find('span').focus();
        }
        return false;
      }
    });
  
  	$('.clear_filters').keydown(function(e) {
      var code = e.keyCode || e.which;
      if (!e.shiftKey && code == '9') {
        if($('.filter_sort_block span[data-type="filters_block"]').hasClass('opened')){
          $('.filter_sort_block span').last().focus();
          return false;
        }
      }
    });
  	
  	$('.filter_sort_block span').last().keydown(function(e) {
      var code = e.keyCode || e.which;
      if (!e.shiftKey && code == '9') {
        if ($(this).hasClass('opened')){
          $('.filter_close').focus();
        }
        else{
			$('.product_link_in_list').first().focus();
        }
        return false;
      }
    });
  	
  
	$('.filter_close').click(function(e){
		e.preventDefault();
      	//$(this).attr({'role': 'status', 'aria-live': 'polite', 'aria-atomic': true, 'aria-label': $(this).data('title')});
      	$('.filter_sort_block span.opened').focus();
    	$('.collections_filter').removeClass('opened');
		$('.filter_sort_block span').removeClass('opened');
		$('.filter_dropdown').removeClass('opened').attr('state', 'collapsed').attr('aria-hidden', true).attr('hidden', true);
		$('.filter_dropdown .tab_content').removeClass('active').attr('aria-hidden', true);
		$('.filter_dropdown').height(0);
        $('.filter_sort_block span').attr({'aria-expanded': false,  'aria-selected': false});
      	$(this).attr('aria-hidden', true);
        if(window.innerWidth < 640){
          $('.filter_dropdown .tab_content > ul > li').find('span').attr('aria-expanded', false);
          $('.filter_dropdown .tab_content > ul > li').find('ul').attr('aria-hidden', true);
        }
    });
  

  

	if($('#video_1').length){
		var myPlayer = videojs("video_1", {"controls": true, "autoplay": true, "muted": true, "preload": "auto"}, function(){
			var player = this;
			player.on('ended', function() {	
              this.play();
			}).on('seeking', function (e) {												
			}).on('play', function (e) {						
			}).on('pause', function(e) {												
			});
		});
	}
  
    if($('#video_1_m').length){
          var myPlayer_m = videojs("video_1_m", {"controls": true, "autoplay": true, "muted": true, "preload": "auto"}, function(){
              var player_m = this;
              player_m.on('ended', function() {	
                this.play();
              }).on('seeking', function (e) {												
              }).on('play', function (e) {						
              }).on('pause', function(e) {												
              });
          });
      }
  
  	if($('#video_2').length){
		var myPlayer2 = videojs("video_2", {"controls": true, "autoplay": false, "muted": true, "preload": "auto"}, function(){
			var player = this;
			player.on('ended', function() {	
              this.play();
			}).on('seeking', function (e) {												
			}).on('play', function (e) {					
			}).on('pause', function(e) {												
			});
		});	
      	
      	if(device.mobile()){
          var touchmoved2;
          $('#video_2_html5_api').on('touchend', function(e){
              if(touchmoved2 != true){
                  if (myPlayer2.paused()) {
                    myPlayer2.play();
                  }
                  else {
                    myPlayer2.pause();
                  }
              }
          }).on('touchmove', function(e){
              touchmoved2 = true;
          }).on('touchstart', function(){	
              touchmoved2 = false;
          });
        }
	}
  
  
  	if($('#video_5').length){
		var myPlayer = videojs("video_5", {"controls": true, "autoplay": true, "muted": true}, function(){
			var player = this;
			player.on('ended', function() {	
              this.play();
			}).on('seeking', function (e) {												
			}).on('play', function (e) {						
			}).on('pause', function(e) {												
			});
		});
	}
  
  
  	
  	var myPlayerS = [];
    $('.series_video_block').each(function(key, val){
      
      if($(this).find('video').length){
        var video_id = $(this).find('video').attr('id');
        myPlayerS[key] = videojs(video_id, {"controls": false, "autoplay": false, "muted": true, "preload": "auto"}, function(){
			var player = this;
			player.on('ended', function() {	
              this.play();
			}).on('seeking', function (e) {												
			}).on('play', function (e) {	 			
			}).on('pause', function(e) {	 										
			});
		});	
        
        if(!device.mobile()){   
          
          $('.video_fake_poster').hover(
          	function(){
                myPlayerS[key].play();
              	$(this).parents('.series_video_block').find('.video_fake_poster').hide();
            },
            function () {
                myPlayerS[key].pause();
              	$(this).parents('.series_video_block').find('.video_fake_poster').show();
            }
          );
          
          
          $('.'+video_id).hover(
            function(){
                myPlayerS[key].play();
              	$(this).parents('.series_video_block').find('.video_fake_poster').hide();
            },
            function () {
                myPlayerS[key].pause();
              	//$(this).parents('.series_video_block').find('.video_fake_poster').show();
            }
          );
        }
        else{

          var touchmoved;
          
           $('.video_fake_poster').on('click', function(){
             
               myPlayerS[key].play();
               $(this).parents('.series_video_block').find('.video_fake_poster').hide();
             
             
           });
          
          $('.'+video_id).on('touchend', function(e){
              if(touchmoved != true){
                  if (myPlayerS[key].paused()) {
                    myPlayerS[key].play();
                  }
                  else {
                    myPlayerS[key].pause();
                  }
              }
          }).on('touchmove', function(e){
              touchmoved = true;
          }).on('touchstart', function(){
              touchmoved = false;
          });
      	}
        
      }
    });
	

	$(window).resize(function() {
      
      	/************************************** one piece **************************/
      
      	
      
        if($('.one_p_gallery').length){
          
            /*if(window.innerWidth > 768){
              setTimeout(function(){
                $('.one_p_slider_bg').height($('.one_p_gallery_person').height()+50);
              },100);
            }*/

            _one_p_corusel = $('.one_p_gallery').flickity({
                pageDots: true,
                wrapAround: true,
                draggable: true,
                pauseAutoPlayOnHover: false,
                //autoPlay: 4000
            });

            $('.one_p_gallery .flickity-page-dots .dot').attr('tabindex', 0);
            _one_p_corusel.on('cellSelect', function() {
              $('.one_p_gallery_cell.is-selected').attr('aria-label', $('.one_p_gallery_cell.is-selected').attr('aria-label')+' current slide');
              $('.one_p_gallery .flickity-page-dots .dot').attr('aria-pressed', false);
              $('.one_p_gallery .flickity-page-dots .dot.is-selected').attr('aria-pressed', true);
            });

            $('.one_p_gallery .flickity-page-dots .dot').keydown(function(e) {
              var code = e.keyCode || e.which;
              if(code == 13) {
                var index = $(this).index();
                $('.one_p_gallery .flickity-page-dots .dot').removeClass('is_selected');
                $(this).addClass('is_selected');
                _one_p_corusel.flickity('select', index);
              }
            });



            $('.one_p_gallery .flickity-page-dots .dot').focusin(function(e) {
                var index = $(this).index();
                $('.one_p_gallery .flickity-page-dots .dot').removeClass('is_selected');
                $(this).addClass('is_selected');
                _one_p_corusel.flickity('select', index);
            });

        }

          /************************************** one piece end **************************/
      
      
        if(window.innerWidth > 768){				
			$('.turtle_text').height($('.turtle_image').innerHeight());			
		}
      	if($('.turtle_gallery .flickity-page-dots').length){

			if(window.innerWidth>768){
				if($('.turtle_text').height()>$('.turtle_text_block').height()+50){
					var offset_turtle = 20;
				} else{
					var offset_turtle = 0;
				}

              	var turtle_off = ($('.turtle_text').height()-$('.turtle_text_block').height())/2;
				$('.turtle_gallery .flickity-page-dots').css({'left': $('.turtle_text_block').offset().left-10, 'top': (turtle_off+turtle_off/2+$('.turtle_text_block').height()-50)});
			}
			else{
				$('.turtle_gallery .flickity-page-dots').removeAttr('style');
			}
          	
		}
      
      	if($('.turtle_gallery').length){
		_turtle_corusel = $('.turtle_gallery').flickity({
			pageDots: true,
			wrapAround: true,
			draggable: true,
          	pauseAutoPlayOnHover: false,
          	//autoPlay: 4000
		});
      
     	$('body').on('click', '.turtle_gallery .flickity-page-dots .dot', function (e) {
           var index = $(this).index();
           var turtle_off = ($('.turtle_gallery_cell').eq(index).find('.turtle_text').height()-$('.turtle_gallery_cell').eq(index).find('.turtle_text_block').height())/2;
           $('.turtle_gallery .flickity-page-dots').css({'top': (turtle_off+turtle_off/2+$('.turtle_gallery_cell').eq(index).find('.turtle_text_block').height()-50)});
        });
      
		if(window.innerWidth>768){
			if($('.turtle_gallery .flickity-page-dots').length){
				if($('.turtle_text').height()>$('.turtle_text_block').height()+50){
					var offset_turtle = 20;
				} else{
					var offset_turtle = 0;
				}
				var turtle_off = ($('.turtle_text').height()-$('.turtle_text_block').height())/2;
				$('.turtle_gallery .flickity-page-dots').css({'left': $('.turtle_text_block').offset().left-10, 'top': (turtle_off+turtle_off/2+$('.turtle_text_block').height()-50)});
			}
		}

      
      	$('.turtle_gallery .flickity-page-dots .dot').each(function(){
          $(this).attr({'aria-label': 'Slide '+($(this).index()+1), 'aria-controls': "Collection-carousel-items", 'role': 'button'});
        });


        $('.turtle_gallery .flickity-page-dots .dot').attr('tabindex', 0);
        _turtle_corusel.on('cellSelect', function() {
          $('.turtle_gallery_cell.is-selected').attr('aria-label', $('.turtle_gallery_cell.is-selected').attr('aria-label')+' current slide');
          $('.turtle_gallery .flickity-page-dots .dot').attr('aria-pressed', false);
          $('.turtle_gallery .flickity-page-dots .dot.is-selected').attr('aria-pressed', true);
        });

        $('.turtle_gallery .flickity-page-dots .dot').keydown(function(e) {
          var code = e.keyCode || e.which;
          if(code == 13) {
            var index = $(this).index();
            $('.turtle_gallery .flickity-page-dots .dot').removeClass('is_selected');
            $(this).addClass('is_selected');
            _turtle_corusel.flickity('select', index);
          }
        });



        $('.turtle_gallery .flickity-page-dots .dot').focusin(function(e) {
            var index = $(this).index();
            $('.turtle_gallery .flickity-page-dots .dot').removeClass('is_selected');
            $(this).addClass('is_selected');
            _turtle_corusel.flickity('select', index);
        });


        $('.turtle_gallery .turtle_text_block .standard_button:not(.learn_more)').focusin(function(e) {
          	e.stopPropagation();
          	e.preventDefault();
          	
            var index = $(this).parents('.turtle_gallery_cell').index();
          console.log(index);
          	_turtle_corusel.flickity('select', index);
          
          setTimeout(function(){
          	$('.turtle_gallery .flickity-viewport').css('position', 'static');
            setTimeout(function(){
              $('.turtle_gallery .flickity-viewport').css('position', 'relative');
            },10);
          },100);
          
          	return false;
        });
      

	}
      
      	if($('#video_col5').length){
          $('.popup_container').height($('#video_col5').innerHeight());
        }

        if($('.img_block5').length){
          $('.img_block5').each(function(){
              $(this).find('img').height($(this).find('div').innerHeight()+20);
          });
        }
      
        /*if($('.home_fold_block .flickity-page-dots').length){
          $('.home_fold_block .flickity-page-dots').css('bottom', ($('.home_fold_block .carousel_text_block').height() + 30));
        }*/
      
      	if($('.page-collection_luxe .catalog_top_image_block').length && $('.collections_filter .collection_logo')[0]){
            $('.page-collection_luxe .catalog_top_image_block').css('left', $('.collections_filter .collection_logo').offset().left);
        }
      
        if(window.innerWidth > 640){
          if($('.series_prod_block').length){
              $('.series_prod_block').height($('.series_video_block').height());
          }
        }
        else{
          $('.series_prod_block').height($('.series_prod_block .product_image_block').innerHeight() + $('.series_prod_block .product_name_price').innerHeight() + $('.series_prod_block .standard_button').innerHeight() + 30);
        }
      
      
      	if($('.cart_tour_left').height()){
          if(window.innerWidth > 480){
            setTimeout(function(){
              $('.cart_tour_right').height($('.cart_tour_left').height());
              $('.tour_block.tour2, .tour_block.tour3, .tour_block.tour4, .tour_block.tour5').height($('.cart_tour_left').height()/2);
            }, 100);
          }
          else{
			  $('.cart_tour_right').height('inherit');
              $('.tour_block.tour2, .tour_block.tour3, .tour_block.tour4, .tour_block.tour5').height('inherit');
          }
        }

      	if($('.top_banner').length && $('.parallax_bg').length){
          if(window.innerWidth < 768){
          	$('.parallax_bg').css('top', $('.top_banner').innerHeight()+54);
          }
          else{
            $('.parallax_bg').css('top', $('.top_banner').innerHeight()+60);
          }
        }
      
        if($('.vjs-tech').length){
          if(window.innerWidth<480){
           	$('.vjs-tech').attr('playsinline', 'true'); 
          }
          else{
            $('.vjs-tech').removeAttr('playsinline');
          }
        }
		
		/*if($('.corporate_container .half_col').length){
			equalheight($('.corporate_container .half_col'));
		}
		if($('.support_tab_block.service .third_col').length){
			equalheight($('.support_tab_block.service .flexbox .third_col'));
		}*/
      
		if($('.content').length && !$('.login_container').length && $('.support_block').length){
			contentHeight();
		}
	  
      
      	if(window.innerWidth > 640 && window.innerHeight > 800){
          if($('.shopify-challenge__container').length){
            $('.shopify-challenge__container').css('height', window.innerHeight - $('.header').innerHeight() - $('.footer').innerHeight());
          }
        }
      
        if((window.innerWidth - $('.main_menu_inner').width())<200){
          $('.header .close_menu_button').css('width', (window.innerWidth - $('.main_menu_inner').width())).attr('tabindex', 0);
        }	
      	
		 
		$('.faq_col.active').find('.answer').animate({ height: $('.faq_col.active').find('.answer').find('span').height()+20 }, 50);

		$('.product_media .popup_blocks .info_popup_inner iframe').height($('.product_media .popup_blocks .info_popup_inner').innerHeight());
		
		
		$('.footer_newsletter input').keypress(function(){
			if($(this).val().length*8 >= $(this).width()){
				var fontsize = parseFloat($(this).css('font-size'));
				if(fontsize>12){
					$(this).css('font-size', (fontsize-2)+'px');
				}
				else{
					if($(this).val().length*5 >= $(this).width()-5){
						$(this).attr('maxlength', $(this).val().length);
					}
				}
			}
		});
		
		var fold_height_content = window.innerHeight-$('.header_top').height();
      
        if($('.content').height()<fold_height_content){
          $('.login_container').height(fold_height_content);
        }
        else{
          $('.login_container').css('padding', '40px 0');
        }
      
        if($('.content').height()<fold_height_content){
          $('.error_container').height(fold_height_content);
        }
        else{
        	$('.error_container').css('padding', '40px 0');
        }
		$('.search_page_content').css('min-height', fold_height_content-$('footer').height()-20);

		
		
		if(window.innerWidth < 1024){
     	 	$('.has_submenu a').attr({'role': 'button', 'aria-pressed': false});
          
          	$('.has_submenu .submenu_button').on('keyup', function(evt){
              evt.preventDefault();
              console.log(evt);
              if(evt.keyCode == 32){
                if(!$(this).parent().hasClass('opened_menu')){
					$('.has_submenu').removeClass('opened_menu');
					$(this).parent().addClass('opened_menu');
                  	var li_height = '';
                    $(this).parent().find('.submenu_list > li').each(function(){
						li_height = (parseInt(li_height) || 0)+$(this).height();
                    });
                    $(this).parent().find('.submenu_list').css('max-height', li_height);
                  	$(this).parent().find('.submenu_list').attr('state', 'expanded').attr('aria-hidden', 'false');
					$(this).parent().find('.submenu_list a').attr('state', 'expanded').attr('tabindex', '0');
                  	$(this).attr({'aria-expanded': 'true', 'aria-pressed': true});
                  	$(this).parent().attr('aria-expanded', 'true');
                }
              }
              if (evt.key == "Escape") {
                $(this).parent().removeClass('opened_menu');
                $(this).parent().find('.submenu_list').css('max-height', 0).attr('state', 'collapsed').attr('aria-hidden', 'true');
                $(this).parent().find('.submenu_list a').attr('state', 'collapsed').attr('tabindex', '-1');
                $(this).attr({'aria-expanded': 'false', 'aria-pressed': false});
                $(this).parent().attr('aria-expanded', 'false');
              }
            });
          
			$('.has_submenu .submenu_button').unbind('click').click(function(e){			
				e.preventDefault();
				if($(this).parent().hasClass('opened_menu')){
					$(this).parent().removeClass('opened_menu');
					$(this).parent().find('.submenu_list').css('max-height', 0).attr('state', 'collapsed').attr('aria-hidden', 'true');
					$(this).parent().find('.submenu_list a').attr('state', 'collapsed').attr('tabindex', '-1');
                  	$(this).attr({'aria-expanded': 'false', 'aria-pressed': false});
                  	$(this).parent().attr('aria-expanded', 'false');
                }
				else{
					$('.has_submenu').removeClass('opened_menu');
					$(this).parent().addClass('opened_menu');
                  	var li_height = '';
                    $(this).parent().find('.submenu_list > li').each(function(){
						li_height = (parseInt(li_height) || 0)+$(this).height();
                    });
                    $(this).parent().find('.submenu_list').css('max-height', li_height);
                  	$(this).parent().find('.submenu_list').attr('state', 'expanded').attr('aria-hidden', 'false');
					$(this).parent().find('.submenu_list a').attr('state', 'expanded').attr('tabindex', '0');
                  	$(this).attr({'aria-expanded': 'true', 'aria-pressed': true});
                  	$(this).parent().attr('aria-expanded', 'true');
				}
			});
		}
        else{
          $('.has_submenu').hover(function(){
            if($(this).find('.submenu_list').height() == 0){
                $(this).find('.submenu_list a').attr('tabindex', 0);
              	$(this).find('.submenu_list').attr('state', 'expanded').attr('aria-hidden', 'false');
              	$(this).find('.submenu_list a').attr('state', 'expanded');
              	$(this).addClass('opened_menu');
              	$(this).attr('aria-expanded', 'true');
              	$(this).find('.submenu_button').attr('aria-expanded', 'true');
            }
            else{
                $(this).find('.submenu_list a').attr('tabindex', '-1');
              	$(this).find('.submenu_list').attr('state', 'collapsed').attr('aria-hidden', 'true');
              	$(this).find('.submenu_list a').attr('state', 'collapsed');
              	$(this).removeClass('opened_menu');
              	$(this).attr('aria-expanded', 'false');
              	$(this).find('.submenu_button').attr('aria-expanded', 'false');
            }
          });
          
          $(".has_submenu").on('keyup', function(evt){
            if(evt.keyCode == 32){
              if(!$(this).hasClass('opened_menu')){
                $(this).find('.submenu_list a').attr('tabindex', 0);
                $(this).find('.submenu_list').attr('state', 'expanded').attr('aria-hidden', 'false');
                $(this).find('.submenu_list a').attr('state', 'expanded');
                $(this).addClass('opened');
                $(this).attr('aria-expanded', 'true');
                $(this).find('.submenu_button').attr('aria-expanded', 'true');
              }
            }
          	if (evt.key == "Escape") {
              $(this).find('.submenu_list a').attr('tabindex', '-1');
              $(this).find('.submenu_list').attr('state', 'collapsed').attr('aria-hidden', 'true');
              $(this).find('.submenu_list a').attr('state', 'collapsed');
              $(this).removeClass('opened_menu');
              $(this).attr('aria-expanded', 'false');
              $(this).find('.submenu_button').attr('aria-expanded', 'false');
            }
          });    
          
          $('.has_submenu').on('click keypress', function (e) {            
            if(!$(this).hasClass('opened_menu')){
              $(this).find('.submenu_list a').attr('tabindex', 0);
              $(this).find('.submenu_list').attr('state', 'expanded').attr('aria-hidden', 'false');
              $(this).find('.submenu_list a').attr('state', 'expanded');
              $(this).addClass('opened_menu');
              $(this).attr('aria-expanded', 'true');
              $(this).find('.submenu_button').attr('aria-expanded', 'true');
            }
            else{
              $(this).find('.submenu_list a').attr('tabindex', '-1');
              $(this).find('.submenu_list').attr('state', 'collapsed').attr('aria-hidden', 'true');
              $(this).find('.submenu_list a').attr('state', 'collapsed');
              $(this).removeClass('opened_menu');
              $(this).attr('aria-expanded', 'false');
              $(this).find('.submenu_button').attr('aria-expanded', 'false');
            }
          }); 
        }


		setTimeout(function(){
          cartItemPhotoWidth();
		}, 300);

      if(window.innerWidth > 768){
		if($('.parallax_bg').length){
			$('.parallax_bg').height($('.catalog_top_image').innerHeight() + 10);
		}
      }
      else {
        console.log('else');
        if($('.parallax_bg').length){
			$('.parallax_bg').height($('.catalog_top_image').innerHeight() - 30);
		}
      }

		$('.catalog_top_image').find('iframe').height($('.catalog_top_image').innerHeight());
		//$('.video-js .vjs-tech').css('margin-top', -(($('.video_viewport').innerHeight())/2)+'px');
		$('.vjs-loading-spinner').css('top', ($('.video_viewport').innerHeight()/2)+'px');
      
        if($('.video_viewport').length){
          $('.vjs-control-bar').css('top', ($('.video_viewport').innerHeight()+70)+'px').attr('aria-label', 'Video control buttons');
        }

      	
      	
     	$('#shopify-section-prospex-street-video-2019 .vjs-control-bar .vjs-play-control').appendTo('.video_bar_buttons');
      	$('#shopify-section-prospex-street-video-2019 .vjs-control-bar .vjs-volume-menu-button').appendTo('.video_bar_buttons');
      	

		if(window.innerWidth > 768){				
			$('.story_text').height($('.story_image').innerHeight());			
		}
		var timelineWidth = $('.story_gallery_nav li').innerWidth()*$('.story_gallery_nav li').length;
		if(timelineWidth>=window.innerWidth){
			$('.story_gallery_nav').css('overflow-x', 'scroll');
			$('.story_gallery_nav').scrollLeft($('.story_gallery_nav .is_selected').offset().left-((window.innerWidth-66)/2));
		}
		else{
			$('.story_gallery_nav').css('overflow-x', 'hidden');
		}
		
		

		var fold_height = window.innerHeight-$('.header_top').height();		

      
      
      	if($('.findstore').length){
			
			if(window.innerWidth > 640){
				$('.l_map_wrap_right').css('height', fold_height_content);
				$('.l_map_wrap_left_scrl').css('height', $('.l_map_wrap_right').height()-$('.l_map_wrap_left .store_form').innerHeight() - 60);
			}
			else{
                $('.filter_selection').html('Filter');
				$('.mobile_map_helper').css('height', '220px');
                $('.l_map_wrap_left_scrl').css('height', fold_height - $('.mobile_map_helper').height() - $('.store_form').height() + 40);
			}
			
			
			if(window.innerWidth > 640){
				$('#mapid').css({'height': $('.l_map_wrap_right').height(), 'width': window.innerWidth-$('.l_map_wrap_left').innerWidth()});
			}
			else{
              	$('#mapid_mobile').css({'height': $('.mobile_map_helper').height(), 'width': window.innerWidth});
			}
          
          	
		}

      // store locator filter selection new code
      // store locator new code
       $(".filter_selection").on("click", function () {
        const $filter = $(".collections_filter_s");
        const $this = $(this);
        const isOpen = $filter.hasClass("active");
      
        if (!isOpen) {
          $filter
            .addClass("active")
            .css({ display: "block" }) // set display explicitly
            .stop()
            .animate({ height: $filter.get(0).scrollHeight, opacity: "1" }, 300);
          $this.addClass("active").find(".arrow").html("&#9652;"); // ▲
        } else {
          $filter
            .removeClass("active")
            .stop()
            .animate({ height: 0, opacity: "0" }, 300, function () {
              $filter.css({ display: "none" });
            });
          $this.removeClass("active").find(".arrow").html("&#9662;"); // ▼
        }
            });
      
        $("body").on("click touchstart", function (event) {
          const $filter = $(".collections_filter_s");
          const $trigger = $(".filter_selection");
        
          if ($trigger.hasClass("active")) {
            if (
              !$(event.target).closest(".collections_filter_s").length &&
              !$(event.target).closest(".filter_selection").length
            ) {
              $filter
                .removeClass("active")
                .stop()
                .animate({ height: 0, opacity: "0" }, 300, function () {
                  $filter.css({ display: "none" });
                });
              $trigger.removeClass("active").find(".arrow").html("&#9662;");
            }
          }
        });
      
        // $('.filter_selection').on('click', function(){
        //     if($('.collections_filter_s').height() == 0){
        //       $('.collections_filter_s').addClass('active').stop().animate({"height": 140, "opacity":"1"}, 400);
        //       $(this).addClass('active');
        //     }	
        //     else{
        //       $('.collections_filter_s').removeClass('active').stop().animate({"height": 0, "opacity":"0"}, 400);
        //       $(this).removeClass('active');
        //     }
        // });
      
        // if($('.filter_selection').length){
        //   $('body').on('click touchstart', function (event) {
        //       if($('.filter_selection').hasClass('active')){
        //         if (!$(event.target).closest('.addresses_drop').length && !$(event.target).closest('.collections_filter_s').length && !$(event.target).closest('.filter_selection').length) {
        //           $('.collections_filter_s').removeClass('active').stop().animate({"height": 0, "opacity":"0"}, 400);
        //           $('.filter_selection').removeClass('active');
        //         }
        //       }
        //   });
        // }
      
      
      
      
      
      
		if(window.innerWidth > 768){
			
            $('.product_description').find('.more_text').css("max-height", 217);
            show_more_height = 217;
			

            if(!$('.links').length){
            	$('.product_zoom_block').height($('.product_description').height()/2+380);
            }
            else{
              	$('.product_zoom_block').height($('.product_description').height()/2+280);
            }

			$('.product_thumb').height($('.product_thumb').width());
			$('.product_data').height(fold_height-80);

			setTimeout(function(){
				if(fold_height>($('.product_description').height()+40)){
					var margin_top = ($('.product_description').height()-$('.product_media').height())/2;
				}
				else{
					var margin_top = ((fold_height-$('.product_media').height())/2)+40;
				}
				$('.product_media').css('margin-top', margin_top);
			}, 100);
			
			$('.product_thumbs_container').height($('.product_image_container').height());		
          
            if(!$('.links').length){
			  $('.product_zoom_container').height($('.product_description').innerHeight()+100);
            }
            else{
              $('.product_zoom_container').height($('.product_description').innerHeight());
            }
			
			$('.story_gallery_nav').height('inherit');
			$('.story_gallery').css('margin-top', '0');
		} else{
          	if(window.innerWidth > 420){
              $('.product_description').find('.more_text').css("max-height", 190);
              show_more_height = 190;
            }
            else{
              $('.product_description').find('.more_text').css("max-height", 170);
              show_more_height = 170;
            }
			$('.product_media').css('margin-top', 'inherit');
			$('.product_zoom_block').css('height', 'inherit');
			$('.product_thumbs_container').css('height', 'inherit');	
			$('.product_data').css("height", "inherit");
		
			$('.story_gallery_nav').height($('.story_gallery_cell.is-selected .story_image').innerHeight()+$('.story_gallery_nav li').innerHeight()+2);
			$('.story_gallery').css('margin-top', $('.story_gallery_nav li').innerHeight());
		}

		/*if(window.innerWidth > 1280){
			$('.zoom_shadow').css({'left': $('.zoom_block').innerWidth()/2-50, 'margin-left': -$('.zoom_block').innerWidth()/2});
		}
		else if(window.innerWidth > 1024  && window.innerWidth <= 1280){
			$('.zoom_shadow').css({'left': $('.zoom_block').innerWidth()/2-20, 'margin-left': -$('.zoom_block').innerWidth()/2});
		}
		else{
			$('.zoom_shadow').css({'left': $('.zoom_block').innerWidth()/2+40, 'margin-left': -$('.zoom_block').innerWidth()/2});
		}*/
		
		if($('.more_text .inner_text').innerHeight() > $('.more_text').innerHeight()){
			$('.show_more').fadeIn();
          	$('.more_text').addClass('longtext');
		}
		else{
			$('.show_more').fadeOut();
          	$('.more_text').removeClass('longtext');
		}

		var block_height = $('.filter_dropdown .tab_content.active ul').height();
		$('.filter_dropdown').height(block_height+80);		

		if($('.home_fold_block').length){
			if(!device.mobile()){
				if(window.innerWidth > 768){
					$('.home_fold_block, .home_fold_block .carousel-cell').height(window.innerHeight-$('.header_top').height()-$('.top_banner').innerHeight());
				} 
                else{
					$('.home_fold_block .carousel-cell').height(window.innerHeight-$('.header_top').height()-$('.top_banner').innerHeight());
					$('.home_fold_block.mobile').css('height', 'auto');
				}
			}
		}

		setTimeout(function(){
			if(window.innerWidth > 768){
              
              if($('.page-page_luxe').length && window.innerHeight>$('body').innerHeight()){
              	$('.footer_newsletter').height(window.innerHeight-$('header').innerHeight()-$('.lux_block').innerHeight()-20);
              	$('.footer_bg').height($('.footer_newsletter').innerHeight());
              }
              else{
				if(window.innerWidth > 1360){
					$('.footer_newsletter').height($('.footer_menu').innerHeight()-27);
				}
				else{
					$('.footer_newsletter').height($('.footer_menu').innerHeight()-20);	
				}
				$('.footer_bg').height($('.footer_menu').innerHeight());
              }
			} else{
				$('.footer_newsletter').css('height', 'auto');
				$('.footer_bg').height($('.footer_newsletter').innerHeight());
			}
		}, 100);

		
	
		
		/*if(window.innerWidth > 920){
			$('.footer_subs').each(function(){
				$(this).width($(this).parent().width()-$(this).parent().find('span').width()-70);
			});
		}
		else{
			$('.footer_subs').css('width', 'inherit');
		}*/
		
		if($('.filter_dropdown').length){
			if(window.innerWidth < 640){
              	
				$('.filter_dropdown .tab_content > ul > li > span').unbind('click').on('click keypress', function(){ 
                  
                  	
					if($(this).parent().hasClass('opened')){
						$(this).parent().removeClass('opened');
                      	$('.filter_dropdown').css('height', block_height_resp+65);
                        $(this).attr({'aria-expanded': false, 'aria-pressed': false});
                      	$(this).parent().find('ul').attr('aria-hidden', true);
					}
					else{
						$('.filter_dropdown .tab_content > ul > li').removeClass('opened');
                      	$('.filter_dropdown .tab_content > ul > li').find('span').attr({'aria-expanded': false, 'aria-pressed': false});
                        $('.filter_dropdown .tab_content > ul > li').find('ul').attr('aria-hidden', true);
						$(this).parent().addClass('opened');
                      	$(this).attr({'aria-expanded': true, 'aria-pressed': true});
                        $(this).parent().find('ul').attr('aria-hidden', false);
                      
                      	var li_height = '';
                        $(this).parent().find('ul li').each(function(key, val){
                            if(isEven(key)){
                              li_height = (parseInt(li_height) || 0)+$(this).parent().height();
                            }
                        });

                        $('.filter_dropdown').css('height', block_height_resp+83+li_height);
					}
					
                 	
                    
				});
			}
		}
		
		setTimeout(function(){
			if(window.innerWidth < 640){
				$('.login_form_block').css('margin-top', -($('.login_form_block').height()/2)+'px');
				$('.register_form_block').css('margin-top', -($('.register_form_block').height()/2)+'px');
                if(!$('.recovery_form_block').is(':visible')){	
                  if($('.registeruser').hasClass('active')){
                      $('.register_form_block').fadeIn().attr('state', 'expanded').attr('aria-hidden', 'false');
                      $('.login_form_block').fadeOut().attr('state', 'collapsed').attr('aria-hidden', 'true');
                  }
                  else{
                      $('.register_form_block').fadeOut().attr('state', 'collapsed').attr('aria-hidden', 'true');
                      $('.login_form_block').fadeIn().attr('state', 'expanded').attr('aria-hidden', 'false');
                  }
                }
            }
			else{
				$('.login_form_block, .register_form_block').css('margin-top', 'inherit');
                if(!$('.recovery_form_block').is(':visible')){	
                     $('.register_form_block').fadeIn().attr('state', 'expanded').attr('aria-hidden', 'false');
                 	 $('.login_form_block').fadeIn().attr('state', 'expanded').attr('aria-hidden', 'false');
                }
            }
		}, 100);
		
		if(window.innerWidth > 1024 && $('body').hasClass('openednav')){
			closeNav($carousel);
		}

		
		$(document).unbind('click').on('click touchstart', function (event) {
			if($('body').hasClass('openednav')){
			  if (!$(event.target).closest('.main_menu_inner').length && !$(event.target).closest('.menu_button').length) {
			  	closeNav($carousel);
			  }
			}
		});

      
      if($('.contest_content')[0] && !device.mobile()){
       	 if($(window).height()>890){
        	$('.contest_content_half').css('height', ($(window).height()-$('.header_top').height())+'px');
         }else {
            $('.contest_content_half').css('height', '780px');
         }
      }
      
      
      setTimeout(function(){
      	setPholder();
      }, 200);
      
      
	}).trigger('resize');

	if($('.home_fold_block').length){
		// if(device.mobile()){
			if (window.innerWidth > 768) {
          $(".home_fold_block, .home_fold_block .carousel-cell").height(
            window.innerHeight -
              $(".header_top").height() -
              $(".top_banner").innerHeight()
          );
        } else {
          $(".home_fold_block .carousel-cell").height(
            window.innerHeight -
              $(".header_top").height() -
              $(".top_banner").innerHeight()
          );
          $(".home_fold_block.mobile").css("height", "auto");
        }
	}
	
	if($('.home_fold_block .carousel').length){
		var $carousel = $('.home_fold_block .carousel').flickity({
			bgLazyLoad: true,
			wrapAround: true,
            selectedAttraction: 0.02,
			friction: 0.3,
          	autoPlay: true
		});
      
      	//$('.home_fold_block .flickity-page-dots').prepend('<span class="pause_carousel" tabindex="0"></span>');
      	$('.home_fold_block .flickity-page-dots .dot').attr('tabindex', 0).attr('aria-expanded', false).attr('role', 'button').addClass('move');
      	$('.home_fold_block .flickity-page-dots .dot').first().attr('aria-expanded', true);
      
      	if($('.home_fold_block .flickity-page-dots .dot').length){
            $('.home_fold_block .flickity-page-dots .dot').each(function(){
              $(this).attr('aria-label', 'Slide '+($(this).index()+1));
            });
        }
      	     	
      
      
      	$carousel.on('cellSelect', function() {
          var dot_index = $('.home_fold_block .dot.is-selected').index();
          $('.home_fold_block .carousel-cell').attr('aria-hidden', true);
          $('.home_fold_block .carousel-cell').eq(dot_index).attr('aria-hidden', false);
          
          $('.home_fold_block .carousel-cell .home_slider_button').attr('tabindex', '-1');
          $('.home_fold_block .carousel-cell').eq(dot_index).find('.home_slider_button').attr('tabindex', 0);
          
          
          $('.home_fold_block .flickity-page-dots .dot').attr('aria-expanded', false);
          $('.home_fold_block .flickity-page-dots .dot').eq(dot_index).attr('aria-expanded', true);
          $('.home_fold_block .flickity-page-dots .dot').addClass('move');
        });
      
      	
      	$('body').on('keypress', '.home_fold_block .flickity-page-dots .dot', function (e) {          
           var key = e.which;
           if(key == 13) {             
             	var index = $(this).index();
  				$carousel.flickity('select', index);              	
           }           
        });
      
      	/*if($('.home_fold_block .flickity-page-dots').length){
          $('.home_fold_block .flickity-page-dots').css('bottom', ($('.home_fold_block .carousel_text_block').height() + 30));
        }*/
      
        $(document).on('click keypress', '.pause_carousel', function(){ 
          if($(this).hasClass('paused')){
          	$carousel.flickity('playPlayer');
            console.log('playPlayer');
            $(this).removeClass('paused');
          }
          else{
            console.log('stopPlayer');
            $carousel.flickity('stopPlayer');
            $(this).addClass('paused');
          }
        });
      
	}
  
  	
	
	$('.menu_button').click(function(){
		openNav($carousel);		
	});
	$('.close_menu_button').click(function(){
		closeNav($carousel);
	});
  
  	/*if(window.innerWidth < 480){
      if($('.login_form_block').length){
          $('input[name="customer[password]"]').parent().addClass('active');
      }
    }*/
  
  	 if($('.contest_content')[0] && $(window).width()<=768){
       $('.contest_form_cont').appendTo('.contest_form_cont_mobile');
       $('.contest_content_half').css('height', ($(window).height()-$('.header_top').height()-100)+'px');
     }
  
  

 
  	$('body').on('click','.popupclick', function(e){
		e.preventDefault();
        //	gtag('event', 'pop-up', {'event_category' : 'click','event_label' : $(this).parent().find('.discount_info_popup_title').html()});
        if(typeof ga !== 'undefined') { 
          ga('send', 'event', 'Pop-up', 'click',  $(this).parent().find('.discount_info_popup_title').html());
        }
        var _tt=$(this).attr('href');
      	setTimeout(function(){ location.href=_tt; },100);
  		return false;
    });
  
  
  	$('body').on('click','.home_slider_button', function(e){
		e.preventDefault();
        if(typeof ga !== 'undefined') {
         ga('send', 'event', 'Home-slideshow', 'click',   $(this).attr('title'));
        }
       	var _tt=$(this).attr('href');
       	setTimeout(function(){ location.href=_tt; },100);
  		return false;
    });  
  
     $('body').on('click','.home_collection_link_g', function(e){
		 e.preventDefault();
         if(typeof ga !== 'undefined') {
           ga('send', 'event', 'Home-collection', 'click',   $(this).attr('title'));
         }
         var _tt=$(this).attr('href');
         setTimeout(function(){ location.href=_tt; },100);
         return false;
    }); 
  
  
	moveFocus();
  
  
  
  
  
  	$('body').on('change','.returnitemcheckbox', function(e){
		e.preventDefault();
      if($(this).prop('checked')){
            _returnscount++;
 			_returnsamount=parseInt($(this).attr('data-price'))/100+_returnsamount;
        $('#selecteditemscount').html(_returnscount);
        $('#selecteditemsprice').html('$'+_returnsamount);
      } else {
        _returnscount--;
        _returnsamount=_returnsamount-parseInt($(this).attr('data-price'))/100;
         $('#selecteditemscount').html(_returnscount);
        $('#selecteditemsprice').html('$'+_returnsamount);
      }
  		return false;
    });
  
  
  
   
  if($('.estdate')[0]){
    $('.estdate').each(function(){
      	$(this).html(addDays($(this).attr('data-create'),3));
    });
  }
  
  
  if($('.checkdeliverdate')[0]){
    $('.checkdeliverdate').each(function(){
      	$(this).html(checkDeliverDate($(this).attr('data-create')));
    });
  }
  
  
  
  
  $('body').on('click','.returnsubmit', function(e){
      e.preventDefault();
      var _returnitems=[];
	    if($('.returnitemcheckbox')[0]){
          
          $('.dropdown-toggle').attr("style","border:1px solid #000000!important");
          
          $('.returnitemcheckbox').each(function(){
           		 if($(this).prop('checked')){
                  	 if($(this).parent().parent().parent().parent().find('.selectpicker').val()!=""){
                   		_returnitems.push({sku:$(this).attr('data-sku'), price:parseInt($(this).attr('data-price'))/100, reason:$(this).parent().parent().parent().parent().find('.selectpicker').val(), info:$(this).parent().parent().parent().parent().find('.return_info').val()});
                     } else {
                         $(this).parent().parent().parent().parent().find('.dropdown-toggle').attr("style","border:1px solid #ff0000!important");
                     }
                  }
          });
          if(_returnitems.length>0){
                 var _data={};
                _data["form"]="return";
                _data["items"]=_returnitems;
             	 _data["order"]=$(this).attr('data-order');
            	 $('.returnsubmit').hide();
                 $('.return_loading').css('display','inline-block');
                PostRec('https://seiko-apps.com/api/postrequest',_data, function(_err, ___data){
                  if(_err){ 
                    console.log(_err);
                    $('#sub_thankyou').html(_err.responseText);
                  }
                  $('#sub_thankyou').show();
                 // $('.returnsubmit').css('display','inline-block');
                  $('.return_loading').hide();
                });	
           } else {
         		alert('Please select returning items'); 
       	   }
        } else {
         	alert('Please select returning items'); 
        }
        return false;
    });
  
  
  
  if(typeof _compatible_products !='undefined') LoadCompatibleProducts();
  
 if(typeof _cart_upsell_skus !='undefined') {
    LoadCompatibleStraps(_cart_upsell_skus, function(_strps){
      if(_strps){
         
        
        $(window).resize(function() {
          $('.cart_straps_cont').width(window.innerWidth-25);
        }).trigger('resize');
        
        
        if($('.cart_straps')[0]){
        

                  _strps.map(function(_g){
                      _g.straps.map(function(_t){

                          $('#sku_s_'+_g.sku).show();

                          $('.cart_straps_cont_'+_g.sku).append('<div class="product_block_cs"><div class="product_block">'+   
                                                   '<a href="/products/'+_t.handle+'" title="'+_t.sku+'" class="product_url" >'+
                                                   '<div class="product_image_block" tabindex="0">'+
                                                    '<img src="'+_t.image+'" alt="'+_t.sku+'" title="'+_t.sku+'" />'+
                                                   '</div>'+
                                                   '<span class="product_name_price">'+
                                                   '<span class="product_name popup_product_name">'+_g.sku+'</span>'+
                                                   '<span class="product_price popup_product_price">$'+(parseInt(_t.price)/100)+'</span>'+
                                                   '</span>'+
                                                   '</a>'+
                                                    (_cart_upsell_skus.indexOf(_t.sku)>-1 ? '<span' : '<a href="/cart"')+' class="incartupsell standard_button  social_add_to_cart '+(_cart_upsell_skus.indexOf(_t.sku)>-1 ? 'strapadded' : 'white')+'" data-id="'+_t.variants[0].id+'" data-sku="'+_t.sku+'" title="ADD TO CART" aria-label="adds product to cart">'+(_cart_upsell_skus.indexOf(_t.sku)>-1 ? 'ADDED</span>' : 'ADD TO CART</a>')+
                                                   '</div></div>');

                      });
						
                      if($('.cart_straps_cont_'+_g.sku+' .product_block_cs').length>0){
                        $('.cart_straps_cont_'+_g.sku).slick({
                          dots: false,
                          infinite: false,
                          speed: 300,
                          slidesToShow: 7,
                          slidesToScroll: 1,
                          responsive: [
                            {
                              breakpoint: 1024,
                              settings: {
                                slidesToShow: 4,
                                infinite: true,
                              }
                            },
                            {
                              breakpoint: 768,
                              settings: {
                                slidesToShow: 3
                              }
                            },
                            {
                              breakpoint: 480,
                              settings: {
                                slidesToShow: 1
                              }
                            }
                          ]
                        });
                      }

                    }); 
        
        } else if($('.product_straps')[0]){
        
  			_strps.map(function(_g){
                  _g.straps.map(function(_t){
                          $('.product_straps').show();       
        				 $('.additional_straps').append('<div class="product_block">'+
                                  '<a href="/products/'+_t.handle+'" title="'+_g.sku+'" class="product_url" tabindex="0">'+
                                    '<div class="product_image_block" tabindex="0"><img src="'+_t.image+'" alt="'+_g.sku+'" title="'+_g.sku+'" /></div>'+
                                  ' </a>'+
                                  '<label class="product_name_price" for="add_to_cart_strap'+_t.variants[0].id+'">'+
                                      '<span class="product_name popup_product_name">'+_g.sku+'</span>'+
                                     ' <span class="product_price popup_product_price" >$'+(parseInt(_t.price)/100)+'</span>'+
                                    '</label>'+                      
                                  '<input type="checkbox" name="add_to_cart_strap" id="add_to_cart_strap'+_t.variants[0].id+'" value="'+_t.variants[0].id+'" data-price="'+(parseInt(_t.price)/100)+'" class="add_to_cart_strap" />'+
                               ' </div>');
                  });
            });
        
        
                if($('.add_strap').length){
                      $('.add_strap').on('click', function(e){
                        e.preventDefault();
                        if($('.product_straps').hasClass('open')){
                           $('.product_straps').removeClass('open');
                           $('.product_straps .additional_straps').css({'max-height': '0', 'opacity': '0'});
                        }
                        else{
                          $('.product_straps').addClass('open');
                          $('.product_straps .additional_straps').css({'max-height': '290px', 'opacity': '1'});
                        }
                        return false;
                      });

                      $(window).resize(function() {
                        if(window.innerWidth < 768){
                          $('.additional_straps').width($('.product_desc_cont').width()-2);
                        }
                        else{
                          $('.additional_straps').width($('.product_desc_cont').width()-3);
                        }
                      }).trigger('resize');
                  
                      $('.additional_straps').slick({
                          dots: false,
                          infinite: false,
                          speed: 300,
                          slidesToShow: 4,
                          slidesToScroll: 1,
                          responsive: [
                            {
                              breakpoint: 1024,
                              settings: {
                                slidesToShow: 3,
                                infinite: true,
                              }
                            },
                            {
                              breakpoint: 768,
                              settings: {
                                slidesToShow: 4
                              }
                            },
                            {
                              breakpoint: 480,
                              settings: {
                                slidesToShow: 3
                              }
                            }
                          ]
                        });

                      $('.add_to_cart_strap').click(function(){
                          var _np=0;
                          $('.add_to_cart_strap').each(function(){
                             if($(this).prop('checked')){  
                               _np=_np+parseInt($(this).attr('data-price'));
                             }
                          })
                          if(_np>0){
                          		 $('.product_desc_cont .p_price').html(' + $'+ _np);
                          } else {
								$('.product_desc_cont .p_price').html('');
                          }
                        
                      });
                    }
        }
        
      }
    });
  }
  
  
});

$(window).load(function() {
	cartItemPhotoWidth();
    if($('.rowing_grid').length){
      if(window.innerWidth > 768){
          setTimeout(function(){
            $('.rowing_grid').masonry({
              itemSelector: '.grid-item',
              columnWidth: '.grid-sizer',
              percentPosition: true
            });
          }, 10);
      }
      else{
        $(window).resize(function() {
          $('.grid-item').height($('.grid-item img').width());
        }).trigger('resize');
      }
    }
});

function paralaxCollection5(){
	var elem = $('.img_block5');
	var wheight=$(window).height();
	var scrolling = $(window).scrollTop();
	 elem.each(function(){
        var $this = $(this);
		var offset = $this.offset().top;
		var height = $this.height();
		var transform = 0;
		if(scrolling+wheight>=offset) {
			transform=Math.round(((wheight+height)-((offset+height)-scrolling))/((wheight+height)/100));
			if(scrolling>=(offset+height)){
				transform=100;
			}
		}
		$this.find('div').css({'background-position': 'center ' + transform + '%'});
	});	
}

function moveFocus(){
	$(document).find('.move').keydown(function(e){
      if (e.keyCode == 39) {      
        $(this).next(".move").focus();
      }
      if (e.keyCode == 37) {      
        $(this).prev(".move").focus();
      }
    });
}

function openSocialPopup(__this){
  var index = __this.data('index');
  var img 	= __shop_social[index]['image'];
  var product = __shop_social[index];

  __this.attr('aria-expanded', true);
   
  if($('.product_block_social').length>1)  _shop_social_corusel.flickity('destroy');

  $('.products_list').empty();
  
  $('.header, .top_banner, .footer, .home_fold_block, .categories_section, .shop_social, #maincontent > div[class!="popup_blocks"]').attr({'aria-hidden': true, 'tabindex': "-1"});
  
  var _kk = 1;
  
 
  __shop_social.map(function(_j,_o){
    
    if(_j['image']==img){
      
      var _np=_j['price'].split('.');
      if(parseInt(_np[1])>0){
        _np[0]=_j['price'];
      }

      var _z=_j['pimage'];
      var _neimg=_z.split('.');
      _neimg[_neimg.length-2]=_neimg[_neimg.length-2]+'_350x600';
      var _img=_neimg.join('.');
      

      $('.products_list').append('<div class="product_block_social carousel-cell" id="p_'+_o+'"><div class="product_block">'+   
                                 ($('.products_list').data('wishlist')=='yes' ? '<div data-handle="'+_j['handle']+'" class="wishlist" aria-label="adds product to wishlist" tabindex="0"></div>' : '')+
                                 '<a href="/products/'+_j['handle']+'" title="'+_j['title']+'" aria-label="'+_j['title']+(typeof _j['tags']!='undefined'?_j['tags']:'')+'" class="product_url" >'+
                                 '<div class="product_image_block popup_product_image_block shadow_load" tabindex="0"><img src="'+$('.products_list').data('spin')+'" alt="'+_j['title']+'" title="'+_j['title']+'" class="spinner" data-src="'+_img+'" /></div>'+
                                 '<span class="product_name_price">'+
                                 '<span class="product_name popup_product_name">'+_j['title']+'</span>'+
                                 '<span class="product_price popup_product_price">$'+_np[0]+'</span>'+
                                 '</span>'+
                                 '</a>'+
                                 '<a href="/cart" class="standard_button white social_add_to_cart" data-id="'+_j['vid']+'" data-sku="'+_j['title']+'" title="ADD TO CART" aria-label="adds product to cart" data-title="'+_j['title']+'">ADD TO CART</a>'+
                                 '</div></div>');
    _kk = _kk+1;
    }
    

  });
  if($('.product_block_social').length>1){
  	$('.products_list').attr('aria-roledescription', "carousel");
    $('.product_block_social').each(function(i){
      $(this).attr({'role': "group", 'aria-roledescription': "slide", 'aria-label': (i+1)+' of '+$('.product_block_social').length});
    });
  }

  if($('.product_block_social').length>1){
    _shop_social_corusel = $('.products_list').flickity({
      bgLazyLoad: true,
      wrapAround: true,
      //autoPlay: true,
      pauseAutoPlayOnHover: true
    });
    
    $('.popup_info_block .flickity-page-dots .dot').each(function(){
      $(this).attr({'aria-label': 'Slide '+($(this).index()+1)+ ' of '+($('.product_block_social').eq($(this).index()).find('.popup_product_name').html()), 'aria-controls': "Shopsocial-carousel-items", 'role': 'button'});
    });
  
  
    $('.popup_info_block .flickity-page-dots .dot').attr('tabindex', 0).addClass('move');
    _shop_social_corusel.on('cellSelect', function() {
      $('.popup_info_block .flickity-page-dots .dot').attr('aria-pressed', false);
      $('.popup_info_block .flickity-page-dots .dot.is-selected').addClass('move').attr('aria-pressed', true);
    });
    
    $('.popup_info_block .flickity-page-dots .dot').keydown(function(e) {
      var code = e.keyCode || e.which;
      if(code == 13) {
        var index = $(this).index();
        $('.popup_info_block .flickity-page-dots .dot').removeClass('is_selected');
        $(this).addClass('is_selected');
        _shop_social_corusel.flickity('select', index);
      }
    });
    
    
    
    $('.popup_info_block .flickity-page-dots .dot').focusin(function(e) {
        var index = $(this).index();
        $('.popup_info_block .flickity-page-dots .dot').removeClass('is_selected');
        $(this).addClass('is_selected');
        _shop_social_corusel.flickity('select', index);
    });
    
    
    $('.popup_info_block .product_url, .popup_info_block .social_add_to_cart').focusin(function(e) {
        var index = $(this).parents('.product_block_social').index();
        _shop_social_corusel.flickity('select', index);
    });
    
    
  }
  
  if($('.popup_info_block .flickity-page-dots .dot').length){
    $('.popup_info_block .flickity-page-dots .dot').last().keydown(function(e) {
      var code = e.keyCode || e.which;
      if (!e.shiftKey && code == '9') {
        $('.shopsocial_popupcont .popup_close').focus();
        return false;
      }
    });
  }
  else{
    $('.popup_info_block .social_add_to_cart').last().keydown(function(e) {
      var code = e.keyCode || e.which;
      if (code == '9') {
        $('.shopsocial_popupcont .popup_close').focus();
        return false;
      }
    });
  }
  
  $('.shopsocial_popupcont .popup_close').last().keydown(function(e) {
    if (e.shiftKey && e.keyCode === 9) {
      return false;
    }
  });

  
  
  
  
  moveFocus();

  $('.popup_image_block').html('<img src="'+img+'" alt="'+product['title']+'" title="'+product['title']+'" />');

  // $('.popup_product_image_block').html('<img src="'+$('.popup_product_image_block').attr('data-spin')+'" alt="" title="" class="spinner" />');
  load_all_social_product_images();

  //$('.popup_product_name').html(product['title']);
  //	var _np=product['price'].split('.');
  //  if(parseInt(_np[1])>0){
  //		_np[0]=product['price'];
  //  }

  //$('.popup_product_price').html('$'+_np[0]);	

  //$('.popup_info_block').find('.wishlist').attr('data-handle',product['handle']);

  $('.shopsocial_popupcont').addClass('opened').attr('aria-hidden', 'false');				
  $('body').addClass('y_hidden');
  $('.loader_inner').css({'visibility':'visible','opacity':'1'});
  //$('.social_add_to_cart').attr('data-id',product['vid']);		
  //$('.social_add_to_cart').show();
  //$('.popup_info_block .product_url').attr('href', '/products/'+product['handle']);

  $(window).resize(function() {
    if(window.innerWidth < 768){
      var popup_other_width = $('.popup_image_block').width()-$('.popup_info_block .product_image_block').width();
      $('.popup_info_block .product_name_price').css('left', ($('.popup_info_block .product_image_block').width()+((popup_other_width-$('.popup_info_block .product_name_price').width())/2)));				
      $('.popup_info_block .standard_button').css('left', ($('.popup_info_block .product_image_block').width()+((popup_other_width-$('.popup_info_block .standard_button').width())/2-10)));		
    }
  }).trigger('resize');

  setTimeout(function(){				
    $('.loader_inner').css({'visibility':'hidden','opacity':'0'});
    $('.shopsocial_popupcont .popup_container').addClass('opened');
  }, 100);
  
  setTimeout(function(){
    //$('.focus_simulation').val(index).trigger('focus');
    $('.shopsocial_popupcont .popup_close').focus();
  }, 200);
}

function loadImage(elem, _cb){
	var img = new Image();
  
  
    if(window.innerWidth < 480){
      if(elem.attr("data-srcm")){
        img.src = elem.attr("data-srcm");
      }
      else{
      	img.src = elem.attr("data-src");
      }
    }
    else{
      img.src = elem.attr("data-src");
    }
	
	img.onload = function() {
		elem.addClass('loaded');
		elem.css('background-image','url('+img.src+')');
		_cb();
	}
}
function loadAllBGImages(elems, _cb){
	if(elems.length>0){
		var _cont=elems.length;
		var _curr=0;
		elems.each(function(){
			loadImage($(this), function(){
				_curr++;
				if(_curr==_cont){
				 _cb(); 
				}
			});
		});
	} else {
		_cb();
	}
}

function loadImageSrc(elem){
	var img = new Image();
  
  
    if(window.innerWidth < 768){
      if(elem.attr("data-srcm")){
        img.src = elem.attr("data-srcm");
      }
      else{
      	img.src = elem.attr("data-src");
      }
    }
    else{
      img.src = elem.attr("data-src");
    }
	
	img.onload = function() {
		elem.addClass('loaded');
		elem.attr('src', img.src);
		//_cb();
	}
}

function loadShadowImage(elem){
	var img = new Image();
	img.src = elem.find('.product_image_block img').attr("src");
	
	img.onload = function() {
      setTimeout(function(){
      	elem.addClass('loaded');
        if(elem.hasClass('womenwatchitem')){
          	elem.find('.shadow_load').css('background-size', '60% 80%');	
        }
        else{
			elem.find('.shadow_load').css('background-size', '100% 100%');	
        }
      }, 200);			
	}
}

function parallax(bg, padding, step, position){
  var scrolled = $(window).scrollTop();
  $('.'+bg).css(position, (-(scrolled*step)+padding)+'px');
}

function openNav($carousel) {
  	$('.main_menu_list a.first_level').attr('tabindex', 0);
  	$('.main_menu_list button').attr('tabindex', 0);
  	$('.main_menu_list input').attr('tabindex', 0);
  	$('.has_submenu .submenu_button').attr('tabindex', 0);
    $('.close_menu_button').attr('aria-hidden', 'false').attr('tabindex', 0);
  	$('.menu_button').attr('aria-hidden', 'true').attr('aria-expanded', 'true');
  
	$('body').addClass('openednav');
  	$('.main_menu_mobile').attr('state', 'expanded').attr('aria-hidden', 'false').css('visibility', 'visible');
	setTimeout(function(){
		if((window.innerWidth - $('.main_menu_inner').width())<200){
			$('.header .close_menu_button').css('width', (window.innerWidth - $('.main_menu_inner').width())).attr('tabindex', 0);
		}	
	}, 400);
  
  	$('.basket_button_block').css('pointer-events', 'none');
	
	if($('.home_fold_block .carousel').length){		
		$carousel.flickity('stopPlayer');
	}
}

function closeNav($carousel) {
  	$('.main_menu_list a').attr('tabindex', '-1');
  	$('.main_menu_list button').attr('tabindex', '-1');
  	$('.main_menu_list input').attr('tabindex', '-1');
  	$('.has_submenu .submenu_button').attr('tabindex', '-1');
    $('.close_menu_button').attr('aria-hidden', 'true').attr('tabindex', '-1');
    $('.menu_button').attr('aria-hidden', 'false').attr('aria-expanded', 'false');
  
	$('body').removeClass('openednav');
  	$('.main_menu_mobile').attr('state', 'collapsed').attr('aria-hidden', 'true').css('visibility', 'hidden');
  	setTimeout(function(){
  		$('.basket_button_block').css('pointer-events', 'initial');
    }, 500);

	if($('.home_fold_block .carousel').length){
		$carousel.flickity('playPlayer');
	}
}

/*
equalheight = function(container){

	if(window.innerWidth>640){
		var currentTallest = 0,
		     currentRowStart = 0,
		     rowDivs = new Array(),
		     $el,
		     topPosition = 0;
		 $(container).each(function() {

		   $el = $(this);
		   $($el).height('auto')
		   topPostion = $el.position().top;

		   if (currentRowStart != topPostion) {
		     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
		       rowDivs[currentDiv].height(currentTallest);
		     }
		     rowDivs.length = 0; // empty the array
		     currentRowStart = topPostion;
		     currentTallest = $el.height();
		     rowDivs.push($el);
		   } else {
		     rowDivs.push($el);
		     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
		  }
		   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
		     rowDivs[currentDiv].height(currentTallest);
		   }
		 });
	}
	else{
		$(container).height('inherit');
	}
}
*/


function LoadShopSocialJSON(_url,_id, _cb){
  $.getJSON(_url, function(_socials ) {
    var _items=[];
    for(var _i=0;_i<_socials.length;_i++){
      if(_socials[_i].id.toString()==_id.toString()) {
        _items=_socials[_i].items;
        break;
      }
    } 
	_cb(_items);
  });
}
///////////////////////////////////////////////////
function ShopSocialCreate(_class){
  if(__shop_social.length>0){
    var _image_slides=[];
    var _ind=0;
    $('.shop_social.'+_class+' div[data-image="social"]').each(function(key, value){
      if(((_class=='home' && key<10) || (_class=='catalog' && key<7)) && __shop_social[_ind]){
           if(_image_slides.indexOf(__shop_social[_ind]['image'])!=-1){
              for(var _i=_ind;_i<__shop_social.length;_i++){
                if(_image_slides.indexOf(__shop_social[_i]['image'])==-1) {
                  _ind=_i;
                  break;
                }
              }
           }
            _image_slides.push(__shop_social[_ind]['image']);
            $(this).css({'background-image': 'url("'+__shop_social[_ind]['image_th']+'")'}).addClass('social_link').attr('role', 'button').attr('aria-expanded', 'false').attr('id', __shop_social[_ind]['pid']).attr('data-type', _class).attr('aria-label', 'Opens shop social popup for '+__shop_social[_ind]['title'] +' watch').attr('data-index', _ind);
              _ind++;
         
        }  else{
      	$(this).parents('.shop_social_block').hide();
      }
    }); 
  }
  else{
  	$('.shop_social').hide();
    $('.shopsocial_popupcont').hide();
  }
  
}
////////////////////////////////////////////////////////////

//-----------------------------------New Filter Design----------------------------------------//
function CreateFilters() {
  $.getJSON(_filters_json_url, function (_all_filters) {
    if (!$(".collection_handle_accessories")[0]) {
      _all_filters["genders"].sort().map(function (_k) {
        for (var _i = 0; _i < _collection_tags.length; _i++) {
          if (_collection_tags[_i].tag.toString() == _k.toString()) {
            $("#filter_g").append(
              '<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;"><a href="#" data-id="' +
                _collection_tags[_i].tag +
                '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_g ' +
                (_collection_tags[_i].active ? "active" : "") +
                '" aria-label="' +
                _k.toString() +
                '" name="' +
                _k.toString() +
                '">' +
                _k.toString() +
                "</a></li>"
            );
            break;
          }
        }
      });

      if ($(".filter_g").length < 1) {
        $("#filter_g_ttl").hide();
      } else {
        const $wrapper = $("#filter_g_ttl");

        $wrapper.addClass("custom_filter_dropdown vis_filter"); // Add your custom dropdown class
        const $label = $wrapper.find("span");

        // Replace <span> with a custom toggle div
        const toggleText = $label.text();
        $label.replaceWith(
          `<div class="custom_filter_toggle" role="button" tabindex="0" aria-expanded="false">${toggleText} ▾</div>`
        );

        // Add menu class to the list
        $("#filter_g").addClass("custom_filter_menu");
      }

      _all_filters["technologys"].sort().map(function (_k) {
        for (var _i = 0; _i < _collection_tags.length; _i++) {
          if (_collection_tags[_i].tag.toString() == _k.toString()) {
            $("#filter_t").append(
              '<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;"><a href="#" data-id="' +
                _collection_tags[_i].tag +
                '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_t ' +
                (_collection_tags[_i].active ? "active" : "") +
                '" aria-label="' +
                _k.toString() +
                '" name="' +
                _k.toString() +
                '">' +
                _k.toString() +
                "</a></li>"
            );
            break;
          }
        }
      });

      if ($(".filter_t").length < 1) {
        $("#filter_t_ttl").hide();
      } else {
        const $wrapper = $("#filter_t_ttl");

        $wrapper.addClass("custom_filter_dropdown vis_filter"); // Add your custom dropdown class
        const $label = $wrapper.find("span");

        // Replace <span> with a custom toggle div
        const toggleText = $label.text();
        $label.replaceWith(
          `<div class="custom_filter_toggle" role="button" tabindex="0" aria-expanded="false">${toggleText} ▾</div>`
        );

        // Add menu class to the list
        $("#filter_t").addClass("custom_filter_menu");

        // $('#filter_t_ttl').addClass('vis_filter');
      }

      // _all_filters['price_range'].map(function(_k){
      //                   for(var _i=0;_i<_collection_tags.length;_i++){
      //                      if(_collection_tags[_i].tag.toString()==_k.toString()) {
      //                        $('#filter_p').append('<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;"><a href="#" data-id="'+_collection_tags[_i].tag+'" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_p '+(_collection_tags[_i].active ? 'active' : '')+'" aria-label="'+_k.toString().replace('1','$1').replace('2','$2').replace('3','$3').replace('4','$4').replace('5','$5').replace('6','$6').replace('7','$7').replace('8','$8').replace('999','$999').replace('-99','-$99')+'">'+_k.toString().replace('1','$1').replace('2','$2').replace('3','$3').replace('4','$4').replace('5','$5').replace('6','$6').replace('7','$7').replace('8','$8').replace('999','$999').replace('-99','-$99')+'</a></li>');
      //                        break;
      //                      }
      //                   }
      //             });

      _all_filters["price_range"].map(function (_k) {
        for (var _i = 0; _i < _collection_tags.length; _i++) {
          if (_collection_tags[_i].tag.toString() === _k.toString()) {
            let displayText = _k.toString();

            if (displayText === "1000-1999") {
              displayText = "$1000+";
            }
            else if (displayText === "100-299") {
              displayText = "BELOW $300";
            }
            else {
              displayText = displayText
                // .replace("1", "$1")
                // .replace("2", "$2")
                .replace("3", "$3")
                .replace("4", "$4")
                .replace("5", "$5")
                .replace("6", "$6")
                .replace("7", "$7")
                .replace("8", "$8")
                .replace("999", "$999")
                .replace("-99", "-$99");
            }

            $("#filter_p").append(
              '<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;">' +
                '<a href="#" data-id="' +
                _collection_tags[_i].tag +
                '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_p ' +
                (_collection_tags[_i].active ? "active" : "") +
                '" aria-label="' +
                displayText +
                '">' +
                displayText +
                "</a>" +
                "</li>"
            );
            break;
          }
        }
      });

      if ($(".filter_p").length < 1) {
        $("#filter_p_ttl").hide();
      } else {
        const $wrapper = $("#filter_p_ttl");

        $wrapper.addClass("custom_filter_dropdown vis_filter"); // Add your custom dropdown class
        const $label = $wrapper.find("span");

        // Replace <span> with a custom toggle div
        const toggleText = $label.text();
        $label.replaceWith(
          `<div class="custom_filter_toggle" role="button" tabindex="0" aria-expanded="false">${toggleText} ▾</div>`
        );

        // Add menu class to the list
        $("#filter_p").addClass("custom_filter_menu");

        // $('#filter_p_ttl').addClass('vis_filter');
      }

      _all_filters["collection"].sort().map(function (_k) {
        for (var _i = 0; _i < _collection_tags.length; _i++) {
          if (_collection_tags[_i].tag.toString() == _k.toString()) {
            $("#filter_cl").append(
              '<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;"><a href="#" data-id="' +
                _collection_tags[_i].tag +
                '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_cl ' +
                (_collection_tags[_i].active ? "active" : "") +
                '" aria-label="' +
                _k.toString() +
                '" name="' +
                _k.toString() +
                '">' +
                _k.toString() +
                "</a></li>"
            );
            break;
          }
        }
      });

      if ($(".filter_cl").length < 1) {
        $("#filter_cl_ttl").hide();
      } else {
        $("#filter_cl_ttl").addClass("vis_filter");
      }

      // if(window.innerWidth < 640){
      //  $('.filter_container .tab_content ul li span').attr('aria-expanded', false);
      //  $('#filter_g').addClass('custom_filter_menu').attr('aria-hidden', 'true').hide();
      //  $('.vis_filter span').attr({'role': 'button', 'aria-pressed': false});
      // }
    }

    var colors = [];
    _all_filters["colors"].sort().map(function (_k) {
      for (var _i = 0; _i < _collection_tags.length; _i++) {
        // console.log('_k', _k.length);

        if (_collection_tags[_i].tag.toString() === _k.toString()) {
          // Define the color based on the color name
          var colorName = _k.toString();
          var colorStyle = "";

          // Set the color style based on the color name
          switch (colorName.toLowerCase()) {
            case "red":
              colorStyle = "red";
              break;
            case "white":
              colorStyle = "white";
              break;
            case "blue":
              colorStyle = "blue";
              break;
            case "gray":
              colorStyle = "gray";
              break;
            case "green":
              colorStyle = "green";
              break;
            case "silver":
              colorStyle = "silver";
              break;
            case "champagne":
              colorStyle = "#F7E7CE";
              break;
            case "black":
              colorStyle = "black";
              break;
            case "blue":
              colorStyle = "blue";
              break;
            case "mother of pearl":
              colorStyle = "#EAE0C8";
              break;
            case "<etallic S":
              colorStyle = "#AAA9AD";
              break;
            case "ivory":
              colorStyle = "#FFFFF0";
              break;
            case "gold":
              colorStyle = "gold";
              break;
            case "copper":
              colorStyle = "copper";
              break;
            case "pink":
              colorStyle = "pink";
              break;
            case "brown":
              colorStyle = "brown";
              break;
            case "yellow":
              colorStyle = "yellow";
              break;
            case "burgundy":
              colorStyle = "#800020";
              break;
            case "digital":
              colorStyle = "digital";
              break;
            case "orange":
              colorStyle = "orange";
              break;
            case "n/a":
              colorStyle = "n/a";
              break;
            case "rose gold":
              colorStyle = "rose gold";
              break;
            case "beige":
              colorStyle = "beige";
              break;
            case "charcoal":
              colorStyle = "#36454F";
              break;
            case "purple":
              colorStyle = "purple";
              break;
            case "light blue":
              colorStyle = "#ADD8E6";
              break;
            case "turquoise":
              colorStyle = "turquoise";
              break;

            // Add more colors as needed
            default:
              colorStyle = "transparent"; // Fallback color
          }

          colors.push(_collection_tags[_i].tag); // Push tag to array

          const $filterC = $("#filter_c");
          const $colorLi = $(".color_li");
          const colorCount = colors.length;
          const isDesktop = window.innerWidth > 1024;

          if (isDesktop) {
            if (colorCount < 10) {
              $filterC.css("height", "auto");
              $colorLi.css("width", "85%");
            } else {
              let height;
              if (colorCount < 11) height = 240;
              else if (colorCount < 14) height = 320;
              else if (colorCount < 16) height = 360;
              else height = 490;

              $filterC.css({
                width: "400px",
                height: `${height}px`,
                "overflow-y": "auto",
                "flex-wrap": "wrap",
                "justify-content": "flex-start",
                "padding-top": "10px",
              });
              $colorLi.css("width", "45%");
            }
          } else {
            if (colorCount < 6) {
              $filterC.css("height", "auto");
              $colorLi.css("width", "87%");
            } else {
              $filterC.css({
                width: "69vw",
                height: "200px",
                "overflow-y": "auto",
                "justify-content": "flex-start",
              });
              $colorLi.css("width", "87%");
            }
          }

          $("#filter_c").append(
            '<li class="color_li" style="display: flex; align-items: center; line-height: 1rem; height: 35px; margin-left: 0; margin-bottom: 8px; padding-left: 15px;">' +
              '<a href="#" data-id="' +
              _collection_tags[_i].tag +
              '" role="checkbox" title="filter" style="font-size: 12px;" tabindex="-1" ' +
              'class="filteringoption filter_c ' +
              (_collection_tags[_i].active ? "active" : "") +
              '" ' +
              'aria-label="' +
              _k.toString() +
              '" name="' +
              _k.toString() +
              '" style="display: flex; align-items: center;">' +
              '<div class="color-circle" style="display: inline-block; width: 15px; height: 15px; border: 1px solid black; border-radius: 50%; margin-right: 5px; background-color: ' +
              colorStyle +
              '; vertical-align: middle;"></div>' +
              _k.toString() +
              "</a>" +
              "</li>"
          );

          break;
        }
      }
    });

    //      _all_filters['colors'].sort().map(function(_k){
    //   	       for(var _i=0;_i<_collection_tags.length;_i++){
    //               console.log('_k', _k);
    //                if(_collection_tags[_i].tag.toString()==_k.toString()) {
    //                  $('#filter_c').append('<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;"><a href="#" data-id="'+_collection_tags[_i].tag+'" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_c '+(_collection_tags[_i].active ? 'active' : '')+'" aria-label="'+_k.toString()+'" name="'+_k.toString()+'">'+_k.toString()+'</a></li>');
    //                  break;
    //                }
    //             }
    // });

    if ($(".filter_c").length < 1) {
      $("#filter_c_ttl").hide();
    } else {
      const $wrapper = $("#filter_c_ttl");

      $wrapper.addClass("custom_filter_dropdown vis_filter"); // Add your custom dropdown class
      const $label = $wrapper.find("span");

      // Replace <span> with a custom toggle div
      const toggleText = $label.text();
      $label.replaceWith(
        `<div class="custom_filter_toggle" role="button" tabindex="0" aria-expanded="false">${toggleText} ▾</div>`
      );

      // Add menu class to the list
      $("#filter_c").addClass("custom_filter_menu");

      // $('#filter_c_ttl').addClass('vis_filter');
    }
    // Function to show more options JSA ADD NEW CODE
    // Sort the colors

    // _all_filters['colors'].sort().map(function(_k) {
    //     for (var _i = 0; _i < _collection_tags.length; _i++) {
    //         if (_collection_tags[_i].tag.toString() == _k.toString()) {
    //             $('#filter_c').append('<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;" class="columns1"><a href="#" data-id="' + _collection_tags[_i].tag + '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_c ' + (_collection_tags[_i].active ? 'active' : '') + '" aria-label="' + _k.toString() + '" name="' + _k.toString() + '">' + _k.toString() + '</a></li>');
    //             break;
    //         }
    //     }
    // });

    // // Check if the number of filter items is greater than 8
    // if ($('.filter_c').length > 8) {
    //     var halfLength = Math.ceil($('.filter_c').length / 2);
    //     var firstColumn = $('.filter_c').slice(0, halfLength);
    //     var secondColumn = $('.filter_c').slice(halfLength);

    //     // Clear the existing content and append the items to two separate columns
    //     $('#filter_c').empty().append('<li class="columns"></li>').append('<li class="columns"></li>');
    //     $('#filter_c .columns:first-child').append(firstColumn);
    //     $('#filter_c .columns:last-child').append(secondColumn);
    // }

    //    _all_filters['size'].sort().map(function(_k){
    //   	       for(var _i=0;_i<_collection_tags.length;_i++){
    //                if(_collection_tags[_i].tag.toString()==_k.toString()) {
    //                  $('#filter_sz').append('<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;"><a href="#" data-id="'+_collection_tags[_i].tag+'" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_sz '+(_collection_tags[_i].active ? 'active' : '')+'" aria-label="'+_k.toString()+'" name="'+_k.toString()+'">'+_k.toString()+'</a></li>');
    //                  break;
    //                }
    //             }
    // });

    // JSA Code ends new add
    _all_filters["size"]
      .sort(function (a, b) {
        if (a === "BELOW 28.0MM") return -1;
        if (b === "BELOW 28.0MM") return 1;
        return a.localeCompare(b);
      })
      .map(function (_k) {
        for (var _i = 0; _i < _collection_tags.length; _i++) {
          if (_collection_tags[_i].tag.toString() == _k.toString()) {
            $("#filter_sz").append(
              '<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;">' +
                '<a href="#" data-id="' +
                _collection_tags[_i].tag +
                '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_sz ' +
                (_collection_tags[_i].active ? "active" : "") +
                '" aria-label="' +
                _k.toString() +
                '" name="' +
                _k.toString() +
                '">' +
                _k.toString() +
                "</a>" +
                "</li>"
            );
            break;
          }
        }
      });

    if ($(".filter_sz").length < 2) {
      $("#filter_sx_ttl").hide();
    } 
    else {
      const $wrapper = $("#filter_sx_ttl");

      $wrapper.addClass("custom_filter_dropdown vis_filter"); // Add your custom dropdown class
      const $label = $wrapper.find("span");

      // Replace <span> with a custom toggle div
      const toggleText = $label.text();
      $label.replaceWith(
        `<div class="custom_filter_toggle" role="button" tabindex="0" aria-expanded="false">${toggleText} ▾</div>`
      );

      // Add menu class to the list
      $("#filter_sz").addClass("custom_filter_menu");

      // $('#filter_sz_ttl').addClass('vis_filter');
    }

    var caseValuesByGender = {
      "Men": [],
      "Women": [],
      "Unisex": []
    };

    if (typeof _case_diameter !== 'undefined') {    
      _case_diameter.forEach(function (item) {
        var val = parseFloat(item.tag);
        if (isNaN(val)) return;
        
        // For Unisex: 35–41
        if (val >= 35 && val <= 41) {
          caseValuesByGender["Unisex"].push(item.tag);
        }
        // For Men: 37+
        if (val >= 37) {
          caseValuesByGender["Men"].push(item.tag);
        }
        // For Women: < 37
        if (val < 37) {
          caseValuesByGender["Women"].push(item.tag);
        }
      });
      
      _all_filters["gendr"].sort().forEach(function (gender) {
        var values = caseValuesByGender[gender];
      
        if (values && values.length > 0) {
          var uniqueValues = [...new Set(values)].sort(function (a, b) {
            return parseFloat(a) - parseFloat(b);
          });
      
          $("#filter_szg").append(
            '<li style="display: flex;line-height: 1.0rem;height: 35px;align-items: center;margin-left: 15px;">' +
              '<a href="#" data-id="' +
              gender +
              '" data-case-values="' +
              uniqueValues.join(",") +
              '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_szg" aria-label="' +
              gender +
              '" name="' +
              gender +
              '">' +
              gender +
              "</a></li>"
          );
        }
      });
  
      if ($(".filter_szg").length < 2) {
        $("#filter_sxg_ttl").hide();
      } 
      else {
        const $wrapper = $("#filter_sxg_ttl");
        $wrapper.addClass("custom_filter_dropdown vis_filter");
        const $label = $wrapper.find("span");
        const toggleText = $label.text();
        $label.replaceWith(
          `<div class="custom_filter_toggle" role="button" tabindex="0" aria-expanded="false">${toggleText} ▾</div>`
        );
        $("#filter_szg").addClass("custom_filter_menu");
      }
    }

    // lugwidth filter
    if (typeof _lug_widths !== 'undefined') {
      const $filterLG = $("#filter_lg");
      const isMobile = window.innerWidth < 1100;
      
      _all_filters["lug_width"]
        .sort((a, b) => parseFloat(a) - parseFloat(b))
        .forEach((_k) => {
          for (let _i = 0; _i < _lug_widths.length; _i++) {
            
            if (_lug_widths[_i].tag.toString() === _k.toString()) {

              console.log('in for loop in if', _lug_widths[_i].tag);
              const activeClass = _lug_widths[_i].tag.active ? "active" : "";
      
              if (isMobile) {
                if (_lug_widths.length < 8) {
                  $filterLG.css({ height: "auto" });
                  $(".lugwidth_li").css("width", "87%");
                } 
                else {
                  $filterLG.css({
                    width: "69vw",
                    height: "200px",
                    "overflow-y": "auto",
                    "justify-content": "flex-start",
                  });
                  $(".lugwidth_li").css("width", "87%");
                }
              }
              
              $filterLG.append(`
                <li class="lugwidth_li" style="display: flex; line-height: 1rem; height: 31px; align-items: center; margin-left: 15px; margin-top: 5px; margin-bottom: 0px; padding-left: 1px;">
                  <a href="#" data-id="${_lug_widths[_i].tag}" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_lg ${activeClass}" aria-label="${_k}" name="${_k}">
                    ${_k}MM
                  </a>
                </li>
              `);
              $filterLG.hide();
  
              break;
            }
          }
        });
      
      // Title and dropdown UI handling
      if ($(".filter_lg").length < 2) {
        $("#filter_lg_ttl").hide();
      } 
      else {
        const $wrapper = $("#filter_lg_ttl");
        $wrapper.addClass("custom_filter_dropdown vis_filter");
      
        const $label = $wrapper.find("span");
        const toggleText = $label.text();
      
        $label.replaceWith(
          `<div class="custom_filter_toggle" role="button" tabindex="0" aria-expanded="false">${toggleText} ▾</div>`
        );
      
        $filterLG.addClass("custom_filter_menu");
      }
    }

    if ($(".collection_handle_accessories")[0]) {
      _all_filters["materials"].sort().map(function (_k) {
        for (var _i = 0; _i < _collection_tags.length; _i++) {
          if (_collection_tags[_i].tag.toString() == _k.toString()) {
            $("#filter_m").append(
              '<li><a href="#" data-id="' +
                _collection_tags[_i].tag +
                '" role="checkbox" title="filter" tabindex="-1" class="filteringoption filter_m ' +
                (_collection_tags[_i].active ? "active" : "") +
                '" aria-label="' +
                _k.toString() +
                '" name="' +
                _k.toString() +
                '">' +
                _k.toString() +
                "</a></li>"
            );
            break;
          }
        }
      });

      if ($(".filter_m").length < 0) {
        $("#filter_m_ttl").hide();
      } else {
        $("#filter_m_ttl").addClass("vis_filter");
      }
    }

    var _hashed_tags = window.location.hash
      .replace("#", "")
      .replace(/%20/g, " ");

    if (_hashed_tags != "") {
      var _tags = _hashed_tags.split("+");
      if ($(".filter_g")[0]) {
        $(".filter_g").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }

      if ($(".filter_t")[0]) {
        $(".filter_t").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_c")[0]) {
        $(".filter_c").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_p")[0]) {
        $(".filter_p").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_cl")[0]) {
        $(".filter_cl").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_sz")[0]) {
        $(".filter_sz").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }

      if ($(".filter_szg")[0]) {
        $(".filter_szg").each(function () {
          console.log('hashed', $(this).attr("data-id"));
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_lg")[0]) {
        $(".filter_lg").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      
      if ($(".filter_m")[0]) {
        $(".filter_m").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }

      if ($(".collection_handle_seiko5sports").length) {
        setTimeout(function () {
          $("html, body").scrollTop($(".scrolltocol").offset().top);
          //$('html, body').animate({scrollTop: parseInt($(".scrolltocol").offset().top)}, 1000);
        }, 2200);
      }
    }

    if ($(".sortingoption.active")[0]) {
      var _typ = $(".sortingoption.active").hasClass("sorting-p")
        ? "Price"
        : "FEATURED";
      $(".sorting_shortcut").append(
        "<li>" +
          _typ +
          ": <span>" +
          $(".sortingoption.active").html() +
          '<a class="remove_selected_sorting"  title="remove" href="#"></a></span></li>'
      );
      $(".selected_filters").show();
      $(".sorting_shortcut_cont").css("display", "inline-block");
    }

    loadAllProducts();
  });
}

$(document).ready(function () {
  $(document).on("click", ".custom_filter_toggle", function () {
    console.log("custom_filter_toggle_vlick");
    const $parentLi = $(this).closest(".custom_filter_dropdown");
    const $menu = $parentLi.find(".custom_filter_menu");

    const isHidden = $menu.attr("aria-hidden") === "true";

    // Close all other dropdowns
    $(".custom_filter_menu")
      .not($menu)
      .each(function () {
        $(this).attr("aria-hidden", "true").slideUp(200);
      });

    // Toggle current dropdown
    if (isHidden) {
      $menu.attr("aria-hidden", "false").slideDown(200);
    } else {
      $menu.attr("aria-hidden", "true").slideUp(200);
    }
  });

  // console.log($("lkoi", ".custom_filter_toggle").length);

  $(document).on("click", ".custom_filter_toggle", function (e) {
    const $toggle = $(this);
    // Find the corresponding menu (ul) sibling or child
    const $menu = $toggle.closest(".custom_filter_dropdown").find(".custom_filter_menu");
    // Access all filtering options inside this dropdown menu
    const $filterOptions = $menu.find(".filteringoption");
  });
});

////////////////////////////////////////////////////////////////////////////

function loadAllProducts(){
  	
	var _url= window.location.href.split('#')[0];
    $.ajax({	
        url: _url+(_url.indexOf('?')>0 ? '&' : '/?')+'page='+_ajaxloadingpageid,
        type: 'get',
      	dataType:'html', 
        success: function(response){
          var result = $(response).find('.product_block_margin');
		  var _prds=$(result).find('.product_item_for_filter');
          if(_prds.length>0){
            
				_prds.each(function(){      
					$('.product_block_margin').append($(this));
				});
            	
				
				if(_prds.length==50){
				  _ajaxloadingpageid++;
				  loadAllProducts();
				} else {
                   Move_OutofStoke_to_bottom();
				   MarkWishlist();
				   StartFilter();
				}
          } else {
           	   Move_OutofStoke_to_bottom();
           	   MarkWishlist();
               StartFilter();
          }
          
        }
      
       
      	
      }); 

  
}
/////////////////////////////////////////////////////////////////////

var _comming_soon_list =[
  "SBSA145"
];

function Move_OutofStoke_to_bottom(){
  $('.product_block').each(function(){
    if($(this).hasClass('product_item_for_filter')){
      if(!$(this).hasClass('p_is_av')){ 
        if(_comming_soon_list.indexOf($(this).attr('data-sku'))>-1){
           $(this).find('.soldout').html('COMING SOON');
        } else {
           $('.product_block_margin').append(this);
        }
   	  }
    } else {
      if(_comming_soon_list.indexOf($(this).attr('data-sku'))>-1){
         $(this).find('.soldout').html('COMING SOON');
      }
    }
  });
  
}


////////////////////////////////////////////////////////////////////////////

function StartFilter(){ 
  
      if($('.product_item_for_filter').length>0){
		var _tags=[];
        var _tags_g=[];
        
        var _tags_t=[];
        var _tags_c=[];
        var _tags_p=[];
        var _tags_m=[];
        var _tags_cl=[];
        var _tags_sz=[];
        
    var _tags_szg = [];
    var _tags_lg = [];
        
         if($('.filteringoption')[0]){
              $('.filteringoption').each(function(){
                if($(this).hasClass('active')) {
                  
                  _tags.push($(this).attr('data-id'));
                       if($(this).hasClass('filter_g')) _tags_g.push($(this).attr('data-id'));
                
                       if($(this).hasClass('filter_t')) _tags_t.push($(this).attr('data-id'));
                        if($(this).hasClass('filter_c')) _tags_c.push($(this).attr('data-id'));
                       if($(this).hasClass('filter_p')) _tags_p.push($(this).attr('data-id'));  
                  		if($(this).hasClass('filter_cl')) _tags_cl.push($(this).attr('data-id'));  
                  	   if($(this).hasClass('filter_sz')) _tags_sz.push($(this).attr('data-id')); 
                  		if($(this).hasClass('filter_m')) _tags_m.push($(this).attr('data-id'));

                        if ($(this).hasClass("filter_szg")) _tags_szg.push($(this).attr("data-id"));          
                        if ($(this).hasClass("filter_lg")) _tags_lg.push($(this).attr("data-id"));

                  
                  	$(this).attr('aria-checked', true);
                  }
                  else{
                    $(this).attr('aria-checked', false);
                  }
              });
         }

        if(_collection_handle!=''){
           		var _url=_origin_url;
         		 if(!_first_load){
           			 _url=window.location.origin+'/collections/'+_collection_handle;
                   if($('.sortingoption.active')[0])  _url=_url+'/?sort_by='+$('.sortingoption.active').attr('data-id');
                 } 
                 else {
                   _first_load=false;
                  if($('.sortingoption.active')[0]){
                    if(_url.indexOf('?')>-1){
                      _url.replace(/\?/g, '?sort_by='+$('.sortingoption.active').attr('data-id')+'&');
                    }  else {
                      _url=_url+'?sort_by='+$('.sortingoption.active').attr('data-id');
                    }
                  }
                 }
          
          
                  if(_tags.length>0) {
                    _url=_url+'#'+_tags.join('+');

                    $('.selected_filters').show();
                    $('.filters_shortcut_cont').css('display','inline-block'); 
                    $('.filters_shortcut').empty();

                    if(_tags_g.length>0) {
                       var _nel=$('<li>BANDS: </li>');
                      _tags_g.map(function(_c){
                          _nel.append('<span>'+_c+'<a class="remove_selected_filter"  title="remove" href="#"></a></span>');
                        });
                       $('.filters_shortcut').append(_nel);
                    }
                    
                     if(_tags_t.length>0) {
                        var _nel=$('<li>TECHNOLOGY: </li>');
                       _tags_t.map(function(_c){
                           _nel.append('<span>'+_c+'<a class="remove_selected_filter" title="remove" href="#"></a></span>');
                        });
                        $('.filters_shortcut').append(_nel);
                     }
                     if(_tags_c.length>0) {
                          var _nel=$('<li>DIAL COLOR: </li>');
                          _tags_c.map(function(_c){
                             _nel.append('<span>'+_c+'<a class="remove_selected_filter" title="remove" href="#"></a></span>');
                          });
                          $('.filters_shortcut').append(_nel);
                     }
                     // if(_tags_p.length>0) {
                     //      var _nel=$('<li>PRICE: </li>');
                     //      _tags_p.map(function(_c){
                     //         _nel.append('<span>'+_c+'<a class="remove_selected_filter" title="remove" href="#"></a></span>');
                     //      });
                     //     $('.filters_shortcut').append(_nel);
                     // }
                    if (_tags_p.length > 0) {
                      var _nel = $('<li>PRICE: </li>');
                      _tags_p.map(function (_c) {
                        // Simple string check and replace
                        var label;
                        if (_c === '1000-1999') {
                          label = '1000+';
                        } else if (_c === '100-299') {
                          label = 'BELOW $300';
                        } else {
                          label = _c;
                        }
                    
                        _nel.append(
                          '<span style="font-weight:400">' +
                            label +
                            '<a class="remove_selected_filter" title="remove" href="#"></a></span>'
                        );
                      });
                      $(".filters_shortcut").append(_nel);
                    }
                     if(_tags_cl.length>0) {
                          var _nel=$('<li>COLLECTION: </li>');
                          _tags_cl.map(function(_c){
                             _nel.append('<span>'+_c+'<a class="remove_selected_filter" title="remove" href="#"></a></span>');
                          });
                         $('.filters_shortcut').append(_nel);
                     }
                    if(_tags_sz.length>0) {
                          var _nel=$('<li>SIZE: </li>');
                          _tags_sz.map(function(_c){
                             _nel.append('<span>'+_c+'<a class="remove_selected_filter" title="remove" href="#"></a></span>');
                          });
                         $('.filters_shortcut').append(_nel);
                     }

                    if (_tags_szg.length > 0) {
                      console.log('_tags_szg', _tags_szg); 
                      var _nel = $('<li style="font-weight:600">GENDER: </li>');
                      _tags_szg.map(function (_c) {
            
                        var label;
                        if (_c.includes("28.0MM-31.9MM") ||_c.includes("32.0MM-35.9MM") ||_c.includes("BELOW 28.0MM")){
                          label = "Women";
                        }
                        if (_c.includes("40.0MM-42.9MM") ||_c.includes("43.0MM AND ABOVE")){
                          label = "Men";
                        }
                        else if (_c.includes("36.0MM-39.9MM") ||_c.includes("40.0MM-42.9MM")){
                          label = "UNISEX";
                        }
                        else {
                          label = _c;
                        }
                        
                        _nel.append(
                          '<span style="font-weight:400">' +
                            label +
                            '<a class="remove_selected_filter" title="remove" href="#"></a></span>'
                        );
                        console.log('_c', _c);
                      });
                      $(".filters_shortcut").append(_nel);
                    }
            
                    if (_tags_lg.length > 0) {
                      var _nel = $('<li style="font-weight:600">LUG WIDTH: </li>');
                      _tags_lg.map(function (_c) {
                        _nel.append(
                          '<span style="font-weight:400">' +
                            _c +
                            '<a class="remove_selected_filter" title="remove" href="#"></a></span>'
                        );
                      });
                      $(".filters_shortcut").append(_nel);
                    }
                    
                    if(_tags_m.length>0) {
                          var _nel=$('<li>BANDS: </li>');
                          _tags_m.map(function(_c){
                             _nel.append('<span>'+_c+'<a class="remove_selected_filter" title="remove" href="#"></a></span>');
                          });
                         $('.filters_shortcut').append(_nel);
                     }
                  } else {
                    $('.filters_shortcut_cont').hide(); 
                    $('.filters_shortcut').empty();
                    if(!$('.sortingoption.active')[0]) $('.selected_filters').hide();
                  }

                history.pushState({}, '', _url); 
        }
        var _countp=0;

       	$('.product_item_for_filter').removeClass('p_show').addClass('p_hide');
        for(var _i=0; _i<$('.product_item_for_filter').length;_i++){
          	 var _this=$('.product_item_for_filter')[_i];
          
          	if(_tags.length>0){
                 var _inds=0;
                if(_tags_g.length>0){
                      for(var _j=0; _j<_tags_g.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_g[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
              
             	 if(_tags_t.length>0){
                      for(var _j=0; _j<_tags_t.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_t[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
               if(_tags_c.length>0){
                      for(var _j=0; _j<_tags_c.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_c[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
              if(_tags_p.length>0){
                      for(var _j=0; _j<_tags_p.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_p[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
              if(_tags_cl.length>0){
                 for(var _j=0; _j<_tags_cl.length;_j++){
                   if($(_this).attr('data-filters').indexOf('|'+_tags_cl[_j].trim()+'|')>-1) {
                     _inds++;
                     break;
                   }
                 }
               } else {
                 _inds++;
               }
              
              if(_tags_sz.length>0){
                      for(var _j=0; _j<_tags_sz.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_sz[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }

              if (_tags_szg.length > 0) {
                // console.log("🚀 Checking gender filters for product:", $(_this).attr("data-sku"));
              
                const productDiameter = parseFloat($(_this).attr("data-casediameter"));
                // console.log("📏 Product case diameter:", productDiameter);
              
                if (isNaN(productDiameter)) {
                  // console.warn("Invalid case diameter for product:", $(_this).attr("data-sku"));
                } 
                else {
                  for (var _j = 0; _j < _tags_szg.length; _j++) {
                    const selectedGender = _tags_szg[_j];
                    // console.log("➡️ Selected Gender:", selectedGender);
              
                    let match = false;
              
                    if (selectedGender === "Unisex") {
                      match = productDiameter >= 35 && productDiameter <= 41;
                    } else if (selectedGender === "Men") {
                      match = productDiameter >= 37;
                    } else if (selectedGender === "Women") {
                      match = productDiameter < 37;
                    }
              
                    if (match) {
                      // console.log("MATCH: Product", $(_this).attr("data-sku"), "fits gender:", selectedGender);
                      _inds++;
                      break;
                    } else {
                      // console.log("NO MATCH: Product", $(_this).attr("data-sku"), "does NOT fit gender:", selectedGender);
                    }
                  }
                }
              } else {
                _inds++;
              }
      
              if (_tags_lg.length > 0) {
      
                for (var _j = 0; _j < _tags_lg.length; _j++) {
                  var dataLug = $(_this).attr("data-lugwidth");
                
                  // Clean decimal if it's a whole number like "14.00" → "14"
                  if (dataLug) {
                    dataLug = dataLug.replace(/\.0+$/, ''); // removes .0, .00
                  }
                            
                  if (dataLug === _tags_lg[_j].trim()) {
                    _inds++;
                    break;
                  }
                }
              } else {
                _inds++;
              }
              
              
               if(_tags_m.length>0){
                      for(var _j=0; _j<_tags_m.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_m[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
              
               if(_inds==9) {
               	   $(_this).removeClass('p_hide').addClass('p_show');
                   if(!$(_this).find('.product_image_block_img').hasClass('loaded')){
                   		 $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
                   }
                 _countp++;
               }
            } else {    
              	$(_this).removeClass('p_hide').addClass('p_show');
                if(!$(_this).find('.product_image_block_img').hasClass('loaded')){
                  $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
                }
                _countp++;
            }
          
            if($('.shadow_load').length){
               loadShadowImage($(_this));
            }

          	if(_countp==20)  break;
         
         }
        	
        if(_countp==0){
          $('.no_products').show();
        }
        else{
          $('.no_products').hide();
        }
  
        $('.loadmore').hide();
        _loadingcollectionproducts=false;
        
      }
}
////////////////////////////////////////////////////////////////////////////

function NexstFilteredList(){

      if(_productslistshow*20<=$('.product_item_for_filter').length){
        _productslistshow++;
		var _tags=[];
        var _tags_g=[];
 
        var _tags_t=[];
        var _tags_c=[];
        var _tags_p=[];
        var _tags_cl=[];
        var _tags_sz=[];
         var _tags_m=[];
        
    var _tags_szg = [];
    var _tags_lg = [];
        
        if($('.filteringoption')[0]){
          $('.filteringoption').each(function(){
            if($(this).hasClass('active')) {              
              _tags.push($(this).attr('data-id'));
                   if($(this).hasClass('filter_g')) _tags_g.push($(this).attr('data-id'));
                    
                   if($(this).hasClass('filter_t')) _tags_t.push($(this).attr('data-id'));
                   if($(this).hasClass('filter_c')) _tags_c.push($(this).attr('data-id'));
                   if($(this).hasClass('filter_p')) _tags_p.push($(this).attr('data-id'));  
             	   if($(this).hasClass('filter_cl')) _tags_cl.push($(this).attr('data-id'));
                   if($(this).hasClass('filter_sz')) _tags_sz.push($(this).attr('data-id'));

                   if ($(this).hasClass('filter_szg')) _tags_szg.push($(this).attr("data-id"));          
                   if ($(this).hasClass('filter_lg')) _tags_lg.push($(this).attr("data-id"));

              
              	   if($(this).hasClass('filter_m')) _tags_m.push($(this).attr('data-id'));
              
              	$(this).attr('aria-checked', true);
              }
              else{
                $(this).attr('aria-checked', false);
              }
          });
        }
     	
        var _countp=0;

        for(var _i=((_productslistshow-1)*20); _i<$('.product_item_for_filter').length;_i++){
           	var _this=$('.product_item_for_filter')[_i];
        	if(_tags.length>0){
          		var _inds=0;
                if(_tags_g.length>0){
                      for(var _j=0; _j<_tags_g.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_g[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
              
             	 if(_tags_t.length>0){
                      for(var _j=0; _j<_tags_t.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_t[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
               if(_tags_c.length>0){
                      for(var _j=0; _j<_tags_c.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_c[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
              if(_tags_p.length>0){
                      for(var _j=0; _j<_tags_p.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_p[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
               if(_tags_cl.length>0){
                 for(var _j=0; _j<_tags_cl.length;_j++){
                   if($(_this).attr('data-filters').indexOf('|'+_tags_cl[_j].trim()+'|')>-1) {
                     _inds++;
                     break;
                   }
                 }
               } else {
                 _inds++;
               }
              
              
              if(_tags_sz.length>0){
                      for(var _j=0; _j<_tags_sz.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_sz[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }

              if (_tags_szg.length > 0) {
                // console.log("🚀 Checking gender filters for product:", $(_this).attr("data-sku"));
              
                const productDiameter = $(_this).attr("data-casediameter");
                // console.log("📏 Product case diameter:", productDiameter);
              
                if (isNaN(productDiameter)) {
                  // console.warn("⚠️ Invalid case diameter for product:", $(_this).attr("data-sku"));
                } 
                else {
                  for (var _j = 0; _j < _tags_szg.length; _j++) {
                    const selectedGender = _tags_szg[_j];
                    // console.log("➡️ Selected Gender:", selectedGender);
              
                    let match = false;
              
                    if (selectedGender === "Unisex") {
                      match = productDiameter >= 35 && productDiameter <= 41;
                    } else if (selectedGender === "Men") {
                      match = productDiameter >= 37;
                    } else if (selectedGender === "Women") {
                      match = productDiameter < 37;
                    }
              
                    if (match) {
                      // console.log("✅ MATCH: Product", $(_this).attr("data-sku"), "fits gender:", selectedGender);
                      _inds++;
                      break;
                    } else {
                      // console.log("❌ NO MATCH: Product", $(_this).attr("data-sku"), "does NOT fit gender:", selectedGender);
                    }
                  }
                }
              }
            
              if (_tags_lg.length > 0) {
                for (var _j = 0; _j < _tags_lg.length; _j++) {
                  var dataLug = $(_this).attr("data-lugwidth");
                
                  // Clean decimal if it's a whole number like "14.00" → "14"
                  if (dataLug) {
                    dataLug = dataLug.replace(/\.0+$/, ''); // removes .0, .00
                  }
                            
                  if (dataLug === _tags_lg[_j].trim()) {
                    _inds++;
                    break;
                  }
                }
              } else {
                _inds++;
              }
              
 				if(_tags_m.length>0){
                      for(var _j=0; _j<_tags_m.length;_j++){
                          if($(_this).attr('data-filters').indexOf('|'+_tags_m[_j].trim()+'|')>-1) {
								_inds++;
                                break;
                          }
                      }
                } else {
                  _inds++;
                }
              
               if(_inds==9) {
               	   $(_this).removeClass('p_hide').addClass('p_show');
                   if(!$(_this).find('.product_image_block_img').hasClass('loaded')){
                   		 $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
                   }
                 _countp++;
               }
            }else{
              $(_this).removeClass('p_hide').addClass('p_show');
              if(! $(_this).find('.product_image_block_img').hasClass('loaded')){
                $(_this).find('.product_image_block_img').attr('src',  $(_this).find('.product_image_block_img').attr('data-src')).addClass('loaded');
              }
              _countp++;
            }
          
          	if($('.shadow_load').length){
               loadShadowImage($(_this));
            }
          
        	if(_countp==20*_productslistshow)  break;
         }
        _loadingcollectionproducts=false;
        
      }

}
///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
function PostRec(_url, _data, callback){
	$.ajax({
		type: "POST",
		url: _url,
        dataType:'Json',
		data: _data
	}).done(function(o) {
		callback(null,o);
	}).fail(function(e) {
		callback(e);
	});
}

function hashchangeSupport(){
  var hash = window.location.hash.substring(1);
 
  if(hash=="shipping"){
    hash="privacy";
    setTimeout(function(){
   	 	var targetOffset = $('.prvc_id_20').offset().top-30;
		$('html, body').animate({scrollTop: targetOffset}, 1000);
    }, 1000);
  } else if(hash=="rules"){
    hash="privacy";
    setTimeout(function(){
   	 	var targetOffset = $('.prvc_id_21').offset().top-30;
		$('html, body').animate({scrollTop: targetOffset}, 1000);
    }, 1000);
  } else if(hash=="privacy-c"){
    hash="privacy";
    setTimeout(function(){
   	 	var targetOffset = $('.prvc_id_8').offset().top-30;
		$('html, body').animate({scrollTop: targetOffset}, 1000);
    }, 1000);
  } else if(hash=="gift"){
    hash="privacy";
    setTimeout(function(){
   	 	var targetOffset = $('.prvc_id_22').offset().top-30;
		$('html, body').animate({scrollTop: targetOffset}, 1000);
    }, 1000);
  } else if(hash=="camo"){
    hash="privacy";
    setTimeout(function(){
   	 	var targetOffset = $('.prvc_id_24').offset().top-30;
		$('html, body').animate({scrollTop: targetOffset}, 1000);
    }, 1000); 
  } else if(hash=="manuals"){
    location.href = "https://www.seikowatches.com/us-en/customerservice/instruction";
  }
  
  $('.offscreen').attr('href', '#'+hash);
  
  //if(hash!='faq')
  $('.support_tab_block.faq a').attr('tabindex', '-1');
  $('.support_tab_block a[target="_blank"]').attr('aria-label', 'opens in new window');
  
  
  
  $('.support_tab_block').removeClass('active').attr('state', 'collapsed').attr('aria-hidden', 'true');
  $('.support_tab_block.'+hash).addClass('active').attr('state', 'expanded').attr('aria-hidden', 'false');

  if($('.support_tabs .support_tab[data-tab="'+hash+'"]').length){
    $('.support_tab').removeClass('active').attr('state', 'closed').attr('aria-expanded', 'false').attr('aria-selected', 'false');
    $('.support_tab[data-tab="'+hash+'"]').addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');
  }
  else{
    $('.support_tab[data-tab="service"]').addClass('active').attr('state', 'opened').attr('aria-expanded', 'true').attr('aria-selected', 'true');
  }
}
/////////////////////////////////////////////////////////////
function setPholder(){
  if(window.innerWidth > 480){
      if($('.pholder').length){
        $('.pholder').each(function(key, value){
          $(this).parent().find('input').css({'padding-top': 0, 'padding-left': ($(this).width()+25)});
        });
      }
  }
  else{
    if(window.innerWidth > 420){
      $('.form_block .pholder').parent().find('input').css({'padding-top': '12px', 'padding-left': '12px'});            
    }
    else{
      $('.form_block .pholder').parent().find('input').css({'padding-top': '11px', 'padding-left': '12px'});            
    }
    $('.promo_form_block .pholder').parent().find('input').css({'padding-top': 0, 'padding-left': ($('.promo_form_block .pholder').width()+25)});
  }
}

///////////////////////////////////////////////////////////////////////

  var _loaded_index=0;
  var _wished_products_handles=[];
  var _wished_products_products=[];
  function LoadWishlistProduct(){
	$.ajax({
		type: "GET",
		url: '/products/'+_wished_products_handles[_loaded_index]+'.js',
        dataType:'json'
	}).done(function(product) {
		if(product.available) _wished_products_products.push(product);
        _loaded_index++;
        if(_loaded_index<_wished_products_handles.length && _wished_products_products.length<20) { 
          	LoadWishlistProduct();
        } else {
          	ShowWishList(); 
        }
      	contentHeight();
      	cartItemPhotoWidth();
	}).fail(function(e) {
		 _loaded_index++;
        if(_loaded_index<_wished_products_handles.length && _wished_products_products.length<20) { 
          	LoadWishlistProduct();
        } else {
          	ShowWishList(); 
        }
	});
    
  }


  function ShowWishList(){
    
    if(_wished_products_products.length>0){
           _wished_products_products.map(function(_i){

                    var _neimg=_i.featured_image.split('.');
                    _neimg[_neimg.length-2]=_neimg[_neimg.length-2]+'_200x300';
                    var _img=_neimg.join('.');
                                                $('#wishlist_content_list').append(
                                                     '<tr class="cart_item" id="'+_i.variants[0].id+'" data-sku="'+_i.title+'"  data-handle="'+_i.handle+'">'+
                                                        '<td class="cart_item_product"><a class="cart_item_photo" title="'+_i.title+'"  href="'+_i.url+'"><img src="'+_img+'" alt="'+_i.title+'" title="'+_i.title+'" /></a></td>'+
                                                        '<td class="shopping_cart_cols" colspan="4">'+
                                                            '<table>'+
                                                                '<tr>'+
                                                                    '<td class="cart_item_logo">'+
                                                                        '<span class="cart_item_logo_wrapper">'+
                                                                            '<a class="cart_item_title"  title="'+_i.title+'" href="'+_i.url+'">'+_i.title+'</a>'+
                                                                        '</span>'+
                                                                    '</td>'+
                                                                    '<td class="cart_item_price"><span>$'+(_i.price/100)+'</span></td>'+
                                                                    '<td class="cart_item_addbag"><button type="submit" class="standard_button wishlist_add_to_cart"  data-handle="'+_i.handle+'" data-sku="'+_i.title+'" data-id="'+_i.variants[0].id+'">ADD TO CART</button></td>'+
                                                                '</tr>'+
                                                           '</table>'+
                                                        '</td>'+
                                                        '<td class="cart_item_remove"><a href="#" class="wishlist_remove_item" data-id="'+_i.variants[0].id+'" data-handle="'+_i.handle+'" title="Remove"></a></td>'+
                                                    '</tr>'      
                                                 );
            });
        $.cookie('wishlist',_wished_products_handles.join(','), { path: '/' });
        $('.wishlist_content').show();
    } else {
   	  $('.wishlist_empty').show();
    }
     $('.loadmore').hide();
  }

///////////////////////////////////////////////////////////
function MarkWishlist(){
  if(_wished_products_handles.length>0){
        $('.product_item_for_filter').each(function(){
          var __this=$(this);
           if(__this.find('.wishlist')[0]){
            	var _handl=__this.find('.wishlist').attr('data-handle').toString();
           	    if(_wished_products_handles.indexOf(_handl)>-1) __this.find('.wishlist').addClass('active');
           }
        }); 
   }
}
//////////////////////////////////////////////////////////////
function contentHeight(){
  
	if($('.content').height()<window.innerHeight - $('.header').innerHeight() - $('.footer').innerHeight()){
		$('.content').height(window.innerHeight - $('.header').innerHeight() - $('.footer').innerHeight());
		
		if($('.support_block').length){
			$('.support_block').height($('.content').height() - $('.support_tabs').height() - $('.section_title').height() - 30);
		}
	
	}
	else{
		$('.content').height('inherit');
		
		if($('.support_block').length){
			$('.support_block').height('inherit');
		}
	}
}
/////////////////////////////////////////////////////////////////////
function cartItemPhotoWidth(){
	if($('.cart_item_photo').length){
        $('.cart_item_photo').each(function(){      
          
          	var _thisimg = $(this);
            setTimeout(function(){

              if(window.innerWidth > 768){   
                  if(_thisimg.find('img').width()<150){
                      _thisimg.width(_thisimg.find('img').width()+40);
                  }
                  else{
                    _thisimg.width(_thisimg.find('img').width());
                  }
              }
              else{
                if(_thisimg.find('img').width()<70){
                    _thisimg.width(_thisimg.find('img').width()+20);
                }
                else{
                  _thisimg.width(_thisimg.find('img').width());
                }
              }
              
          }, 100);  
         
       });
	}
}
////////////////////////////////////////////////////////////////////////
var _allmanuals={};
function LoadManuals(){
	$.ajax({
		type: "GET",
		url: _products_manuals_json_url,
        dataType:'json'
	}).done(function(_manuals) {
		_allmanuals=_manuals;
	}).fail(function(e) {
		console.loog(e);
	});
}
////////////////////////////////////////////////////////////////////////
function SearchManuals(_val){
  $('.download_manual').removeAttr('role').removeAttr('aria-live').removeAttr('aria-atomic').css('display','none');
  $('.no_manual_found').removeAttr('role').removeAttr('aria-atomic').css('display','none');
  var _findmanual=false;
  for(var _key in _allmanuals) { 
     for(var _v=0;_v<_allmanuals[_key].length;_v++) { 
       if(_allmanuals[_key][_v].toLowerCase()==_val.toLowerCase()){
         $('.download_manual').html('DOWNLOAD MANUAL');
         $('.download_manual').attr('href', "http://loremipsumcorp.com/seiko_shopify_data/watch-manuals/"+_key+".pdf");
         $('.download_manual').attr({'role': 'status', 'aria-live': 'polite', 'aria-atomic': true}).css('display','block');
         _findmanual=true;
          break;
       }
     }
     if(_findmanual) break;  
  }
  if(!_findmanual){
    $('.no_manual_found').attr({'role': 'alert', 'aria-atomic': true}).css('display','block');
  }
}


////////////////////////////////////////////////////////////////////////
/*
var _alldropoff={};
function LoadDropoff(){
	$.ajax({
		type: "GET",
		url: _products_dropoff_json_url,
        dataType:'json'
	}).done(function(_dropoffs) {
		_alldropoff=_dropoffs;
	}).fail(function(e) {
		console.log(e);
	});
}
////////////////////////////////////////////////////////////////////////

function SearchDropoff(_val){
  $('.download_dropoff').css('display','none');
  $('.no_manual_found').css('display','none');
  var _finddropoff=false;
  for(var _key in _alldropoff) { 
     for(var _v=0;_v<_alldropoff[_key].length;_v++) { 
       if(_alldropoff[_key][_v].toLowerCase()==_val.toLowerCase()){
         $('.download_dropoff').html('DOWNLOAD');
         $('.download_dropoff').css('display','block');
         _finddropoff=true;
          break;
       }
     }
     if(_finddropoff) break;  
  }
  if(!_finddropoff){
    $('.no_manual_found').css('display','block');
  }
}
*/
function SearchDropoff(_val){
  $('.locations_list').empty();
  $('.locatorloadinganim').show();
  $('.no_manual_found').removeAttr('role').removeAttr('aria-atomic').css('display','none');
  LoadDropoff(_val, function(_alldropoff){
     $('.locatorloadinganim').hide();
    if(_alldropoff.length==0) {
       $('.no_manual_found').attr({'role': 'alert', 'aria-atomic': true}).css('display','block');
    } else {
    	_alldropoff.map(function(_i){
			var _who=[];
          _i.OperatingHours.StandardHours.DayOfWeek.map(function(_k){
            _who.push(OpenCloseHours(_k));	
          });
          
           $('.locations_list').append('<div class="location_block"><div class="loc_left">'+
                                   		 '<h3>'+_i.AddressKeyFormat.ConsigneeName+'</h3><span class="miles">('+_i.Distance.Value+' miles away)</span>'+
                                   		 '<span class="miles">'+_i.AddressKeyFormat.AddressLine+', '+_i.AddressKeyFormat.PoliticalDivision1+', '+_i.AddressKeyFormat.PostcodePrimaryLow+(_i.PhoneNumber ? '<br>'+PhoneFormatting(_i.PhoneNumber) : "")+'</span>'+
                                    	  '<div class="hours">OPENING HOURS</div><span class="location_hours_block"><span class="days">Sunday<br />Monday<br />Tuesday<br />Wednesday<br />Thursday<br />Friday<br />Saturday</span><span class="loc_state">'+_who.join('<br>')+'</span></span></div></div>');
          
     	 });
      }
   });
}
function isEven(n) {
  n = Number(n);
  return n === 0 || !!(n && !(n%2));
}
///////////////////////////////////////////////////////////////////////
function load_all_social_product_images(){
  $('.popup_product_image_block').each(function(){
    	 var _this=$(this);
    	 var _src=_this.find('.spinner').attr('data-src');
 		 var img = new Image();
   		 img.src = _src;
   		 img.onload = function() {
           _this.html('<img src="'+_src+'" alt="" title="" class="imageforload" />').css('background-size', '100% 100%');
   		 }
  });
}

////////////////////////////////////////////////////////////////////////
var _all_search_results_list=[];
function LoadSearchresults(){
	$.ajax({
		type: "GET",
		url: _search_results_json_url,
        dataType:'json'
	}).done(function(_results) {
		_all_search_results_list=_results;
      SearchTerms();
	}).fail(function(e) {
		console.loog(e);
	});
}
////////////////////////////////////////////////////////////////////////
function SearchTerms(){
  	var _val=$('.no_search_resuts_go').attr('data-terms').trim().toLowerCase();
 	 var _findex=[];
     for(var _v=0;_v<_all_search_results_list.length;_v++) {  
       if(_all_search_results_list[_v].terms.indexOf(_val)>-1){
        	_findex=_all_search_results_list[_v].products;
             break;
       }
     }
  if(_findex.length>0) {
  		LoadRecomProducts(_findex);
  } else {
    if(!$('.product_block')[0]) {
      $('.no_search_resuts_go').show();
      $('.loadmore').hide();
    }
  }

}
////////////////////////////////////////////////////////////////////////////
function LoadRecomProducts(_handles){
  _handles.map(function(_i){
   	 LoadRecomProduct_item(_i.toLowerCase());
  });
  $('.loadmore').hide();
}
////////////////////////////////////////////////////////////////////////////
function LoadRecomProduct_item(_handle){
  	$.ajax({
		type: "GET",
		url: '/products/'+_handle+'.js',
        dataType:'json'
	}).done(function(_result) {
		//console.log(_result);
      	
      var _dnow = new Date();
    _dnow.setDate(_dnow.getDate() - 7);
	var _pdate=new Date(_result.created_at);

    var _prdds=$(
        '<div class="product_block product_item_for_filter p_show  '+ (_result.handle.substr(0,1)== 'q' ? 'p_cl' : '')+'">'+(_pdate<_dnow ? '<div class="new_icon">NEW</div>' : '')+
            '<a href="'+_result.url+'"  title="'+_result.title+'">'+
                 '<div class="product_image_block shadow_load">'+
                        '<img class="product_image_block_img loaded" src="'+_result.images[0].split('.png')[0]+'_400x600.png'+_result.images[0].split('.png')[1]+'" alt="'+_result.title+'" title="'+_result.title+'" >'+
                  '</div>'+
              '<span class="product_name_price">'+
                  '<span class="product_name">'+_result.title+'</span>'+
                  '<span class="product_price">$'+_result.variants[0].price/100+'</span>'+
                  '<span class="discount">'+(_result.variants[0].compare_at_price ? '$'+_result.variants[0].compare_at_price/100 : '')+'</span>'+
                   '<div data-bv-show="inline_rating" data-bv-productId="'+_result.id+'" data-bv-redirect-url="'+_result.url+'"></div>'+
              '</span>'+
          '</a>'+
            (_result.variants[0].available ? ' <a href="/cart" class="standard_button white productinfo_add_to_cart" data-sku="'+_result.title+'" data-id="'+_result.variants[0].id+'" title="ADD TO CART" data-title="'+_result.title+'">ADD TO CART</a>' : '<span class="soldout">SOLD-OUT</span>')+
    '</div>');
      
      $('.product_block_margin').append(_prdds);
       loadShadowImage(_prdds);
	}).fail(function(e) {
		console.log(e);
	});
}

//////////////////////////////////////////////////////////////////////////// if not us then redirect
var _whitelist_ips=['10.200.113.151','118.238.253.139'];
function CheckCountry(){
  if(!seiko_readCookie()) {
 	 var xhttp=new XMLHttpRequest;
        xhttp.onreadystatechange=function() {
            if(4===this.readyState&&200===this.status) {
                var t=JSON.parse(this.responseText);
                if(t.code!="US" && t.code!="RO" && t.code!="AM"  && _whitelist_ips.indexOf(t.ip.toString())==-1 && location.href.indexOf("/products/")==-1) location.href='https://www.seikowatches.com/';
            }
        }
        ,
        xhttp.open("GET", "https://appdevelopergroup.co/geoip.php", !0),
        xhttp.send();
  }
}
//////////////////////////////////////////////////////
function seiko_readCookie() {
        for(var t="admin_login_success=", n=document.cookie.split(";"), o=0; o<n.length; o++) {
            for(var r=n[o];" "==r.charAt(0);)r=r.substring(1, r.length);
            if(0==r.indexOf(t)) {
              if(GMMD5.MD5(GMMD5.MD5('3')+GMMD5.MD5(r.substring(t.length, r.length)))=="4b72a03fdefd70888f6eb2e7080b9797")  return true;
            }
        }
        return false;
 }
///////////////////////////////////////////

function Validate_file(_elem) {
    var _validFileExtensions = [".png",".jpg",".jpeg"];  
    var blnValid = false;
    var oInput =document.getElementById(_elem);
	if (oInput.type == "file") {
		var sFileName = oInput.value;
        var  fsize = Math.round((oInput.files.item(0).size / 1024));
		if (sFileName.length > 0) {		
			for (var j = 0; j < _validFileExtensions.length; j++) {
				var sCurExtension = _validFileExtensions[j];
				if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase() && fsize<=5120) {
					blnValid = true;
					break;
				}
			}		
		}
	}
    return blnValid;
}


var checkFields = function() {
	$('form.contact-form input').change(function() {       
      if($(this).val().length>0){
		if (!isEmail($(this).val())) {
          	$(this).parent().find('.individual_hint').attr({'role': 'alert', 'aria-atomic': true}).show();
			$(this).parent().find('.standard_hint').removeAttr('role').removeAttr('aria-atomic').hide();
            $(this).attr('aria-invalid', true);
		} else {
			$(this).parent().find('.individual_hint').removeAttr('role').removeAttr('aria-atomic').hide();
			$(this).parent().find('.standard_hint').removeAttr('role').removeAttr('aria-atomic').hide();
            $(this).attr('aria-invalid', false);
		}
      }
      else{
        $(this).parent().find('.standard_hint').attr({'role': 'alert', 'aria-atomic': true});
        $(this).attr('aria-invalid', true);
      }
   });
}

var checkForm = function() {
    var _this = $(this);
	$.validate({
        form: '.contact-form',
		scrollToTopOnError: false,
        onError: function(){
          _this.parent().find('.standard_hint').attr({'role': 'alert', 'aria-atomic': true});
          _this.parent().find('input[name="contact[email]"]').attr('aria-invalid', true);
        }
	});
};

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}
////////////////////////////////////////////

function LoadDropoff(_zip, _cb){
	$.ajax({
		type: "GET",
      url: 'https://seiko-sync.herokuapp.com/getlocator/'+_zip,
        dataType:'json'
	}).done(function(_dropoffs) {
		_cb(_dropoffs.points);
	}).fail(function(e) {
		console.log(e);
	});
}
////////////////////////////////////////////////////////////////////////
function OpenCloseHours(_k){
  var _reso="Closed";
  if(typeof _k.ClosedIndicator === "undefined"){
    if(_k.OpenHours.length==3){
      	_reso= _k.OpenHours.substr(0,1)+":"+_k.OpenHours.substr(1,2)+'AM';
    } else if(parseInt(_k.OpenHours.substr(0,2))<12){
        _reso=_k.OpenHours.substr(0,2)+":"+_k.OpenHours.substr(2,2)+'AM';
    } else if(parseInt(_k.OpenHours.substr(0,2))>12){ 
     	 _reso=parseInt(_k.OpenHours.substr(0,2))-12+":"+_k.OpenHours.substr(2,2)+'PM';
    } else {
		_reso=_k.OpenHours.substr(0,2)+":"+_k.OpenHours.substr(2,2)+'PM';
    }
    _reso=_reso+" - ";
    
    if(_k.CloseHours.length==3){
      	_reso= _reso+_k.CloseHours.substr(0,1)+":"+_k.CloseHours.substr(1,2)+'AM';
    } else if(parseInt(_k.CloseHours.substr(0,2))<12){
        _reso=_reso+_k.CloseHours.substr(0,2)+":"+_k.CloseHours.substr(2,2)+'AM';
    } else if(parseInt(_k.CloseHours.substr(0,2))>12){ 
     	 _reso=_reso+(parseInt(_k.CloseHours.substr(0,2))-12)+":"+_k.CloseHours.substr(2,2)+'PM';
    } else {
		_reso=_reso+_k.CloseHours.substr(0,2)+":"+_k.CloseHours.substr(2,2)+'PM';
    }
  }
  return _reso;
}
//////////////////////////////////////////////////////////////////////////
function PhoneFormatting(_phone){
  var _numb='('+_phone.substr(0,3)+') '+_phone.substr(3,3)+' '+_phone.substr(6,2)+'-'+_phone.substr(8,2);
  return '<a href="tel:'+_numb+'">'+_numb+'</a>';
} 
//////////////////////////////////////////////////////////////////////////
var _collections_list_for_store_locator=["", "seiko5sports", "presage", "prospex"];



function get_all_addresses_popup(_data){
  var _allpr=[];
  var _ind=0;
  _data.map(function(_k,_c){
    if(_ind<3 && (_k.display_name.indexOf(', USA')>0 || _k.display_name.indexOf(', United States')>0)){
      var _address=_k.display_name.replace(/, United States of America/g,'');
      if(_address.indexOf('County')>0){
        var _tmm=_address.split(',');
        var _new_addr=[];
        _tmm.map(function(_t){
          if(_t.indexOf('County')==-1) _new_addr.push(_t.trim());
        });
        _address=_new_addr.join(', ');
      }
    	_allpr.push({"id":_c+2, "title":_address, "lat":_k.lat, "lon":_k.lon});
      _ind++;
    }
  });
  return _allpr;
}

////////////////////////////////////////////////////////////////////////////////
function searchLocations_inpopup() {
   $(".l_map_res_list").empty();
   $('.list_loader_popup').show();
	var address =($('#praddress_incollection').val().length>0 ? $('#praddress_incollection').val().trim().replace(/ /g,'+')+'+' : "");
		
	if(address.length>1){
		$.getJSON('https://geocode.maps.co/search?q='+address+'&format=json&polygon=1&addressdetails=1&api_key=658c72e030653798329319cwx861442', function(_locs) {    
		if (_locs) {
			if (_locs[0]) {
				searchLocationsNear_popup(parseFloat(_locs[0].lat),parseFloat(_locs[0].lon));
			} else {
                $('.list_loader_popup').hide();
				PopuperShow("No locations were found using address.");
			}
		} else {
            $('.list_loader_popup').hide();
			PopuperShow("No locations were found using address.");
		}
		});
	}else{
       $('.list_loader_popup').hide();
		PopuperShow("Please enter an address.");
	}
	return false;
}

////////////////////////////////////////////////////////////////////////////////
function SortStores( a, b ) {
  if ( parseFloat(a.distance) < parseFloat(b.distance) ){
    return -1;
  }
  if ( parseFloat(a.distance) > parseFloat(b.distance) ){
    return 1;
  }
  return 0;
}

////////////////////////////////////////////////////////////////////////////////

function searchLocationsNear_popup(lat, lng) {
  	_curr_lat=lat;
 	_curr_lng=lng;
	var searchUrl = 'https://seiko-apps.com/api/postrequest/';
	var _data={};
    _data["latitude"]   = lat;
    _data["longitude"]  = lng;
    
  //console.log(_collection_handle);
  var _other_coll=true;
  var _curr_coll=-1;
  if(typeof _collection_handle !='undefined'){
    if(_collection_handle!=''){
      if(_collections_list_for_store_locator.indexOf(_collection_handle)>-1) {
        _other_coll=false;
        _curr_coll=_collections_list_for_store_locator.indexOf(_collection_handle);
        _data["collection"]=_curr_coll;
      }
    }
  }
  $(".l_map_res_list").empty();
  	
	
	PostRec(searchUrl, _data, function(_err, __data){
   	    if(!_err){
   	    	___data = __data['stores'];
          
          	var _itmss=[];
           $('.list_loader_popup').hide();
   	    	if(___data.length>0){
	   	    	for (var i = 0; i < ___data.length; i++) {
                  if(_other_coll || (!_other_coll && ___data[i].collections.indexOf(_curr_coll)>-1)){
                    _itmss.push({id:___data[i]._id,name:___data[i].data.name, address:___data[i].data.city_state,latl:___data[i].position[1],lngl:___data[i].position[0],distance:getDistance_popup(lat, lng, ___data[i].position[1], ___data[i].position[0]).toFixed(1)}); 
                  }
				}
              if(_itmss.length>0){
                _itmss.sort(SortStores);
                
                  if(window.innerWidth > 640){
                    for (var i = 0; i < 3; i++) {
                         createOption_popup(_itmss[i].id,_itmss[i].name,  _itmss[i].address, _itmss[i].latl, _itmss[i].lngl, _itmss[i].distance, i);
                    }  
                  }
                  else{
					for (var i = 0; i < 2; i++) {
                         createOption_popup(_itmss[i].id,_itmss[i].name,  _itmss[i].address, _itmss[i].latl, _itmss[i].lngl, _itmss[i].distance, i);
                    }  
                  }
                  $(".l_map_res_list").append('<a class="view_more_s" href="/pages/store-locator#'+_itmss[0].id+"|"+_curr_lat+"|"+_curr_lng+'">View all results</a>');
                
             	 var ul_height = $('.find_a_store_opened .l_map_res_list').height();
             	 $('.find_a_store_opened').stop().animate({"height": ul_height - 105}, 400);
             	 $('.find_a_store_opened .l_map_wrap_left_scrl').stop().animate({"height": ul_height+50}, 400);
              } else{
                  $('.find_a_store_opened').stop().animate({"height": 250}, 400);
                  PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");	
              }
			} else{
                $('.find_a_store_opened').stop().animate({"height": 250}, 400);
				PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");	
			}
		} 
		
     });	
}

function createOption_popup(id, store_name,  address, lat, lng, distance, i) {	
  	PopuperClose();
  	$('.store_popup_block h2 span').hide();
	$(".l_map_res_list").append(
      "<li class='l_map_res_list_i' tabindex='0' data-id='"+i+"'  "+
          "data-name='"+store_name.trim()+"' " +
          "data-address='"+address.trim()+"' " +

          "data-lat='"+lat+"' data-lng='"+lng+"'> " +
          "<a href='/pages/store-locator#"+id+"|"+_curr_lat+"|"+_curr_lng+"'><span class='l_map_store_name'>" + store_name.trim() + "</span>" +
          "<p class='l_map_distance'>" + distance +" mi<span class='l_map_address'>" + address.trim()+"</span></p>" +
          "</a>" +
      "</li>");
}


function getDistance_popup(lat1,lon1,lat2,lon2) {
  var R = 3963.1676; // Radius of the earth in miles
  var dLat = deg2rad_popup(lat2-lat1);  // deg2rad below
  var dLon = deg2rad_popup(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad_popup(lat1)) * Math.cos(deg2rad_popup(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in miles
  return d;
}

function deg2rad_popup(deg) {
  return deg * (Math.PI/180)
}


function L_GeoIP_popup(){
  $.getJSON("https://geoip-db.com/json/").success(function(data) {
    if(data.country_code!="US"){
        PopuperShow("No locations were found using your search criteria [ <b>"+(data.country_name || 'Your location')+"</b> ]. Please try another input address to search for locations."); 
    } else{
       $('.list_loader_popup').show();
       searchLocationsNear_popup(parseFloat(data.latitude),parseFloat(data.longitude));
    }
  }).error(function() {
      PopuperShow("No locations were found using your search criteria [Your location]. Please try another input address to search for locations."); 
  });
}


function PopuperShow(test) {
  $('.store_popup_block h2 span').show();
  $('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 300, function(){
    if(window.innerWidth > 640){
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '70px' }, 600);
      	$('.find_a_store_opened').stop().animate({"height": 260}, 400);
    }
    else{
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '60px' }, 600);	
    }
  });
  
  setTimeout(function(){
  	$('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 600);
  }, 3000);
}
       
function PopuperClose(test) {	
  $('#l_map_wrap_m_text').html(test).animate({ opacity: 0, height: 0 }, 600);	
}




function loadPressNextPage(){
    
  	_canayaxload=false;
	var _url= window.location.href.split('#')[0];
    $.ajax({	
        url: _url+(_url.indexOf('?')>0 ? '&' : '/?')+'page='+_ajaxloadpresspage,
        type: 'get',
      	dataType:'html', 
        success: function(response){
          
          var result = $(response).find('.press_grid');
		  var _artk=$(result).find('.grid-item').addClass('hidden_grid');
          
          if(_artk.length>0){
            $('.loader_blog').css({'visibility':'visible','opacity':'1'});
            
				_artk.each(function(){
                       
					   $('.press_grid').append($(this));
                  
                  	   $('.press_grid').masonry( 'appended', $(this), true ); 
                       window.setTimeout(function() {
                            $('.press_grid').masonry('layout');
                       }, 60);
                  
                  	   window.setTimeout(function() {
                         $('.grid-item').removeClass('hidden_grid');
                       }, 50);
				});
            	setTimeout(function(){ _canayaxload=true;},100);
            
				if(_artk.length==50){
				  _ajaxloadpresspage=-1;
				} else {	
				   _ajaxloadpresspage++;
				}
            
            
            $('.loader_blog').css({'visibility':'hidden','opacity':'0'});
          } 
        }
      }); 

}

////////////////////////////////////////////////////////////////////////////
function LoadCompatibleProducts(){
     var _comm="";
    for(var _i=0;_i<_compatible_products.length;_i++){
      _comm+=(_i>0 ? " OR handle:" + _compatible_products[_i] : "handle:" + _compatible_products[_i]);
    }
  $.ajax({	
    url: decodeURI("/search.js?view=products.handle&q=" + _comm),
    type: 'get',
    dataType:'html', 
    success: function(response){
      $('#compatibleproductslist').append(response);
       $('#compatibleproductslist').append('<span class="cb"></span>');
    }
  }); 
}
////////////////////////////////////////////////////////////////////////////
function LoadCompatibleStraps(_cart_upsell_skus,_cd){
  $.ajax({	
    url: decodeURI("/collections/accessories?view=json.accessories"),
    type: 'get',
    dataType:'html', 
    success: function(response){ 
    	var _data=JSON.parse(response);
		var _upsell=[];	
        for(var _i=0;_i<_cart_upsell_skus.length;_i++){
           var _strps=[];
			for(var _j=0;_j<_data.results.length;_j++){
              if(_data.results[_j].tags.indexOf(_cart_upsell_skus[_i])>-1 && _data.results[_j].available){
                  _strps.push(_data.results[_j]); 
              }
            }
          if(_strps.length>0){
            _upsell.push({sku:_cart_upsell_skus[_i],straps:_strps});
          }
        }
      if(_upsell.length>0){
         return _cd(_upsell); 
      } else {
       	return _cd(null); 
      }
    }
  }); 
}
////////////////////////////////////////////////////////////////////////////////
function CheckGiftItem(_sku){
	var _ret=null;
  	var _rsku=null;
  	var _gifts_item_list=[
        {
          id:"32562616434767",
          sku:"SP20029H",
          products:[]
        }
      ];


  
  for(var _i=0;_i<_gifts_item_list.length;_i++){
    if(_gifts_item_list[_i].products.indexOf(_sku)>-1){
    	_ret=_gifts_item_list[_i].id;
      	_rsku=_gifts_item_list[_i].sku;
    }
  }
  
  
  return _ret;

}
////////////////////////////////////////////////////////////////////////////////
function check_cart_page(){
  if(location.href.indexOf("/cart")>-1){
    $.get("/cart.js", function(data) {
      if(data.items.length>0){
        
        
		var _prdss_li=[
          "SRPH63",
          "SRPH65"
        ];
        
        var _handles=[];        
        var _reg_prod=false;
        var _gift_prod=0;
        
        
        /*
 		data.items.map(function(_i){
        	if(_prdss_li.indexOf(_i.product_title)>-1) _reg_prod=true;
            if(_i.product_title=="BLACKSTRAP")  _gift_prod+=_i.quantity;
        });

        
        if(_reg_prod){
          if(_gift_prod==0) {
            $.post('/cart/add.js', {quantity: 1, id:"40489900376143" }, function(data) {}).fail(function(response) {
                var _sta=JSON.parse(response.responseText);
               if(!_sta.status) location.reload();
            });
          } 
        }
        */
        
        
        
       
      
        data.items.map(function(_i){
          //if(_i.product_type=="Wrist Watches" && _i.price>=27500) _handles.push(_i.handle);
          //if(_prdss_li.indexOf(_i.product_title)>-1) _handles.push(_i.handle);
          if(_i.product_type=="Wrist Watches") _handles.push(_i.handle);
          if(_i.product_type=="Gifts")  _gift_prod+=_i.quantity;
        });

       
        
        if(_handles.length>0){
          SearchProductsFromCart(_handles,function(_reso){
                if(_reso){           
                        if(_gift_prod==0) {
                          $.post('/cart/add.js', {quantity: 1, id:"40540019163215" }, function(data) {}).fail(function(response) {
                              var _sta=JSON.parse(response.responseText);
                             if(!_sta.status) location.reload();
                          });
                        } else  if(_gift_prod>1) {
                            $.post('/cart/update.js', {updates: {"40540019163215":1,"40540019163215":0 }}, function(data) {}).fail(function(response) {
                                var _sta=JSON.parse(response.responseText);
                               if(!_sta.status) location.reload();
                            });
                        }
          
                 } else if(_gift_prod>0) {
                    $.post('/cart/change.js',  {quantity:0, id:"40540019163215" }, function(data) {}).fail(function(response) {
                      var _sta=JSON.parse(response.responseText);
                      if(!_sta.status) location.reload();
                    });
                 }      
          });
    
        } else if(_gift_prod>0) {
          $.post('/cart/change.js',  {quantity:0, id:"40540019163215" }, function(data) {}).fail(function(response) {
            var _sta=JSON.parse(response.responseText);
            if(!_sta.status) location.reload();
          });
        }
        
       
        
      }	
    }, "json");
             
  }
}
////////////////////////////////////////////////////////////////////////////
function SearchProductsFromCart(_products,_cb){
     var _comm="";
    for(var _i=0;_i<_products.length;_i++){
      _comm+=(_i>0 ? " OR handle:" + _products[_i] : "handle:" + _products[_i]);
    }
  $.ajax({	
    url: decodeURI("/search.js?view=json&q=" + _comm),
    type: 'get',
    dataType:'json', 
    success: function(response){
      if(response.results){
        var _find=false;
        for(var _i=0;_i<response.results.length;_i++){
          if(response.results[_i].collections.indexOf("165156847695")>-1){
               _find=true;
               break;
           }
        }
      	 _cb(_find);
      } else {
         _cb(false);
      }
    }
  }); 
}
/////////////////////////////////////////////////////
function LoadHomeBestSellers(){
    $.ajax({	
        url:'/collections/all?sort_by=best-selling&view=bestsellers',
        type: 'get',
      	dataType:'html', 
        success: function(response){
				$('#homebestsellers').append(response);
        }
      }); 
}

///////////////////////////////////////////////////////////////
var _retailers_list=[
"Ackerman Jewelers",
"Adler's - Baton Rouge",
"Adler's - Metairie",
"Alan Miller Jewelers",
"Albert's Diamond Jewelers",
"Alexander's Jewelers",
"Alter's Gem Jewelry",
"Anderson Bros. Jewelers",
"Ara Karkazian Watch & Jewelers Co.",
"Arizona Fine Time",
"Atlantic City Jewelry",
"Aucoin Hart Jewelers",
"Avenue Jewelers",
"Bailey's Fine Jewelry",
"Bailey's Fine Jewelry",
"Barons Jewelers",
"Bay Area Diamond Company",
"Bell Jewelers",
"Belle View Jewelers",
"Bere Jewelers",
"Berger & Son Fine Jewelers",
"Beverly Palm Jewelers",
"Blake Jewelers",
"Bob Richards Jewelers",
"Boccardo Jewelers",
"Boelter's Jewelers",
"Boggs Jewelers",
"Boudreaux's Jewelers",
"Brent L. Miller Jewelers & Goldsmiths",
"Bromberg's",
"Brugen Jewelers",
"Cailey Jewelers",
"Calhoun Jewelers",
"Callahan Jewelers",
"Caparo Jewelers",
"Carat & Co.",
"Carroll / Ochs Jewelers",
"Casa D'Oro Diamonds & Fine Jewelry",
"CH Premier Jewelers",
"Chong Hing Jewelers - Rowland Heights",
"Chong Hing Jewelers - San Gabriel",
"Christoff Jewelers",
"Classic Jewelry",
"Claudias Jewelry, Inc.",
"Clawson Jewelers",
"Clifton Jewelers",
"Cohasset Jewelers",
"Cornerstone Jewelry Design",
"Craig Husar Designs",
"Crown Jewelry",
"Dan Gould Jewelers",
"Danson Jewelers",
"David Desso",
"Davis Jewelers",
"Dejaun Jewelers - Thousand Oaks",
"Dejaun Jewelers - Woodland Hills",
"DePaula Jewelers",
"DeVons Jewelers - Reno",
"DeVons Jewelers - Stockton",
"DeVries Jewelers",
"Diamond Ring Co.",
"Diamonds & Designs",
"Diamonds of London",
"Di'Amore Fine Jewelers",
"Dorman's Jewelry Inc.",
"Douglas Jewelers",
"Droste's Jewelry Shoppes",
"Dunbar Jewelers",
"E.D. Marshall Jewelers",
"E.G. Landis Jewelers",
"Edward Arthur Jewelers",
"Elegant Jewelers",
"Elegant Watches",
"Eli Adams Jewelers",
"Elizalde Jewelry",
"Ellis Jewelers",
"Entonces Watch & Jewelry Repair",
"Espling Jewelers",
"Exquisite Timepieces",
"Fakier",
"Fashion Time",
"Feldmar Watch Company",
"Fiscus Jewelers",
"Fords Jewelers",
"Friedman's Jewelers",
"Fuller's Jewelry",
"Gabriel Jewelers",
"Garrick Jewelers",
"GemTime Watch & Jewelry Boutique",
"Golden Time Jewelers",
"Goldstein Swank and Gordon",
"Goodman's Jewelers",
"Grant Pacific Imports",
"Gray Jewelers",
"Gunderson's Jewelers - Fargo",
"Gunderson's Jewelers - Omaha",
"Gunderson's Jewelers - Sioux City",
"Gunderson's Jewelers - Sioux Falls",
"Guven's Fine Jewelry",
"Hannoush Jewelers - Danbury",
"Hannoush Jewelers - Farmington",
"Hannoush Jewelers - Fort Myers",
"Hannoush Jewelers - North Dartmouth",
"Hannoush Jewelers - West Warwick",
"Helmut the Jeweler",
"Herbert's Jewelers",
"Herndon Clock & Watch Co.",
"Herteen & Stocker Jewelers",
"Hoppe Jewelers",
"Huntington Fine Jewelers",
"Islamorada Jewelers",
"It's About Time - Atlanta",
"It's About Time - Kennesaw",
"IW Marks",
"J Brooks Jewelers",
"J Keith's Jewelry",
"J.H. Faske Jewelers",
"James & Williams Jewelers",
"Janvier Jewelers",
"JB Hudson Jewelers",
"Jewel Shop",
"Jewelry Pavilion",
"Joey The Jeweler",
"Johnson's Jewelers",
"Joseph Edwards",
"Joseph Gann Jewelers",
"Josephs Jewelers",
"Just in Time",
"Kardesh Jewelers",
"Kelley Jewelers",
"Kevin Edward Jewelers",
"King Jewelers",
"King's Jewelry",
"Klutts Jewelers & Designers",
"Latin Jewelers",
"Lennon's W.B. Wilcox Jewelers",
"Lewis Jewelers",
"Little Treasury Jewelers",
"Little Watch Shop",
"Loch Jewelers",
"Long Jewelers",
"Lucido Fine Jewelry - Birmingham",
"Lucido Fine Jewelry - Rochester",
"Lucido Fine Jewelry - Sterling Heights",
"M & M Jewelry",
"M.J. Miller & Co.",
"M.R.T. Jewelers",
"M.S. Brown Jewelers",
"Maharaja's Fine Jewelry and Gift",
"Maloof",
"Malsons Jewelers",
"Manfredi Jewels",
"Marinaccio Jewelers",
"Marquise Jewelers",
"Martin Jewelers",
"Matheu's Fine Watches & Jewelry",
"McAuley Fine Jewelry",
"McGee & Company Fine Jewelers",
"Meierotto Jewelers",
"Michael Szwed Jewelers",
"Miller Clock Service",
"Miska Jewelers",
"Mitchum Jewelers",
"Montalvo Jewelers",
"Moody's Jewelry",
"Morgan Jewelers",
"Mountz Jewelers",
"Moyer Fine Jewelers",
"Murad & Co.",
"My Watch",
"Nasr Bros Jewelers - Denton",
"Nasr Bros Jewelers - Fairview",
"Novak Jewelers",
"Old Northeast Jewelers - St. Petersburg",
"Old Northeast Jewelers - Tampa",
"One More Time",
"Orlando Watch Company",
"Park Place Jewelers",
"Paul Medawar Fine Jewelry",
"Paul's Watch Repair",
"Princessa Jewelry",
"R.C. Wahl Jewelers",
"R.E. Saxon Jeweler",
"Ralph Jewelry",
"Richter & Phillips Jewelers",
"Right Time Watches - Denver",
"Right Time Watches - Highlands Ranch",
"Rogers Jewelry Co.",
"Royal Jewelers",
"Royale Jewelers",
"Safa Jewelers",
"Sarasota Watch Company",
"Schnack's Fine Jewelry",
"Security Jewelers",
"Seven Oaks Fine Jewelers",
"Sharfmans Jewelers",
"Shaw's Jewelry",
"Skaneateles Jewelry, Inc.",
"Skeie's Jewelers",
"Smyth Jewelers",
"Spicer Greene Jewelers",
"Stadheim Jewelers",
"Stratton Jewelers",
"Sullivan's S&S Jewelers",
"Sydel & Sydel Jewelry",
"The Diamond Room",
"The Gem Collection",
"The Watch Connection",
"The Watch Works",
"Tick Tock Jewelers",
"Tick Tock Shop",
"Tick Tock Watches",
"Time Square",
"Timekeeper",
"Timeless Luxury Watches",
"Timescape USA",
"Topper Fine Jewelers",
"Trifecta Watches",
"Tripp & Company Jewelers",
"Underwood Jewelers - Ponte Vedra Beach",
"Underwood Jewelers - San Marco Jacksonville",
"Underwood Jewelers - St. John Jacksonville",
"Unicorn Jewelry & Watch Boutique",
"Valencia Time Center",
"Vinhas Jewelers",
"Watch City",
"Watch Repair",
"Watch Stop",
"Watch Works",
"Wayzata Jewelers",
"Will Jewelers",
"William S. Nacol Jewelry Co.",
"Windsor Jewelers - Charlotte",
"Windsor Jewelers - Winston Salem",
"AZ Watch & Jewelry Service",
"Black Sea Jewelers",
"C.F. Reuschlein Inc.",
"Cirelli's Fine Jewelry",
"David’s Fine Jewelers",
"Dimo Fine Jewelry",
"Ediger's Diamonds",
"Freehold Jewelers",
"Gallo Jewelers",
"Hak Heng Sheng",
"J & N Jewelry & Watch Repair",
"Jewel Time",
"Keeping Time Glendale",
"Kimberly Jewelry",
"L & K Jewelers",
"Long Jewelers II",
"Long Jewelers III",
"Malson's Jewelers",
"Marquis Jewelers",
"Mcguire's Jewelers",
"Michael's Jewelers",
"Mimo's Jewelry & Watches",
"Mr. Time Watch Repair",
"Olinger Diamond Center",
"Omega Millenium Inc.",
"Papandrew Jewelers Inc.",
"Paradise Jewelry & Watches",
"Personal Touch Jewelry",
"Piper Diamond Co",
"Precious Time",
"Paradise Jewelers",
"Ruby Jewelers",
"ReinigeR Jewelers",
"RM Jewelers",
"Rohr Jewelry",
"Sayegh Jewelers",
"Cowardin Jewelers",
"The Clock Doctor",
"The Jewel Box",
"Time Center",
"Time Center II",
"Time Spot",
"Time Zone",
"Timeland",
"TNT Jewelers",
"Ulman's",
"Vana Watch & Jewelry",
"W. Bauman",
"Watch & Clock Junction",
"Watches Unlimited",
"ReinigeR Jewelers"
];
/////////////////////////////////////////////////////////////////////////////////////////////////////
function SearchRetailer(_quer){
  var _res=[];
  for(var _i=0;_i<_retailers_list.length;_i++){
    if(_retailers_list[_i].toLowerCase().indexOf(_quer.toString().trim().toLowerCase())>-1){
      _res.push({id:_i, title:_retailers_list[_i]});
      if(_res.length>=5) break;
    }
  }
  return _res;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////

function paralaxOnep(pelem){
	var elem = pelem;
	var wheight=$(window).height();
	var scrolling = $(window).scrollTop();
	 elem.each(function(){
        var $this = $(this);
		var offset = $this.offset().top;
		var height = $this.height();
		var transform = 0;
		if(scrolling+wheight>=offset) {
			transform=Math.round(((wheight+height)-((offset+height)-scrolling))/((wheight+height)/100));
			if(scrolling>=(offset+height)){
				transform=100;
			}
		}
		$this.css({'background-position': 'center ' + transform + '%'});
	});	
}

///////////////////////////////////////////////////////////////////////////////////////
var _all_products_for_collection=[];
var _can_load_n_p=true;
function LoadSeiko5SubCollections(_page, _this){
  bdgs_getreq("/collections/seiko5sports?view=json&page="+_page, function(_data){
    if(_can_load_n_p){
    	if(_data.results.length>0)	_all_products_for_collection=_all_products_for_collection.concat(_data.results);
        if(_data.results.length==50) {
          _page++;
          LoadSeiko5SubCollections(_page, _this);
        } else {
          _can_load_n_p=false;        
        }
    }
 
    
    if(!_can_load_n_p){
      if(!_this.hasClass('itms_loaded')) _this.addClass('itms_loaded');
      
      var _tag=_this.attr('data-tag');
      var _id=_this.attr('data-id');
      var lugwidth = _this.attr('data-lugwidth');
      var casediameter = _this.attr('data-casediameter');
      console.log('lugwidth--', lugwidth);
      console.log('casediameter--', casediameter);
      
      //console.log(_id);
      _all_products_for_collection.map(function(_i){
        if(_i.tags){
           if(_i.tags.indexOf(_tag)>-1){
console.log('ii', _i);
             
             $('#'+_id).append(      
               '<div class="product_block  p_show '+(_i.iswomanclass ? 'womenwatchitem' : '')+' loaded '+(_i.available ? 'oth_is_av' : '')+'" tabindex="0"  data-sku="'+_i.title+'">'+ 
      			(_i.available && _i.customer ? '<div data-handle="'+_i.handle+'" class="wishlist" role="button" tabindex="0"></div>' : '')+
     		   '<a href="'+_i.url+'" class="product_link_in_list" aria-label="Product '+_i.title+' '+(_i.compare_at_price ? ' Price '+_i.compare_at_price+' Sale price '+_i.price+' ' :' Price '+ _i.price+' ' )+ _i.tags.join(', ')+'">'+
        		'<div class="product_image_block shadow_load" style="background-size: 60% 80%;"><img class="product_image_block_img loaded" data-src="'+_i.image+'" src="'+_i.image+'" alt="'+_i.title+', Watch, watches" /></div>'+
        		'<span class="product_name_price">'+
         		   '<h2 class="product_name">'+_i.title+'</h2>'+
         		 	'<span class="product_price" aria-label="Original price" title="Original price"><span class="hidden_text">Original price</span>'+_i.show_price+'</span>'+
         				 '<del class="discount" aria-label="Sale price" title="Sale price"><span class="hidden_text">Sale price</span>'+(_i.compare_at_price ? _i.show_compare_at_price :"" )+ '</del>'+
          				 '<div data-bv-show="inline_rating" data-bv-productId="'+_i.id+'" data-bv-redirect-url="'+_i.url+'"></div>'+
        			'</span></a>'+
    		 		(_i.available ? '<a href="/cart" class="standard_button white productinfo_add_to_cart" data-title="'+_i.title+'" aria-label="ADD TO CART '+_i.title+'" data-sku="'+_i.title+'" data-id="'+_i.variants[0].id+'">ADD TO CART</a>' : '<span class="soldout" tabindex="0">'+(_comming_soon_list.indexOf(_i.title)>-1 ? 'COMING SOON' : 'SOLD-OUT')+'</span>')+'</div>'  
 			);
           } 
        }
      });  
      
      Move_OutofStoke_to_bottom_sub($('#'+_id));
      
      
      _this.parents('.collections_block5').find('.collection5_items').stop().animate({"height": _this.parents('.collections_block5').find('.collection5_items').find('.collections_section').height(),"opacity":"1"}, 400);
    }
  });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function bdgs_getreq(_url,_cb){
  var xhr = new XMLHttpRequest();
  xhr.open('GET', _url, true);
  xhr.send();
  xhr.onreadystatechange = function() { 
    if (xhr.readyState != 4) return;
    if (xhr.status == 200) {
      var _data=JSON.parse(xhr.responseText);
      return _cb(_data);
    }
  }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function Move_OutofStoke_to_bottom_sub(_rootcoll){
 _rootcoll.find('.product_block').each(function(){
      if(!$(this).hasClass('oth_is_av')){ 
        if(_comming_soon_list.indexOf($(this).attr('data-sku'))==-1)  _rootcoll.append(this);
   	  }
  });
}

///////////////////////////////////////
function initTabs() {
	// Show the first tab and hide the rest
$('#tabset li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabset li').click(function(){
  $('#tabset li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
}
//////////////////////////////
function loadNEWProducts(){
  	
	var _url= window.location.href.split('#')[0];
    $.ajax({	
        url: _url+(_url.indexOf('?')>0 ? '&' : '/?')+'page='+_ajaxloadingpageid,
        type: 'get',
      	dataType:'html', 
        success: function(response){
          var result = $(response).find('.product_block_margin');
		  var _prds=$(result).find('.product_item_for_filter');
          if(_prds.length>0){
            
				_prds.each(function(){      
					$('.product_block_margin').append($(this));
				});
            	
				
				if(_prds.length==50){
				  _ajaxloadingpageid++;
				  loadAllProducts();
				} else {
                   Move_OutofStoke_to_bottom();
				   MarkWishlist();
				   StartFilter();
				}
          } else {
           	   Move_OutofStoke_to_bottom();
           	   MarkWishlist();
               StartFilter();
          }
          
        }
      
       
      	
      }); 

  
}


